export const miyuki = [
    {
      "a": 0,
      "b": 3,
      "c": [
        205,
        197,
        192
      ],
      "id": "8-1",
      "t": "Silver, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        210,
        205,
        200
      ],
      "id": "8-1F",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        192,
        146,
        81
      ],
      "id": "8-2",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        172,
        132,
        66
      ],
      "id": "8-3",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        187,
        147,
        84
      ],
      "id": "8-3F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        186,
        122,
        40
      ],
      "id": "8-4",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        178,
        121,
        51
      ],
      "id": "8-4F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        95,
        60,
        39
      ],
      "id": "8-5",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        94,
        58,
        45
      ],
      "id": "8-5F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        185,
        155,
        14
      ],
      "id": "8-6",
      "t": "Yellow, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        186,
        152,
        36
      ],
      "id": "8-6F",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        189,
        97,
        29
      ],
      "id": "8-8",
      "t": "Orange, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        216,
        105,
        21
      ],
      "id": "8-8F",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        161,
        31,
        40
      ],
      "id": "8-10",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        154,
        34,
        41
      ],
      "id": "8-10F",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        119,
        39,
        48
      ],
      "id": "8-11",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        118,
        55,
        65
      ],
      "id": "8-11R",
      "t": "Red, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        110,
        83,
        86
      ],
      "id": "8-12",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        122,
        91,
        96
      ],
      "id": "8-12F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        76,
        61,
        63
      ],
      "id": "8-13",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        69,
        56,
        58
      ],
      "id": "8-13F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        162,
        161,
        65
      ],
      "id": "8-14",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        142,
        150,
        45
      ],
      "id": "8-14F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        65,
        101,
        63
      ],
      "id": "8-15",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        55,
        83,
        63
      ],
      "id": "8-16",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        38,
        104,
        61
      ],
      "id": "8-16F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        32,
        92,
        79
      ],
      "id": "8-17",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        28,
        96,
        81
      ],
      "id": "8-17F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        62,
        141,
        161
      ],
      "id": "8-18",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        52,
        149,
        190
      ],
      "id": "8-18F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        46,
        84,
        155
      ],
      "id": "8-19",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        45,
        78,
        153
      ],
      "id": "8-19F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        63,
        47,
        105
      ],
      "id": "8-20",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        58,
        47,
        112
      ],
      "id": "8-20F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        85,
        84,
        80
      ],
      "id": "8-21",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        90,
        86,
        76
      ],
      "id": "8-21F",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        200,
        160,
        146
      ],
      "id": "8-23F",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        67,
        54,
        74
      ],
      "id": "8-24",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        84,
        71,
        83
      ],
      "id": "8-24F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        42,
        92,
        126
      ],
      "id": "8-25",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        34,
        77,
        120
      ],
      "id": "8-25F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        73,
        81,
        50
      ],
      "id": "8-26",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        56,
        68,
        44
      ],
      "id": "8-26F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        32,
        62,
        42
      ],
      "id": "8-27",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        49,
        63,
        56
      ],
      "id": "8-27F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        74,
        113,
        170
      ],
      "id": "8-28",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        22,
        81,
        83
      ],
      "id": "8-30",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        199,
        197,
        208
      ],
      "id": "8-131",
      "t": "Crystal, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        236,
        235,
        245
      ],
      "id": "8-131F",
      "t": "Crystal, White, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        242,
        243,
        251
      ],
      "id": "8-131FR",
      "t": "Crystal, White, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        197,
        138,
        61
      ],
      "id": "8-132",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        203,
        145,
        65
      ],
      "id": "8-132F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        208,
        157,
        104
      ],
      "id": "8-132FR",
      "t": "Brown, Gold, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        108,
        50,
        28
      ],
      "id": "8-133",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        116,
        57,
        40
      ],
      "id": "8-133F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        114,
        67,
        77
      ],
      "id": "8-133FR",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        74,
        40,
        31
      ],
      "id": "8-134",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        74,
        52,
        48
      ],
      "id": "8-134F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        112,
        83,
        85
      ],
      "id": "8-134FR",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        41,
        34,
        30
      ],
      "id": "8-135",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        52,
        45,
        41
      ],
      "id": "8-135F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        86,
        90,
        107
      ],
      "id": "8-135FR",
      "t": "Brown, Iridescent, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        70,
        50,
        41
      ],
      "id": "8-135S",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        215,
        184,
        2
      ],
      "id": "8-136",
      "t": "Yellow, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        222,
        183,
        5
      ],
      "id": "8-136F",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        225,
        187,
        78
      ],
      "id": "8-136FR",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        225,
        84,
        9
      ],
      "id": "8-138",
      "t": "Orange, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        242,
        104,
        16
      ],
      "id": "8-138F",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        248,
        126,
        79
      ],
      "id": "8-138FR",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        144,
        11,
        23
      ],
      "id": "8-141",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        134,
        28,
        48
      ],
      "id": "8-141F",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        156,
        63,
        102
      ],
      "id": "8-141FR",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        113,
        80,
        91
      ],
      "id": "8-142",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        114,
        78,
        91
      ],
      "id": "8-142F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        126,
        99,
        117
      ],
      "id": "8-142FR",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        142,
        160,
        40
      ],
      "id": "8-143",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        146,
        167,
        39
      ],
      "id": "8-143F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        169,
        183,
        101
      ],
      "id": "8-143FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        55,
        118,
        37
      ],
      "id": "8-144",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        10,
        77,
        64
      ],
      "id": "8-147",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        22,
        73,
        62
      ],
      "id": "8-147F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        73,
        104,
        113
      ],
      "id": "8-147FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        25,
        144,
        204
      ],
      "id": "8-148",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        7,
        152,
        225
      ],
      "id": "8-148F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        74,
        166,
        222
      ],
      "id": "8-148FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        16,
        56,
        101
      ],
      "id": "8-149",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        21,
        68,
        118
      ],
      "id": "8-149F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        71,
        96,
        144
      ],
      "id": "8-149FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        35,
        48,
        162
      ],
      "id": "8-150",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        44,
        57,
        170
      ],
      "id": "8-150F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        88,
        112,
        192
      ],
      "id": "8-150FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        37,
        3,
        107
      ],
      "id": "8-151",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        55,
        33,
        107
      ],
      "id": "8-151F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        84,
        80,
        145
      ],
      "id": "8-151FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        61,
        65,
        67
      ],
      "id": "8-152",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        67,
        68,
        71
      ],
      "id": "8-152F",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        96,
        104,
        120
      ],
      "id": "8-152FR",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        57,
        38,
        44
      ],
      "id": "8-153",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        208,
        151,
        141
      ],
      "id": "8-155",
      "t": "Pink, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        217,
        165,
        152
      ],
      "id": "8-155F",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        223,
        176,
        172
      ],
      "id": "8-155FR",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        20,
        37,
        25
      ],
      "id": "8-156",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        45,
        53,
        48
      ],
      "id": "8-156F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        65,
        53,
        73
      ],
      "id": "8-157",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        48,
        60,
        36
      ],
      "id": "8-158",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        122,
        142,
        200
      ],
      "id": "8-159L",
      "t": "Blue, Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        37,
        109,
        87
      ],
      "id": "8-179",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        23,
        135,
        98
      ],
      "id": "8-179L",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        156,
        110,
        95
      ],
      "id": "8-187",
      "t": "Brown, Opaque",
      "dt": "Plating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        119,
        99,
        74
      ],
      "id": "8-188",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        138,
        128,
        124
      ],
      "id": "8-190",
      "t": "Silver, Opaque",
      "dt": "Plating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        184,
        146,
        83
      ],
      "id": "8-191",
      "t": "Gold, Opaque",
      "dt": "Plating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        200,
        150,
        98
      ],
      "id": "8-191F",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        168,
        141,
        102
      ],
      "id": "8-193",
      "t": "Gold, Opaque",
      "dt": "Plating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        139,
        134,
        131
      ],
      "id": "8-194",
      "t": "Silver, Opaque",
      "dt": "Plating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        161,
        155,
        155
      ],
      "id": "8-194F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        192,
        161,
        129
      ],
      "id": "8-195",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        202,
        173,
        151
      ],
      "id": "8-196",
      "t": "Gold, Alabaster",
      "dt": "Goldline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        139,
        118,
        113
      ],
      "id": "8-197",
      "t": "Pink, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        168,
        149,
        161
      ],
      "id": "8-198",
      "t": "Pink, Alabaster",
      "dt": "Copperline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        166,
        124,
        89
      ],
      "id": "8-199",
      "t": "Gold, Iridescent, Opaque",
      "dt": "Plating, Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        232,
        175,
        100
      ],
      "id": "8-202",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        231,
        115,
        124
      ],
      "id": "8-204",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        219,
        196,
        215
      ],
      "id": "8-207",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        188,
        92,
        116
      ],
      "id": "8-208",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        188,
        63,
        143
      ],
      "id": "8-209",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        203,
        176,
        173
      ],
      "id": "8-215",
      "t": "Beige, Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        91,
        105,
        99
      ],
      "id": "8-217",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        116,
        161,
        195
      ],
      "id": "8-221",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        163,
        167,
        213
      ],
      "id": "8-222",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        91,
        80,
        100
      ],
      "id": "8-223",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        141,
        105,
        106
      ],
      "id": "8-224",
      "t": "Beige, Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        191,
        85,
        95
      ],
      "id": "8-226",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        109,
        175,
        96
      ],
      "id": "8-228",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        181,
        139,
        108
      ],
      "id": "8-234",
      "t": "Brown, Gold, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        151,
        152,
        161
      ],
      "id": "8-242",
      "t": "Crystal, Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        173,
        186,
        204
      ],
      "id": "8-250",
      "t": "Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        205,
        157,
        104
      ],
      "id": "8-251",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        206,
        170,
        52
      ],
      "id": "8-252",
      "t": "Yellow, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        166,
        81,
        84
      ],
      "id": "8-254D",
      "t": "Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        139,
        109,
        116
      ],
      "id": "8-256D",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        85,
        76,
        80
      ],
      "id": "8-257",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        122,
        148,
        149
      ],
      "id": "8-263",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        149,
        102,
        144
      ],
      "id": "8-264",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        216,
        211,
        224
      ],
      "id": "8-265",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        132,
        183,
        215
      ],
      "id": "8-269",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        174,
        213,
        205
      ],
      "id": "8-271",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        244,
        210,
        222
      ],
      "id": "8-272",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        228,
        203,
        133
      ],
      "id": "8-273",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        104,
        111,
        144
      ],
      "id": "8-274",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        170,
        131,
        128
      ],
      "id": "8-275",
      "t": "Brown, Orange, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        199,
        111,
        129
      ],
      "id": "8-276",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        112,
        130,
        137
      ],
      "id": "8-277",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        103,
        196,
        219
      ],
      "id": "8-278",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        94,
        129,
        150
      ],
      "id": "8-279",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        97,
        106,
        122
      ],
      "id": "8-283",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        227,
        225,
        225
      ],
      "id": "8-284",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        130,
        138,
        153
      ],
      "id": "8-286",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        79,
        123,
        192
      ],
      "id": "8-299",
      "t": "Blue, Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        107,
        74,
        74
      ],
      "id": "8-301",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        96,
        44,
        41
      ],
      "id": "8-304",
      "t": "Purple, Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        54,
        67,
        44
      ],
      "id": "8-306",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        133,
        93,
        64
      ],
      "id": "8-311",
      "t": "Brown, Gold, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        106,
        70,
        94
      ],
      "id": "8-312",
      "t": "Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        92,
        59,
        67
      ],
      "id": "8-313",
      "t": "Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        62,
        105,
        121
      ],
      "id": "8-339",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        98,
        106,
        141
      ],
      "id": "8-340",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        81,
        116,
        69
      ],
      "id": "8-341",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        115,
        96,
        93
      ],
      "id": "8-342",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        56,
        80,
        75
      ],
      "id": "8-344",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        81,
        65,
        130
      ],
      "id": "8-352",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        62,
        87,
        184
      ],
      "id": "8-353",
      "t": "Blue, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        55,
        103,
        91
      ],
      "id": "8-354",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        186,
        119,
        125
      ],
      "id": "8-355",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        92,
        72,
        114
      ],
      "id": "8-356",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        101,
        80,
        73
      ],
      "id": "8-357",
      "t": "Iridescent, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        217,
        153,
        148
      ],
      "id": "8-366",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        81,
        38,
        49
      ],
      "id": "8-367",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        27,
        27,
        29
      ],
      "id": "8-401",
      "t": "Black, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        48,
        48,
        48
      ],
      "id": "8-401F",
      "t": "Black, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        96,
        91,
        107
      ],
      "id": "8-401FR",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        52,
        51,
        52
      ],
      "id": "8-401SF",
      "t": "Black, Opaque",
      "dt": "Semi-Frost"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        253,
        253,
        253
      ],
      "id": "8-402",
      "t": "White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        238,
        237,
        245
      ],
      "id": "8-402F",
      "t": "White, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        247,
        221,
        2
      ],
      "id": "8-404",
      "t": "Yellow, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        249,
        88,
        16
      ],
      "id": "8-406",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        223,
        56,
        40
      ],
      "id": "8-407",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        234,
        94,
        96
      ],
      "id": "8-407FR",
      "t": "Pink, Red, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        188,
        29,
        39
      ],
      "id": "8-408",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        84,
        48,
        45
      ],
      "id": "8-409",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        141,
        113,
        127
      ],
      "id": "8-410",
      "t": "Purple, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        151,
        126,
        147
      ],
      "id": "8-410FR",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        65,
        119,
        59
      ],
      "id": "8-411",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        98,
        140,
        116
      ],
      "id": "8-411FR",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        51,
        147,
        151
      ],
      "id": "8-412",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        71,
        166,
        212
      ],
      "id": "8-413",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        46,
        26,
        126
      ],
      "id": "8-414",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        80,
        84,
        151
      ],
      "id": "8-414FR",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        158,
        178,
        84
      ],
      "id": "8-416",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        165,
        185,
        117
      ],
      "id": "8-416FR",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        112,
        47,
        49
      ],
      "id": "8-419",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        162,
        194,
        223
      ],
      "id": "8-430",
      "t": "Blue, Opaque",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        67,
        72,
        83
      ],
      "id": "8-451",
      "t": "Gray, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        37,
        43,
        55
      ],
      "id": "8-452",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        54,
        55,
        56
      ],
      "id": "8-453",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        66,
        60,
        76
      ],
      "id": "8-454",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        47,
        58,
        84
      ],
      "id": "8-455",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        61,
        72,
        82
      ],
      "id": "8-456",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        127,
        103,
        79
      ],
      "id": "8-457",
      "t": "Gold, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        111,
        85,
        60
      ],
      "id": "8-457L",
      "t": "Gold, Transparent",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        57,
        47,
        43
      ],
      "id": "8-458",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        70,
        70,
        52
      ],
      "id": "8-459",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        57,
        39,
        41
      ],
      "id": "8-460",
      "t": "Purple, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        81,
        67,
        58
      ],
      "id": "8-461",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        127,
        91,
        56
      ],
      "id": "8-462",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        148,
        118,
        132
      ],
      "id": "8-478",
      "t": "Purple, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        226,
        191,
        139
      ],
      "id": "8-516",
      "t": "Orange, Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        252,
        186,
        206
      ],
      "id": "8-517",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        125,
        211,
        155
      ],
      "id": "8-520",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        153,
        197,
        210
      ],
      "id": "8-522",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        132,
        163,
        210
      ],
      "id": "8-524",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        128,
        131,
        139
      ],
      "id": "8-526",
      "t": "Gray, Alabaster",
      "dt": "Glazed Luster"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        236,
        220,
        183
      ],
      "id": "8-527",
      "t": "Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        230,
        228,
        234
      ],
      "id": "8-528",
      "t": "White, Alabaster",
      "dt": "Luster"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        88,
        167,
        169
      ],
      "id": "8-536",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        126,
        128,
        193
      ],
      "id": "8-538",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        250,
        154,
        120
      ],
      "id": "8-539",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        108,
        132,
        160
      ],
      "id": "8-545",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        206,
        205,
        210
      ],
      "id": "8-551",
      "t": "Silver, Alabaster",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        212,
        159,
        116
      ],
      "id": "8-552",
      "t": "Gold, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        173,
        103,
        92
      ],
      "id": "8-553",
      "t": "Orange, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        212,
        115,
        152
      ],
      "id": "8-556",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        87,
        172,
        169
      ],
      "id": "8-571",
      "t": "Green, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        154,
        130,
        194
      ],
      "id": "8-574",
      "t": "Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        135,
        142,
        158
      ],
      "id": "8-576",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        228,
        221,
        216
      ],
      "id": "8-591",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        231,
        215,
        200
      ],
      "id": "8-592",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        215,
        171,
        136
      ],
      "id": "8-593",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster, Galvanized"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        205,
        200,
        190
      ],
      "id": "8-600",
      "t": "White, Opaque",
      "dt": "Glazed Luster, Galvanized"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        126,
        92,
        86
      ],
      "id": "8-641",
      "t": "Brown, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        200,
        123,
        125
      ],
      "id": "8-642",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        164,
        97,
        116
      ],
      "id": "8-645",
      "t": "Red, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        28,
        158,
        199
      ],
      "id": "8-647",
      "t": "Blue, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        105,
        112,
        180
      ],
      "id": "8-649",
      "t": "Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        92,
        90,
        90
      ],
      "id": "8-650",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        220,
        213,
        210
      ],
      "id": "8-961",
      "t": "Silver, Opaque",
      "dt": "Plating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        210,
        203,
        203
      ],
      "id": "8-961F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        194,
        186,
        194
      ],
      "id": "8-1001",
      "t": "Silver, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        176,
        137,
        117
      ],
      "id": "8-1003",
      "t": "Gold, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        174,
        122,
        94
      ],
      "id": "8-1004",
      "t": "Gold, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        102,
        90,
        107
      ],
      "id": "8-1005",
      "t": "Red, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        174,
        149,
        93
      ],
      "id": "8-1006",
      "t": "Yellow, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        176,
        92,
        66
      ],
      "id": "8-1008",
      "t": "Orange, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        150,
        60,
        80
      ],
      "id": "8-1010",
      "t": "Red, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        114,
        88,
        109
      ],
      "id": "8-1012",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        78,
        69,
        81
      ],
      "id": "8-1013",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        143,
        152,
        81
      ],
      "id": "8-1014",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        60,
        89,
        79
      ],
      "id": "8-1016",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        49,
        85,
        92
      ],
      "id": "8-1017",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        82,
        152,
        191
      ],
      "id": "8-1018",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        54,
        96,
        161
      ],
      "id": "8-1019",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        69,
        68,
        125
      ],
      "id": "8-1020",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        203,
        178,
        176
      ],
      "id": "8-1023",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        98,
        86,
        107
      ],
      "id": "8-1024",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        48,
        82,
        125
      ],
      "id": "8-1025",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        84,
        93,
        88
      ],
      "id": "8-1026",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        188,
        180,
        165
      ],
      "id": "8-1051",
      "t": "Silver, Transparent",
      "dt": "Galvanized, Galvanized"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        181,
        136,
        94
      ],
      "id": "8-1052",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed, Outside Dyed, Galvanized"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        183,
        134,
        96
      ],
      "id": "8-1053",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed, Outside Dyed, Galvanized"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        193,
        218,
        141
      ],
      "id": "8-1119",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        142,
        212,
        137
      ],
      "id": "8-1120",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        248,
        189,
        103
      ],
      "id": "8-1121",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        252,
        131,
        119
      ],
      "id": "8-1122",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        80,
        87,
        104
      ],
      "id": "8-1254",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        107,
        86,
        67
      ],
      "id": "8-1255",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        101,
        111,
        97
      ],
      "id": "8-1256",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        51,
        76,
        92
      ],
      "id": "8-1425",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        48,
        25,
        90
      ],
      "id": "8-1427",
      "t": "Blue, Purple, Transparent",
      "dt": "Outside-Dyed, Silverline, Outside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        75,
        92,
        87
      ],
      "id": "8-1456",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Silverline, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        144,
        115,
        80
      ],
      "id": "8-1461",
      "t": "Beige, Brown, Opaque",
      "dt": "Outside-Dyed, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        80,
        87,
        182
      ],
      "id": "8-1477",
      "t": "Blue, Purple, Opaque",
      "dt": "Luster, Outside-Dyed, Outside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        53,
        86,
        144
      ],
      "id": "8-1827",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        52,
        42,
        129
      ],
      "id": "8-1945",
      "t": "Blue, Opaque",
      "dt": "Luster"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        104,
        106,
        103
      ],
      "id": "8-2002",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        92,
        70,
        71
      ],
      "id": "8-2005",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        109,
        89,
        68
      ],
      "id": "8-2006",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        101,
        114,
        106
      ],
      "id": "8-2008",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        71,
        68,
        66
      ],
      "id": "8-2013",
      "t": "Brown, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        229,
        213,
        190
      ],
      "id": "8-2021",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        95,
        114,
        140
      ],
      "id": "8-2030",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        114,
        94,
        80
      ],
      "id": "8-2035",
      "t": "Iridescent, Transparent",
      "dt": "Frosted (Matte), Glazed Luster, Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        65,
        80,
        65
      ],
      "id": "8-2066",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        127,
        117,
        114
      ],
      "id": "8-2195",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 229, 207, 188 ],
      "id": "8-2370",
      "t": "Light Pearl",
      "dt": "Gem Stone Coating"
    },    {
      "a": 0,
      "b": 2,
      "c": [ 202, 177, 150 ],
      "id": "8-2371",
      "t": "Pearl",
      "dt": "Gem Stone Coating"
    },    {
      "a": 0,
      "b": 2,
      "c": [ 162, 142, 109 ],
      "id": "8-2372",
      "t": "Dark Pearl",
      "dt": "Gem Stone Coating"
    },    {
      "a": 0,
      "b": 2,
      "c": [ 167, 143, 149 ],
      "id": "8-2373",
      "t": "Thistle",
      "dt": "Gem Stone Coating"
    },    {
      "a": 0,
      "b": 2,
      "c": [ 143, 146, 114 ],
      "id": "8-2374",
      "t": "Lilac",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 140, 156, 135 ],
      "id": "8-2375",
      "t": "Sage",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 136, 158, 159 ],
      "id": "8-2376",
      "t": "Ocean",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 154, 150, 171 ],
      "id": "8-2377",
      "t": "Cyan",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 136, 148, 161 ],
      "id": "8-2378",
      "t": "Purple",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        38,
        32,
        34
      ],
      "id": "8-2402",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        6,
        75,
        67
      ],
      "id": "8-2405",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        6,
        87,
        78
      ],
      "id": "8-2405F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        56,
        93,
        99
      ],
      "id": "8-2405FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        16,
        55,
        54
      ],
      "id": "8-2406",
      "t": "Blue, Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        40,
        47,
        55
      ],
      "id": "8-2411",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        117,
        112,
        104
      ],
      "id": "8-2412",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        143,
        73,
        32
      ],
      "id": "8-2422",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        130,
        75,
        47
      ],
      "id": "8-2422F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        69,
        116,
        41
      ],
      "id": "8-2423",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        21,
        81,
        74
      ],
      "id": "8-2425",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        21,
        88,
        88
      ],
      "id": "8-2425F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        55,
        62,
        66
      ],
      "id": "8-2426",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        60,
        51,
        50
      ],
      "id": "8-2428",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        26,
        102,
        137
      ],
      "id": "8-2429",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        118,
        132,
        164
      ],
      "id": "8-2430",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        74,
        87,
        144
      ],
      "id": "8-2431",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        120,
        117,
        116
      ],
      "id": "8-2440",
      "t": "Blue, Gray, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        221,
        210,
        189
      ],
      "id": "8-2442",
      "t": "Crystal, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        158,
        161,
        174
      ],
      "id": "8-2443",
      "t": "Crystal, Iridescent, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        167,
        118,
        125
      ],
      "id": "8-2601",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        150,
        154,
        137
      ],
      "id": "8-2604",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        87,
        156,
        156
      ],
      "id": "8-2605",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        87,
        136,
        177
      ],
      "id": "8-2606",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        122,
        102,
        156
      ],
      "id": "8-2607",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        189,
        178,
        150
      ],
      "id": "8-4201",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        167,
        154,
        129
      ],
      "id": "8-4201F",
      "t": "Silver, White, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        182,
        134,
        62
      ],
      "id": "8-4202",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        207,
        157,
        90
      ],
      "id": "8-4202F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        178,
        121,
        48
      ],
      "id": "8-4203",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        185,
        111,
        42
      ],
      "id": "8-4203F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        152,
        114,
        77
      ],
      "id": "8-4204",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        167,
        130,
        101
      ],
      "id": "8-4204F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        189,
        173,
        73
      ],
      "id": "8-4205",
      "t": "Yellow, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        193,
        128,
        84
      ],
      "id": "8-4206",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        168,
        91,
        73
      ],
      "id": "8-4207",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        158,
        52,
        42
      ],
      "id": "8-4208",
      "t": "Red, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        190,
        85,
        82
      ],
      "id": "8-4208F",
      "t": "Red, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        167,
        110,
        113
      ],
      "id": "8-4209",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        151,
        69,
        107
      ],
      "id": "8-4210",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        194,
        109,
        140
      ],
      "id": "8-4210F",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        166,
        54,
        71
      ],
      "id": "8-4211",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        190,
        78,
        94
      ],
      "id": "8-4211F",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        128,
        64,
        57
      ],
      "id": "8-4212",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        133,
        81,
        79
      ],
      "id": "8-4212F",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        106,
        75,
        73
      ],
      "id": "8-4213",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        123,
        94,
        90
      ],
      "id": "8-4213F",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        106,
        160,
        107
      ],
      "id": "8-4214",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        128,
        179,
        135
      ],
      "id": "8-4214F",
      "t": "Green, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        100,
        116,
        94
      ],
      "id": "8-4215",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        118,
        142,
        139
      ],
      "id": "8-4216",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        57,
        127,
        136
      ],
      "id": "8-4217",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        69,
        123,
        129
      ],
      "id": "8-4217F",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        150,
        97,
        123
      ],
      "id": "8-4218",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        135,
        55,
        71
      ],
      "id": "8-4219",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        121,
        75,
        101
      ],
      "id": "8-4220",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        150,
        141,
        119
      ],
      "id": "8-4221",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        167,
        156,
        139
      ],
      "id": "8-4221F",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        121,
        104,
        87
      ],
      "id": "8-4222",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        188,
        135,
        91
      ],
      "id": "8-4231",
      "t": "Yellow, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        176,
        109,
        95
      ],
      "id": "8-4233",
      "t": "Orange, Pink, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        157,
        57,
        60
      ],
      "id": "8-4234",
      "t": "Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        180,
        75,
        146
      ],
      "id": "8-4238",
      "t": "Pink, Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        187,
        66,
        100
      ],
      "id": "8-4239",
      "t": "Pink, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        66,
        110,
        142
      ],
      "id": "8-4242",
      "t": "Blue, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        152,
        111,
        104
      ],
      "id": "8-4243",
      "t": "Beige, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        157,
        70,
        68
      ],
      "id": "8-4244",
      "t": "Orange, Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        113,
        64,
        69
      ],
      "id": "8-4245",
      "t": "Brown, Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        142,
        80,
        132
      ],
      "id": "8-4246",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        115,
        61,
        96
      ],
      "id": "8-4247",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        94,
        68,
        107
      ],
      "id": "8-4248",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        95,
        72,
        77
      ],
      "id": "8-4249",
      "t": "Brown, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        94,
        87,
        85
      ],
      "id": "8-4250",
      "t": "Brown, Gray, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        79,
        78,
        80
      ],
      "id": "8-4251",
      "t": "Brown, Gray, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 26, 26, 185 ],
      "id": "8-4281",
      "t": "Navy Blue",
      "dt": "Duracoat, Silverline Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 38, 38, 84 ],
      "id": "8-4282",
      "t": "Navy Blue",
      "dt": "Duracoat, Silverline Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        252,
        146,
        103
      ],
      "id": "8-4298",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        254,
        124,
        175
      ],
      "id": "8-4299",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        112,
        184,
        228
      ],
      "id": "8-4300",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        251,
        97,
        166
      ],
      "id": "8-4301",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        241,
        124,
        188
      ],
      "id": "8-4302",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        184,
        112,
        186
      ],
      "id": "8-4303",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        243,
        233,
        164
      ],
      "id": "8-4451",
      "t": "Yellow Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        228,
        185,
        95
      ],
      "id": "8-4452",
      "t": "Gold Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        247,
        167,
        39
      ],
      "id": "8-4453",
      "t": "Orange Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        249,
        144,
        52
      ],
      "id": "8-4454",
      "t": "Orange Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        149,
        121,
        99
      ],
      "id": "8-4455",
      "t": "Coffee Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        172,
        108,
        28
      ],
      "id": "8-4456",
      "t": "Tan Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        158,
        108,
        67
      ],
      "id": "8-4457",
      "t": "Rust Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        142,
        78,
        35
      ],
      "id": "8-4458",
      "t": "Chocolate Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        121,
        72,
        19
      ],
      "id": "8-4459",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        139,
        86,
        36
      ],
      "id": "8-4460",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        250,
        178,
        154
      ],
      "id": "8-4461",
      "t": "Rose Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        249,
        145,
        130
      ],
      "id": "8-4462",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        243,
        164,
        165
      ],
      "id": "8-4463",
      "t": "Rose Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        191,
        108,
        101
      ],
      "id": "8-4464",
      "t": "Salmon Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        218,
        118,
        127
      ],
      "id": "8-4465",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        242,
        164,
        183
      ],
      "id": "8-4466",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        249,
        128,
        156
      ],
      "id": "8-4467",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        157,
        75,
        103
      ],
      "id": "8-4468",
      "t": "Blackberry Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        119,
        30,
        32
      ],
      "id": "8-4469",
      "t": "Red Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        96,
        26,
        22
      ],
      "id": "8-4470",
      "t": "Maroon Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        141,
        202,
        66
      ],
      "id": "8-4471",
      "t": "Lime Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        103,
        199,
        183
      ],
      "id": "8-4472",
      "t": "Cyan Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        144,
        160,
        105
      ],
      "id": "8-4473",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        130,
        137,
        91
      ],
      "id": "8-4474",
      "t": "Olive Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        77,
        167,
        141
      ],
      "id": "8-4475",
      "t": "Teal Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        57,
        149,
        71
      ],
      "id": "8-4476",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        53,
        122,
        91
      ],
      "id": "8-4477",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        69,
        194,
        182
      ],
      "id": "8-4478",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        93,
        146,
        152
      ],
      "id": "8-4479",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        40,
        154,
        177
      ],
      "id": "8-4480",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        65,
        98,
        94
      ],
      "id": "8-4481",
      "t": "Teal Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        85,
        128,
        152
      ],
      "id": "8-4482",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        19,
        114,
        135
      ],
      "id": "8-4483",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        20,
        104,
        179
      ],
      "id": "8-4484",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        47,
        112,
        142
      ],
      "id": "8-4485",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        143,
        129,
        170
      ],
      "id": "8-4486",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        142,
        101,
        115
      ],
      "id": "8-4487",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        144,
        113,
        169
      ],
      "id": "8-4488",
      "t": "Purple Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        125,
        99,
        115
      ],
      "id": "8-4489",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        98,
        70,
        103
      ],
      "id": "8-4490",
      "t": "Violet Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        106,
        96,
        49
      ],
      "id": "8-4491",
      "t": "Olive Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        100,
        68,
        43
      ],
      "id": "8-4492",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 0,
      "b": 1,
      "c": [ 26, 26, 185 ],
      "id": "8-4493",
      "t": "Navy Blue",
      "dt": "Duracoat, Opaque Dyed"
    },
    {
      "a": 0,
      "b": 1,
      "c": [ 38, 38, 84 ],
      "id": "8-4494",
      "t": "Navy Blue",
      "dt": "Duracoat, Opaque Dyed"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        87,
        59,
        40
      ],
      "id": "8-4501",
      "t": "Brown, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        56,
        36,
        30
      ],
      "id": "8-4502",
      "t": "Blue, Brown, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        68,
        60,
        56
      ],
      "id": "8-4503",
      "t": "Blue, Brown, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        60,
        55,
        48
      ],
      "id": "8-4504",
      "t": "Black, Blue, Red, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        84,
        68,
        64
      ],
      "id": "8-4505",
      "t": "Brown, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        69,
        84,
        80
      ],
      "id": "8-4506",
      "t": "Green, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        41,
        40,
        41
      ],
      "id": "8-4511",
      "t": "Black, Gray, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        197,
        167,
        112
      ],
      "id": "8-4512",
      "t": "Beige, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        92,
        44,
        33
      ],
      "id": "8-4513",
      "t": "Red, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        116,
        130,
        114
      ],
      "id": "8-4514",
      "t": "Blue, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        159,
        135,
        72
      ],
      "id": "8-4515",
      "t": "Green, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        58,
        69,
        74
      ],
      "id": "8-4516",
      "t": "Blue, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        123,
        97,
        69
      ],
      "id": "8-4517",
      "t": "Brown, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        97,
        96,
        89
      ],
      "id": "8-4551",
      "t": "Orange, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 50, 53, 66 ],
      "id": "8-4555",
      "t": "AB",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 1,
      "c": [
        73,
        71,
        76
      ],
      "id": "8-4556",
      "t": "Blue, Purple, Transparent",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        120,
        117,
        126
      ],
      "id": "8-4557",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        175,
        174,
        183
      ],
      "id": "8-4558",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [ 45, 51, 54 ],
      "id": "8-4560",
      "t": "Black / Marea",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 1,
      "c": [ 73, 75, 78 ],
      "id": "8-4561",
      "t": "Valentinite Matte",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [
        72,
        69,
        69
      ],
      "id": "8-4571",
      "t": "Pink, Purple, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        77,
        83,
        88
      ],
      "id": "8-4572",
      "t": "Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [
        95,
        73,
        72
      ],
      "id": "8-4573",
      "t": "Gold, Red, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [ 80, 82, 88 ],
      "id": "8-4574",
      "t": "Vitrail Light (VL)",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [ 183, 183, 183 ],
      "id": "8-4575",
      "t": "Crystal Labrador Full",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [ 200, 200, 200 ],
      "id": "8-4587",
      "t": "Aluminium Silver",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [ 170, 154, 120 ],
      "id": "8-4588",
      "t": "Aztec Gold",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [ 223, 171, 144 ],
      "id": "8-4589",
      "t": "Vintage Copper",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 3,
      "c": [ 192, 131, 108 ],
      "id": "8-4590",
      "t": "B. Bronze",
      "dt": "Special Coating"
    },
    {
      "a": 0,
      "b": 2,
      "c": [ 150, 87, 84 ],
      "id": "8-4591",
      "t": "Lava Red",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        191,
        184,
        180
      ],
      "id": "11-1",
      "t": "Silver, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        208,
        199,
        189
      ],
      "id": "11-1F",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        172,
        133,
        74
      ],
      "id": "11-3",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        197,
        154,
        90
      ],
      "id": "11-3F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        173,
        114,
        37
      ],
      "id": "11-4",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        189,
        131,
        63
      ],
      "id": "11-4F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        95,
        44,
        16
      ],
      "id": "11-5",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        87,
        48,
        41
      ],
      "id": "11-5F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        199,
        170,
        14
      ],
      "id": "11-6",
      "t": "Yellow, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        200,
        171,
        16
      ],
      "id": "11-6F",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        201,
        88,
        23
      ],
      "id": "11-8",
      "t": "Orange, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        211,
        86,
        11
      ],
      "id": "11-8F",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        171,
        55,
        37
      ],
      "id": "11-10",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        156,
        30,
        40
      ],
      "id": "11-10F",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        143,
        8,
        10
      ],
      "id": "11-11",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        131,
        96,
        100
      ],
      "id": "11-12",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        129,
        98,
        101
      ],
      "id": "11-12F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        87,
        56,
        62
      ],
      "id": "11-13",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        89,
        60,
        66
      ],
      "id": "11-13F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        146,
        152,
        43
      ],
      "id": "11-14",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        151,
        154,
        46
      ],
      "id": "11-14F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        59,
        116,
        46
      ],
      "id": "11-15",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        47,
        108,
        56
      ],
      "id": "11-16",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        42,
        91,
        55
      ],
      "id": "11-16F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        23,
        83,
        65
      ],
      "id": "11-17",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        5,
        108,
        83
      ],
      "id": "11-17F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        81,
        150,
        173
      ],
      "id": "11-18",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        84,
        157,
        184
      ],
      "id": "11-18F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        37,
        93,
        162
      ],
      "id": "11-19",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        44,
        101,
        166
      ],
      "id": "11-19F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        43,
        35,
        98
      ],
      "id": "11-20",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        48,
        41,
        108
      ],
      "id": "11-20F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        71,
        71,
        66
      ],
      "id": "11-21",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        102,
        102,
        98
      ],
      "id": "11-21F",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        113,
        113,
        109
      ],
      "id": "11-21L",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        204,
        178,
        192
      ],
      "id": "11-22",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        191,
        149,
        131
      ],
      "id": "11-23",
      "t": "Pink, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        198,
        161,
        148
      ],
      "id": "11-23F",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        88,
        73,
        95
      ],
      "id": "11-24",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        83,
        69,
        73
      ],
      "id": "11-24F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        54,
        81,
        108
      ],
      "id": "11-25",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        7,
        82,
        127
      ],
      "id": "11-25F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        65,
        82,
        32
      ],
      "id": "11-26",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        60,
        79,
        33
      ],
      "id": "11-26F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        15,
        53,
        28
      ],
      "id": "11-27",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        36,
        54,
        40
      ],
      "id": "11-27F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        110,
        141,
        174
      ],
      "id": "11-28",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        55,
        34,
        21
      ],
      "id": "11-29",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        6,
        88,
        89
      ],
      "id": "11-30",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        219,
        217,
        226
      ],
      "id": "11-131",
      "t": "Crystal, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        226,
        226,
        238
      ],
      "id": "11-131F",
      "t": "Crystal, White, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        235,
        235,
        247
      ],
      "id": "11-131FR",
      "t": "Crystal, White, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        234,
        234,
        247
      ],
      "id": "11-131SFR",
      "t": "Crystal, White, Transparent",
      "dt": "Rainbow, Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        199,
        132,
        48
      ],
      "id": "11-132",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        215,
        154,
        77
      ],
      "id": "11-132F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        211,
        159,
        120
      ],
      "id": "11-132FR",
      "t": "Brown, Gold, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        131,
        58,
        18
      ],
      "id": "11-133",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        139,
        68,
        23
      ],
      "id": "11-133F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        155,
        102,
        97
      ],
      "id": "11-133FR",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        62,
        29,
        25
      ],
      "id": "11-134D",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        91,
        50,
        35
      ],
      "id": "11-134F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        103,
        84,
        103
      ],
      "id": "11-134FR",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        38,
        23,
        21
      ],
      "id": "11-135",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        52,
        40,
        36
      ],
      "id": "11-135F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        89,
        78,
        85
      ],
      "id": "11-135FR",
      "t": "Brown, Iridescent, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        218,
        178,
        5
      ],
      "id": "11-136",
      "t": "Yellow, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        229,
        187,
        4
      ],
      "id": "11-136F",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        231,
        200,
        84
      ],
      "id": "11-136FR",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        235,
        86,
        5
      ],
      "id": "11-138",
      "t": "Orange, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        240,
        82,
        7
      ],
      "id": "11-138F",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        244,
        125,
        93
      ],
      "id": "11-138FR",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        180,
        11,
        26
      ],
      "id": "11-140",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        161,
        8,
        23
      ],
      "id": "11-140SF",
      "t": "Red, Transparent",
      "dt": "Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        135,
        6,
        9
      ],
      "id": "11-141",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        155,
        14,
        35
      ],
      "id": "11-141F",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        155,
        62,
        86
      ],
      "id": "11-141FR",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        153,
        2,
        11
      ],
      "id": "11-141SF",
      "t": "Red, Transparent",
      "dt": "Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        105,
        70,
        83
      ],
      "id": "11-142",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        119,
        87,
        100
      ],
      "id": "11-142F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        139,
        125,
        148
      ],
      "id": "11-142FR",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        136,
        152,
        17
      ],
      "id": "11-143",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        147,
        164,
        37
      ],
      "id": "11-143F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        155,
        178,
        94
      ],
      "id": "11-143FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        59,
        122,
        29
      ],
      "id": "11-144",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        7,
        75,
        26
      ],
      "id": "11-146",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        14,
        85,
        40
      ],
      "id": "11-146F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        55,
        109,
        95
      ],
      "id": "11-146FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        9,
        70,
        50
      ],
      "id": "11-147",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        4,
        80,
        62
      ],
      "id": "11-147F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        61,
        119,
        122
      ],
      "id": "11-147FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        18,
        146,
        208
      ],
      "id": "11-148",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        16,
        154,
        224
      ],
      "id": "11-148F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        86,
        175,
        232
      ],
      "id": "11-148FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        11,
        55,
        103
      ],
      "id": "11-149",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        10,
        72,
        128
      ],
      "id": "11-149F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        67,
        106,
        154
      ],
      "id": "11-149FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        27,
        63,
        169
      ],
      "id": "11-150",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        41,
        71,
        177
      ],
      "id": "11-150F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        78,
        99,
        187
      ],
      "id": "11-150FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        42,
        85,
        181
      ],
      "id": "11-150SFR",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        26,
        9,
        110
      ],
      "id": "11-151",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        46,
        27,
        115
      ],
      "id": "11-151F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        71,
        73,
        151
      ],
      "id": "11-151FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        27,
        6,
        110
      ],
      "id": "11-151SF",
      "t": "Blue, Transparent",
      "dt": "Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        60,
        64,
        65
      ],
      "id": "11-152",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        85,
        88,
        92
      ],
      "id": "11-152F",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        103,
        102,
        122
      ],
      "id": "11-152FR",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        57,
        37,
        44
      ],
      "id": "11-153",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        222,
        173,
        167
      ],
      "id": "11-155",
      "t": "Pink, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        217,
        157,
        141
      ],
      "id": "11-155F",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        212,
        163,
        151
      ],
      "id": "11-155FR",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        17,
        40,
        28
      ],
      "id": "11-156",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        32,
        48,
        39
      ],
      "id": "11-156F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        22,
        44,
        31
      ],
      "id": "11-156SF",
      "t": "Green, Transparent",
      "dt": "Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        66,
        51,
        72
      ],
      "id": "11-157",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        41,
        57,
        25
      ],
      "id": "11-158",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        90,
        99,
        90
      ],
      "id": "11-158FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        126,
        145,
        213
      ],
      "id": "11-159L",
      "t": "Blue, Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        43,
        130,
        83
      ],
      "id": "11-179L",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        126,
        97,
        73
      ],
      "id": "11-188",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Nickel"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        119,
        110,
        105
      ],
      "id": "11-190",
      "t": "Silver, Opaque",
      "dt": "Plating, Nickel"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        126,
        114,
        112
      ],
      "id": "11-190F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Nickel"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        207,
        155,
        56
      ],
      "id": "11-191",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        216,
        171,
        114
      ],
      "id": "11-191F",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        164,
        134,
        94
      ],
      "id": "11-193",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        176,
        147,
        120
      ],
      "id": "11-193F",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        147,
        142,
        135
      ],
      "id": "11-194",
      "t": "Silver, Opaque",
      "dt": "Plating, Palladium"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        150,
        142,
        138
      ],
      "id": "11-194F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Palladium"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        192,
        148,
        103
      ],
      "id": "11-195",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        198,
        166,
        143
      ],
      "id": "11-196",
      "t": "Gold, Alabaster",
      "dt": "Goldline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        128,
        98,
        92
      ],
      "id": "11-197",
      "t": "Pink, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        153,
        140,
        145
      ],
      "id": "11-198",
      "t": "Pink, Alabaster",
      "dt": "Copperline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        175,
        126,
        64
      ],
      "id": "11-199",
      "t": "Gold, Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        238,
        175,
        121
      ],
      "id": "11-202",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        225,
        108,
        116
      ],
      "id": "11-204",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        226,
        202,
        216
      ],
      "id": "11-207",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        215,
        76,
        119
      ],
      "id": "11-208",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        191,
        55,
        152
      ],
      "id": "11-209",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        207,
        176,
        166
      ],
      "id": "11-215",
      "t": "Beige, Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        90,
        113,
        112
      ],
      "id": "11-217",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        100,
        163,
        206
      ],
      "id": "11-221",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        165,
        166,
        219
      ],
      "id": "11-222",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        81,
        69,
        94
      ],
      "id": "11-223",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        138,
        109,
        103
      ],
      "id": "11-224",
      "t": "Beige, Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        203,
        85,
        97
      ],
      "id": "11-226",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        110,
        183,
        84
      ],
      "id": "11-228",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        165,
        127,
        103
      ],
      "id": "11-234",
      "t": "Brown, Gold, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        152,
        154,
        165
      ],
      "id": "11-242",
      "t": "Crystal, Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        203,
        207,
        217
      ],
      "id": "11-250",
      "t": "Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        197,
        138,
        80
      ],
      "id": "11-251",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        224,
        191,
        52
      ],
      "id": "11-252",
      "t": "Yellow, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        161,
        28,
        42
      ],
      "id": "11-254D",
      "t": "Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        192,
        56,
        58
      ],
      "id": "11-254L",
      "t": "Orange, Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        124,
        107,
        118
      ],
      "id": "11-256",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        85,
        58,
        80
      ],
      "id": "11-257",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        171,
        186,
        80
      ],
      "id": "11-258",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        77,
        131,
        77
      ],
      "id": "11-259",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        37,
        148,
        210
      ],
      "id": "11-260",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        121,
        138,
        145
      ],
      "id": "11-263",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        135,
        93,
        137
      ],
      "id": "11-264",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        212,
        208,
        217
      ],
      "id": "11-265",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        169,
        200,
        212
      ],
      "id": "11-269L",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        150,
        196,
        183
      ],
      "id": "11-271",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        209,
        195,
        213
      ],
      "id": "11-272",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        208,
        182,
        118
      ],
      "id": "11-273",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        89,
        88,
        122
      ],
      "id": "11-274",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        181,
        116,
        100
      ],
      "id": "11-275",
      "t": "Brown, Orange, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        188,
        91,
        114
      ],
      "id": "11-276",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        105,
        131,
        118
      ],
      "id": "11-277",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        135,
        204,
        231
      ],
      "id": "11-278",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        56,
        115,
        148
      ],
      "id": "11-279",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        83,
        100,
        115
      ],
      "id": "11-283",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        225,
        220,
        221
      ],
      "id": "11-284",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        124,
        125,
        133
      ],
      "id": "11-286",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        58,
        88,
        81
      ],
      "id": "11-288",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        104,
        150,
        216
      ],
      "id": "11-299",
      "t": "Blue, Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        108,
        69,
        68
      ],
      "id": "11-301",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        95,
        55,
        60
      ],
      "id": "11-302",
      "t": "Pink, Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        79,
        24,
        23
      ],
      "id": "11-304",
      "t": "Purple, Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        57,
        69,
        82
      ],
      "id": "11-305",
      "t": "Blue, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        33,
        48,
        18
      ],
      "id": "11-306",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        65,
        48,
        78
      ],
      "id": "11-308",
      "t": "Blue, Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        85,
        26,
        21
      ],
      "id": "11-309",
      "t": "Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        124,
        88,
        54
      ],
      "id": "11-311",
      "t": "Brown, Gold, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        104,
        71,
        87
      ],
      "id": "11-312",
      "t": "Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        86,
        49,
        59
      ],
      "id": "11-313",
      "t": "Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        98,
        65,
        84
      ],
      "id": "11-313SF",
      "t": "Purple, Transparent",
      "dt": "Gold Luster, Rainbow, Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        100,
        79,
        98
      ],
      "id": "11-318",
      "t": "Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        62,
        93,
        65
      ],
      "id": "11-331",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        26,
        71,
        57
      ],
      "id": "11-332",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        80,
        67,
        109
      ],
      "id": "11-333",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        62,
        59,
        48
      ],
      "id": "11-335",
      "t": "Blue, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        85,
        53,
        48
      ],
      "id": "11-336",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        132,
        90,
        86
      ],
      "id": "11-337",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        36,
        61,
        50
      ],
      "id": "11-338",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        69,
        100,
        130
      ],
      "id": "11-339",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        112,
        102,
        127
      ],
      "id": "11-340",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        92,
        118,
        63
      ],
      "id": "11-341",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        121,
        113,
        114
      ],
      "id": "11-342",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        44,
        78,
        66
      ],
      "id": "11-344",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        134,
        85,
        45
      ],
      "id": "11-345",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        85,
        76,
        101
      ],
      "id": "11-346",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        45,
        60,
        73
      ],
      "id": "11-347",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        105,
        92,
        113
      ],
      "id": "11-348",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        67,
        63,
        56
      ],
      "id": "11-349",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        62,
        82,
        53
      ],
      "id": "11-350",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        149,
        118,
        92
      ],
      "id": "11-351",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        86,
        57,
        142
      ],
      "id": "11-352",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        47,
        83,
        155
      ],
      "id": "11-353",
      "t": "Blue, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        44,
        106,
        77
      ],
      "id": "11-354",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        191,
        90,
        123
      ],
      "id": "11-355",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        92,
        74,
        111
      ],
      "id": "11-356",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        91,
        80,
        70
      ],
      "id": "11-357",
      "t": "Iridescent, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        36,
        48,
        69
      ],
      "id": "11-358",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        147,
        142,
        105
      ],
      "id": "11-359",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        104,
        95,
        125
      ],
      "id": "11-360",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        91,
        99,
        90
      ],
      "id": "11-361",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        45,
        55,
        65
      ],
      "id": "11-362",
      "t": "Blue, Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        141,
        50,
        56
      ],
      "id": "11-363",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        137,
        82,
        85
      ],
      "id": "11-364",
      "t": "Orange, Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        206,
        134,
        127
      ],
      "id": "11-366",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        58,
        38,
        35
      ],
      "id": "11-367",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        65,
        45,
        58
      ],
      "id": "11-367SF",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        112,
        112,
        117
      ],
      "id": "11-368",
      "t": "Gray, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        226,
        164,
        148
      ],
      "id": "11-369",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        129,
        162,
        146
      ],
      "id": "11-370",
      "t": "Green, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        174,
        183,
        144
      ],
      "id": "11-371",
      "t": "Green, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        138,
        75,
        69
      ],
      "id": "11-372",
      "t": "Red, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        178,
        69,
        67
      ],
      "id": "11-373",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        90,
        123,
        109
      ],
      "id": "11-374",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        80,
        107,
        74
      ],
      "id": "11-375",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        91,
        135,
        168
      ],
      "id": "11-376",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        140,
        94,
        26
      ],
      "id": "11-377",
      "t": "Gold, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        164,
        160,
        120
      ],
      "id": "11-378",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        102,
        77,
        58
      ],
      "id": "11-379",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        45,
        61,
        73
      ],
      "id": "11-390",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        18,
        18,
        19
      ],
      "id": "11-401",
      "t": "Black, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        53,
        53,
        54
      ],
      "id": "11-401F",
      "t": "Black, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        46,
        68,
        94
      ],
      "id": "11-401FR",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        21,
        21,
        20
      ],
      "id": "11-401SF",
      "t": "Black, Opaque",
      "dt": "Semi-Frost"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        250,
        250,
        253
      ],
      "id": "11-402",
      "t": "White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        252,
        252,
        253
      ],
      "id": "11-402F",
      "t": "White, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        249,
        225,
        0
      ],
      "id": "11-404",
      "t": "Yellow, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        252,
        135,
        8
      ],
      "id": "11-405",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        250,
        82,
        7
      ],
      "id": "11-406",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        252,
        138,
        5
      ],
      "id": "11-406L",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        219,
        36,
        16
      ],
      "id": "11-407",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        218,
        73,
        95
      ],
      "id": "11-407FR",
      "t": "Pink, Red, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        207,
        6,
        24
      ],
      "id": "11-408",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        75,
        37,
        34
      ],
      "id": "11-409",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        99,
        69,
        68
      ],
      "id": "11-409F",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        149,
        121,
        136
      ],
      "id": "11-410",
      "t": "Purple, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        80,
        136,
        69
      ],
      "id": "11-411",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        95,
        136,
        101
      ],
      "id": "11-411FR",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        43,
        148,
        147
      ],
      "id": "11-412",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        24,
        160,
        207
      ],
      "id": "11-413",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        39,
        24,
        120
      ],
      "id": "11-414",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        48,
        40,
        139
      ],
      "id": "11-414F",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        250,
        184,
        219
      ],
      "id": "11-415",
      "t": "Pink, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        160,
        179,
        73
      ],
      "id": "11-416",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        95,
        112,
        205
      ],
      "id": "11-417L",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        98,
        23,
        29
      ],
      "id": "11-419",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        245,
        213,
        12
      ],
      "id": "11-422",
      "t": "Yellow, Opaque",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        251,
        140,
        77
      ],
      "id": "11-423",
      "t": "Orange, Opaque",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        190,
        37,
        54
      ],
      "id": "11-426",
      "t": "Red, Opaque",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        165,
        201,
        230
      ],
      "id": "11-430",
      "t": "Blue, Opaque",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        73,
        121,
        71
      ],
      "id": "11-431",
      "t": "Green, Opaque",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        44,
        51,
        64
      ],
      "id": "11-451",
      "t": "Gray, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        16,
        39,
        53
      ],
      "id": "11-452",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        41,
        48,
        43
      ],
      "id": "11-453",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        31,
        32,
        37
      ],
      "id": "11-454",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        39,
        43,
        53
      ],
      "id": "11-455D",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        54,
        67,
        79
      ],
      "id": "11-456",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        99,
        73,
        48
      ],
      "id": "11-457",
      "t": "Gold, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        120,
        84,
        37
      ],
      "id": "11-457L",
      "t": "Gold, Transparent",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        43,
        35,
        24
      ],
      "id": "11-458",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        61,
        62,
        41
      ],
      "id": "11-459",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        48,
        23,
        38
      ],
      "id": "11-460",
      "t": "Purple, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        81,
        66,
        58
      ],
      "id": "11-461",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        97,
        58,
        44
      ],
      "id": "11-462",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        56,
        58,
        65
      ],
      "id": "11-464",
      "t": "Gray, Opaque",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        59,
        71,
        44
      ],
      "id": "11-465",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        60,
        48,
        49
      ],
      "id": "11-466",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        27,
        60,
        88
      ],
      "id": "11-467",
      "t": "Blue, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        62,
        82,
        64
      ],
      "id": "11-468",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        21,
        30,
        48
      ],
      "id": "11-469",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        77,
        127,
        69
      ],
      "id": "11-480",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        227,
        203,
        168
      ],
      "id": "11-492",
      "t": "Beige, White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        220,
        183,
        137
      ],
      "id": "11-493",
      "t": "Beige, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        232,
        197,
        135
      ],
      "id": "11-514D",
      "t": "Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        223,
        188,
        139
      ],
      "id": "11-516",
      "t": "Orange, Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        234,
        212,
        221
      ],
      "id": "11-517",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        122,
        185,
        157
      ],
      "id": "11-520",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        143,
        212,
        237
      ],
      "id": "11-522",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        164,
        191,
        227
      ],
      "id": "11-524",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        127,
        130,
        139
      ],
      "id": "11-526",
      "t": "Gray, Alabaster",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        232,
        213,
        172
      ],
      "id": "11-527",
      "t": "Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        250,
        249,
        253
      ],
      "id": "11-528",
      "t": "White, Alabaster",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        210,
        126,
        142
      ],
      "id": "11-535",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        77,
        172,
        168
      ],
      "id": "11-536",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        102,
        162,
        202
      ],
      "id": "11-537",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        129,
        129,
        186
      ],
      "id": "11-538",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        236,
        146,
        138
      ],
      "id": "11-539",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        179,
        156,
        162
      ],
      "id": "11-542",
      "t": "Pink, Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        116,
        142,
        175
      ],
      "id": "11-545",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        145,
        129,
        137
      ],
      "id": "11-546",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        208,
        207,
        206
      ],
      "id": "11-551",
      "t": "Silver, Alabaster",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        203,
        146,
        95
      ],
      "id": "11-552",
      "t": "Gold, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        176,
        95,
        82
      ],
      "id": "11-553",
      "t": "Orange, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        218,
        197,
        141
      ],
      "id": "11-554",
      "t": "Yellow, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        195,
        104,
        143
      ],
      "id": "11-556",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        68,
        174,
        164
      ],
      "id": "11-571",
      "t": "Green, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        142,
        113,
        179
      ],
      "id": "11-574",
      "t": "Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        141,
        142,
        161
      ],
      "id": "11-576",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        201,
        188,
        166
      ],
      "id": "11-577",
      "t": "Yellow, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        194,
        151,
        101
      ],
      "id": "11-578",
      "t": "Gold, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        168,
        144,
        146
      ],
      "id": "11-579",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        234,
        222,
        203
      ],
      "id": "11-591",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        239,
        222,
        201
      ],
      "id": "11-592",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        214,
        174,
        148
      ],
      "id": "11-593",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        231,
        213,
        189
      ],
      "id": "11-594",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        233,
        165,
        151
      ],
      "id": "11-596",
      "t": "Pink, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        223,
        212,
        199
      ],
      "id": "11-600",
      "t": "White, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        122,
        91,
        86
      ],
      "id": "11-641",
      "t": "Brown, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        185,
        117,
        111
      ],
      "id": "11-642",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        203,
        186,
        204
      ],
      "id": "11-643",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        186,
        150,
        194
      ],
      "id": "11-644",
      "t": "Pink, Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        169,
        89,
        120
      ],
      "id": "11-645",
      "t": "Red, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        7,
        136,
        97
      ],
      "id": "11-646",
      "t": "Green, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        22,
        153,
        194
      ],
      "id": "11-647",
      "t": "Blue, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        41,
        99,
        139
      ],
      "id": "11-648",
      "t": "Blue, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        106,
        117,
        188
      ],
      "id": "11-649",
      "t": "Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        96,
        96,
        98
      ],
      "id": "11-650",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        227,
        219,
        215
      ],
      "id": "11-961",
      "t": "Silver, Opaque",
      "dt": "Plating, Silver"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        217,
        209,
        203
      ],
      "id": "11-961F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Silver"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        188,
        177,
        180
      ],
      "id": "11-1001",
      "t": "Silver, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        183,
        139,
        100
      ],
      "id": "11-1003",
      "t": "Gold, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        168,
        117,
        82
      ],
      "id": "11-1004",
      "t": "Gold, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        109,
        68,
        73
      ],
      "id": "11-1005",
      "t": "Red, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        196,
        179,
        76
      ],
      "id": "11-1006",
      "t": "Yellow, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        194,
        91,
        49
      ],
      "id": "11-1008",
      "t": "Orange, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        142,
        48,
        81
      ],
      "id": "11-1010",
      "t": "Red, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        130,
        102,
        116
      ],
      "id": "11-1012",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        92,
        73,
        87
      ],
      "id": "11-1013",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        149,
        155,
        103
      ],
      "id": "11-1014",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        45,
        102,
        83
      ],
      "id": "11-1016",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        41,
        102,
        112
      ],
      "id": "11-1017",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        72,
        147,
        182
      ],
      "id": "11-1018",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        54,
        93,
        143
      ],
      "id": "11-1019",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        42,
        55,
        138
      ],
      "id": "11-1020",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        185,
        157,
        156
      ],
      "id": "11-1023",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        80,
        74,
        98
      ],
      "id": "11-1024",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        32,
        78,
        123
      ],
      "id": "11-1025",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        79,
        104,
        93
      ],
      "id": "11-1026",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        198,
        188,
        171
      ],
      "id": "11-1051",
      "t": "Silver, Transparent",
      "dt": "Galvanized"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        196,
        150,
        102
      ],
      "id": "11-1052",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        128,
        150,
        156
      ],
      "id": "11-1059D",
      "t": "Blue, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        170,
        132,
        156
      ],
      "id": "11-1061L",
      "t": "Purple, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        154,
        137,
        146
      ],
      "id": "11-1062D",
      "t": "Purple, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        200,
        153,
        131
      ],
      "id": "11-1072L",
      "t": "Beige, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        110,
        139,
        118
      ],
      "id": "11-1074",
      "t": "Green, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        119,
        82,
        82
      ],
      "id": "11-1085",
      "t": "Brown, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        173,
        143,
        139
      ],
      "id": "11-1086",
      "t": "Pink, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        102,
        102,
        95
      ],
      "id": "11-1087",
      "t": "Green, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        100,
        80,
        78
      ],
      "id": "11-1088",
      "t": "Brown, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        95,
        32,
        33
      ],
      "id": "11-1089",
      "t": "Red, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        216,
        231,
        129
      ],
      "id": "11-1119",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        118,
        231,
        148
      ],
      "id": "11-1120",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        249,
        206,
        101
      ],
      "id": "11-1121",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        253,
        146,
        129
      ],
      "id": "11-1122",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        231,
        167,
        7
      ],
      "id": "11-1233",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        71,
        78,
        93
      ],
      "id": "11-1254",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        248,
        125,
        172
      ],
      "id": "11-1385",
      "t": "Pink, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        101,
        92,
        55
      ],
      "id": "11-1421",
      "t": "Yellow, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        36,
        62,
        78
      ],
      "id": "11-1425",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        56,
        47,
        63
      ],
      "id": "11-1426",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        58,
        43,
        106
      ],
      "id": "11-1427",
      "t": "Blue, Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        75,
        95,
        87
      ],
      "id": "11-1456",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Silverline, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        37,
        49,
        92
      ],
      "id": "11-1457",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Silverline, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        146,
        115,
        73
      ],
      "id": "11-1461",
      "t": "Beige, Brown, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        85,
        85,
        177
      ],
      "id": "11-1477",
      "t": "Blue, Purple, Opaque",
      "dt": "Luster, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        179,
        97,
        99
      ],
      "id": "11-1660",
      "t": "Pink, Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        33,
        65,
        41
      ],
      "id": "11-1661",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Frosted (Matte), Silverline, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        71,
        84,
        129
      ],
      "id": "11-1827",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        74,
        49,
        75
      ],
      "id": "11-1884",
      "t": "Blue, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        146,
        132,
        69
      ],
      "id": "11-1889",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        100,
        114,
        68
      ],
      "id": "11-1897",
      "t": "Green, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        61,
        61,
        103
      ],
      "id": "11-1899",
      "t": "Blue, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        198,
        185,
        171
      ],
      "id": "11-1901",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        197,
        149,
        80
      ],
      "id": "11-1902",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        241,
        234,
        220
      ],
      "id": "11-1920",
      "t": "White, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        247,
        211,
        135
      ],
      "id": "11-1921",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Frosted (Matte), Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        234,
        162,
        117
      ],
      "id": "11-1922",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        148,
        128,
        189
      ],
      "id": "11-1924",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        142,
        113,
        78
      ],
      "id": "11-1925",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Frosted (Matte), Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        87,
        119,
        63
      ],
      "id": "11-1926",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        42,
        158,
        151
      ],
      "id": "11-1927",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        80,
        88,
        130
      ],
      "id": "11-1928",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        99,
        122,
        194
      ],
      "id": "11-1929",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        74,
        76,
        170
      ],
      "id": "11-1930",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        171,
        101,
        127
      ],
      "id": "11-1931",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        91,
        61,
        118
      ],
      "id": "11-1932",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        35,
        78,
        78
      ],
      "id": "11-1933",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        242,
        170,
        167
      ],
      "id": "11-1934",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        225,
        175,
        130
      ],
      "id": "11-1935",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        247,
        199,
        114
      ],
      "id": "11-1936",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        218,
        129,
        47
      ],
      "id": "11-1937",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        43,
        71,
        81
      ],
      "id": "11-1938",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        21,
        21,
        116
      ],
      "id": "11-1945",
      "t": "Blue, Opaque",
      "dt": "Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        120,
        107,
        66
      ],
      "id": "11-1981",
      "t": "Iridescent, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        139,
        91,
        55
      ],
      "id": "11-1983",
      "t": "Gold, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        122,
        87,
        78
      ],
      "id": "11-1984",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        162,
        123,
        84
      ],
      "id": "11-1985",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        124,
        122,
        109
      ],
      "id": "11-1986",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        116,
        116,
        118
      ],
      "id": "11-2002",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        65,
        57,
        48
      ],
      "id": "11-2004",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        73,
        60,
        72
      ],
      "id": "11-2005",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        113,
        88,
        70
      ],
      "id": "11-2006",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        87,
        107,
        106
      ],
      "id": "11-2008",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        46,
        47,
        53
      ],
      "id": "11-2010",
      "t": "Black, Gray, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        62,
        69,
        84
      ],
      "id": "11-2011",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        119,
        109,
        99
      ],
      "id": "11-2012",
      "t": "Gray, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        63,
        60,
        54
      ],
      "id": "11-2013",
      "t": "Brown, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        50,
        55,
        67
      ],
      "id": "11-2014",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        71,
        65,
        53
      ],
      "id": "11-2015",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        66,
        56,
        64
      ],
      "id": "11-2016",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        61,
        72,
        80
      ],
      "id": "11-2018",
      "t": "Green, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        69,
        66,
        76
      ],
      "id": "11-2019",
      "t": "Iridescent, Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        54,
        66,
        41
      ],
      "id": "11-2020",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        237,
        217,
        194
      ],
      "id": "11-2021",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        231,
        202,
        177
      ],
      "id": "11-2022",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        220,
        170,
        155
      ],
      "id": "11-2023",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        188,
        143,
        163
      ],
      "id": "11-2024",
      "t": "Pink, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        171,
        153,
        171
      ],
      "id": "11-2025",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        191,
        193,
        207
      ],
      "id": "11-2026",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        140,
        114,
        118
      ],
      "id": "11-2027",
      "t": "Pink, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        110,
        149,
        143
      ],
      "id": "11-2028",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        87,
        157,
        178
      ],
      "id": "11-2029",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        96,
        122,
        150
      ],
      "id": "11-2030",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        91,
        114,
        104
      ],
      "id": "11-2031",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        137,
        120,
        82
      ],
      "id": "11-2032",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        124,
        124,
        98
      ],
      "id": "11-2033",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        151,
        120,
        131
      ],
      "id": "11-2034",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Gold Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        133,
        106,
        89
      ],
      "id": "11-2035",
      "t": "Iridescent, Transparent",
      "dt": "Frosted (Matte), Glazed Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        234,
        179,
        170
      ],
      "id": "11-2036",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        172,
        131,
        147
      ],
      "id": "11-2037",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        89,
        116,
        142
      ],
      "id": "11-2038",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        66,
        49,
        60
      ],
      "id": "11-2061",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        67,
        56,
        66
      ],
      "id": "11-2062",
      "t": "Iridescent, Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        63,
        85,
        109
      ],
      "id": "11-2064",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        42,
        59,
        55
      ],
      "id": "11-2066",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        75,
        118,
        147
      ],
      "id": "11-2074",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        58,
        61,
        112
      ],
      "id": "11-2075",
      "t": "Blue, Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        129,
        116,
        105
      ],
      "id": "11-2091",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        127,
        112,
        106
      ],
      "id": "11-2195",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        186,
        185,
        212
      ],
      "id": "11-2211",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        77,
        120,
        140
      ],
      "id": "11-2261",
      "t": "Blue, Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        170,
        187,
        47
      ],
      "id": "11-2316",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        153,
        119,
        114
      ],
      "id": "11-2331",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        94,
        105,
        116
      ],
      "id": "11-2333",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        231,
        131,
        144
      ],
      "id": "11-2346",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Semi-Frost, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 229, 207, 188 ],
      "id": "11-2370",
      "t": "Light Pearl",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 202, 177, 150 ],
      "id": "11-2371",
      "t": "Pearl",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 162, 142, 109 ],
      "id": "11-2372",
      "t": "Dark Pearl",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 167, 143, 149 ],
      "id": "11-2373",
      "t": "Thistle",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 143, 146, 114 ],
      "id": "11-2374",
      "t": "Lilac",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 140, 156, 135 ],
      "id": "11-2375",
      "t": "Sage",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 136, 158, 159 ],
      "id": "11-2376",
      "t": "Ocean",
      "dt": "Gem Stone Coating"
    },

    {
      "a": 1,
      "b": 2,
      "c": [ 154, 150, 171 ],
      "id": "11-2377",
      "t": "Cyan",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 136, 148, 161 ],
      "id": "11-2378",
      "t": "Purple",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        74,
        35,
        24
      ],
      "id": "11-2400SF",
      "t": "Brown, Transparent",
      "dt": "Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        78,
        49,
        60
      ],
      "id": "11-2401SF",
      "t": "Purple, Transparent",
      "dt": "Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        31,
        26,
        26
      ],
      "id": "11-2402",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        29,
        23,
        25
      ],
      "id": "11-2402SF",
      "t": "Purple, Transparent",
      "dt": "Semi-Frost"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        5,
        68,
        63
      ],
      "id": "11-2405",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        2,
        88,
        86
      ],
      "id": "11-2405F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        43,
        110,
        123
      ],
      "id": "11-2405FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        9,
        63,
        64
      ],
      "id": "11-2406",
      "t": "Blue, Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        33,
        38,
        44
      ],
      "id": "11-2411",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        127,
        121,
        116
      ],
      "id": "11-2412",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        133,
        86,
        43
      ],
      "id": "11-2422",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        135,
        73,
        35
      ],
      "id": "11-2422F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        97,
        139,
        49
      ],
      "id": "11-2423",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        28,
        82,
        72
      ],
      "id": "11-2425",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        15,
        88,
        83
      ],
      "id": "11-2425F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        69,
        73,
        74
      ],
      "id": "11-2426",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        49,
        31,
        31
      ],
      "id": "11-2428",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        21,
        119,
        166
      ],
      "id": "11-2429",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        148,
        158,
        178
      ],
      "id": "11-2430",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        70,
        88,
        135
      ],
      "id": "11-2431",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        119,
        114,
        114
      ],
      "id": "11-2440",
      "t": "Blue, Gray, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        220,
        204,
        174
      ],
      "id": "11-2442",
      "t": "Crystal, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        88,
        131,
        124
      ],
      "id": "11-2445",
      "t": "Green, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        107,
        70,
        71
      ],
      "id": "11-2449",
      "t": "Gold, Iridescent, Transparent",
      "dt": "Metallic"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        159,
        102,
        108
      ],
      "id": "11-2601",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        163,
        164,
        146
      ],
      "id": "11-2604",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        41,
        135,
        131
      ],
      "id": "11-2605",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        90,
        132,
        168
      ],
      "id": "11-2606",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        120,
        102,
        150
      ],
      "id": "11-2607",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        219,
        206,
        177
      ],
      "id": "11-4201",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        237,
        219,
        181
      ],
      "id": "11-4201F",
      "t": "Silver, White, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        180,
        138,
        80
      ],
      "id": "11-4202",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        208,
        153,
        81
      ],
      "id": "11-4202F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        184,
        119,
        45
      ],
      "id": "11-4203",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        191,
        129,
        74
      ],
      "id": "11-4203F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        182,
        140,
        114
      ],
      "id": "11-4204",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        173,
        136,
        107
      ],
      "id": "11-4204F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        202,
        188,
        79
      ],
      "id": "11-4205",
      "t": "Yellow, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        191,
        122,
        86
      ],
      "id": "11-4206",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        170,
        104,
        78
      ],
      "id": "11-4207",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        145,
        57,
        48
      ],
      "id": "11-4208",
      "t": "Red, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        187,
        84,
        78
      ],
      "id": "11-4208F",
      "t": "Red, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        185,
        122,
        125
      ],
      "id": "11-4209",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        164,
        101,
        132
      ],
      "id": "11-4210",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        184,
        110,
        132
      ],
      "id": "11-4210F",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        196,
        88,
        113
      ],
      "id": "11-4211",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        195,
        101,
        113
      ],
      "id": "11-4211F",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        124,
        51,
        43
      ],
      "id": "11-4212",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        160,
        99,
        93
      ],
      "id": "11-4212F",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        122,
        94,
        87
      ],
      "id": "11-4213",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        145,
        114,
        109
      ],
      "id": "11-4213F",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        113,
        160,
        118
      ],
      "id": "11-4214",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        125,
        183,
        134
      ],
      "id": "11-4214F",
      "t": "Green, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        93,
        115,
        99
      ],
      "id": "11-4215",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        126,
        155,
        150
      ],
      "id": "11-4216",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        40,
        108,
        113
      ],
      "id": "11-4217",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        67,
        119,
        126
      ],
      "id": "11-4217F",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        143,
        84,
        106
      ],
      "id": "11-4218",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        147,
        71,
        96
      ],
      "id": "11-4219",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        128,
        86,
        105
      ],
      "id": "11-4220",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        147,
        138,
        115
      ],
      "id": "11-4221",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        160,
        149,
        127
      ],
      "id": "11-4221F",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        108,
        92,
        72
      ],
      "id": "11-4222",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        183,
        129,
        80
      ],
      "id": "11-4231",
      "t": "Yellow, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        170,
        105,
        90
      ],
      "id": "11-4233",
      "t": "Orange, Pink, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        138,
        45,
        57
      ],
      "id": "11-4234",
      "t": "Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        181,
        87,
        152
      ],
      "id": "11-4238",
      "t": "Pink, Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        187,
        59,
        94
      ],
      "id": "11-4239",
      "t": "Pink, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        69,
        119,
        157
      ],
      "id": "11-4242",
      "t": "Blue, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        147,
        105,
        97
      ],
      "id": "11-4243",
      "t": "Beige, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        150,
        78,
        71
      ],
      "id": "11-4244",
      "t": "Orange, Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        114,
        65,
        73
      ],
      "id": "11-4245",
      "t": "Brown, Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        145,
        77,
        125
      ],
      "id": "11-4246",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        132,
        72,
        107
      ],
      "id": "11-4247",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        102,
        68,
        117
      ],
      "id": "11-4248",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        111,
        86,
        85
      ],
      "id": "11-4249",
      "t": "Brown, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        89,
        82,
        82
      ],
      "id": "11-4250",
      "t": "Brown, Gray, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        78,
        77,
        77
      ],
      "id": "11-4251",
      "t": "Brown, Gray, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 26, 26, 185 ],
      "id": "11-4281",
      "t": "Navy Blue",
      "dt": "Duracoat, Silverline Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 38, 38, 84 ],
      "id": "11-4282",
      "t": "Navy Blue",
      "dt": "Duracoat, Silverline Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        251,
        160,
        81
      ],
      "id": "11-4298",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        249,
        100,
        159
      ],
      "id": "11-4299",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        115,
        178,
        219
      ],
      "id": "11-4300",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        246,
        117,
        192
      ],
      "id": "11-4301",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        237,
        92,
        193
      ],
      "id": "11-4302",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        173,
        105,
        179
      ],
      "id": "11-4303",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        243,
        233,
        164
      ],
      "id": "11-4451",
      "t": "Yellow Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        228,
        185,
        95
      ],
      "id": "11-4452",
      "t": "Gold Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        247,
        167,
        39
      ],
      "id": "11-4453",
      "t": "Orange Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        249,
        144,
        52
      ],
      "id": "11-4454",
      "t": "Orange Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        149,
        121,
        99
      ],
      "id": "11-4455",
      "t": "Coffee Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        172,
        108,
        28
      ],
      "id": "11-4456",
      "t": "Tan Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        158,
        108,
        67
      ],
      "id": "11-4457",
      "t": "Rust Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        142,
        78,
        35
      ],
      "id": "11-4458",
      "t": "Chocolate Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        121,
        72,
        19
      ],
      "id": "11-4459",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        139,
        86,
        36
      ],
      "id": "11-4460",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        250,
        178,
        154
      ],
      "id": "11-4461",
      "t": "Rose Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        249,
        145,
        130
      ],
      "id": "11-4462",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        243,
        164,
        165
      ],
      "id": "11-4463",
      "t": "Rose Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        191,
        108,
        101
      ],
      "id": "11-4464",
      "t": "Salmon Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        218,
        118,
        127
      ],
      "id": "11-4465",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        242,
        164,
        183
      ],
      "id": "11-4466",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        249,
        128,
        156
      ],
      "id": "11-4467",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        157,
        75,
        103
      ],
      "id": "11-4468",
      "t": "Blackberry Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        119,
        30,
        32
      ],
      "id": "11-4469",
      "t": "Red Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        96,
        26,
        22
      ],
      "id": "11-4470",
      "t": "Maroon Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        141,
        202,
        66
      ],
      "id": "11-4471",
      "t": "Lime Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        103,
        199,
        183
      ],
      "id": "11-4472",
      "t": "Cyan Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        144,
        160,
        105
      ],
      "id": "11-4473",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        130,
        137,
        91
      ],
      "id": "11-4474",
      "t": "Olive Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        77,
        167,
        141
      ],
      "id": "11-4475",
      "t": "Teal Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        57,
        149,
        71
      ],
      "id": "11-4476",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        53,
        122,
        91
      ],
      "id": "11-4477",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        69,
        194,
        182
      ],
      "id": "11-4478",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        93,
        146,
        152
      ],
      "id": "11-4479",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        40,
        154,
        177
      ],
      "id": "11-4480",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        65,
        98,
        94
      ],
      "id": "11-4481",
      "t": "Teal Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        85,
        128,
        152
      ],
      "id": "11-4482",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        19,
        114,
        135
      ],
      "id": "11-4483",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        20,
        104,
        179
      ],
      "id": "11-4484",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        47,
        112,
        142
      ],
      "id": "11-4485",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        143,
        129,
        170
      ],
      "id": "11-4486",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        142,
        101,
        115
      ],
      "id": "11-4487",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        144,
        113,
        169
      ],
      "id": "11-4488",
      "t": "Purple Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        125,
        99,
        115
      ],
      "id": "11-4489",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        98,
        70,
        103
      ],
      "id": "11-4490",
      "t": "Violet Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        106,
        96,
        49
      ],
      "id": "11-4491",
      "t": "Olive Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        100,
        68,
        43
      ],
      "id": "11-4492",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 1,
      "b": 1,
      "c": [ 26, 26, 185 ],
      "id": "11-4493",
      "t": "Navy Blue",
      "dt": "Duracoat, Opaque Dyed"
    },
    {
      "a": 1,
      "b": 1,
      "c": [ 38, 38, 84 ],
      "id": "11-4494",
      "t": "Navy Blue",
      "dt": "Duracoat, Opaque Dyed"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        128,
        84,
        57
      ],
      "id": "11-4501",
      "t": "Brown, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        78,
        35,
        18
      ],
      "id": "11-4502",
      "t": "Blue, Brown, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        59,
        55,
        46
      ],
      "id": "11-4503",
      "t": "Blue, Brown, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        45,
        25,
        30
      ],
      "id": "11-4504",
      "t": "Black, Blue, Red, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        106,
        81,
        69
      ],
      "id": "11-4505",
      "t": "Brown, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        108,
        115,
        100
      ],
      "id": "11-4506",
      "t": "Green, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        42,
        72,
        41
      ],
      "id": "11-4507",
      "t": "Green, Transparent",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        29,
        37,
        50
      ],
      "id": "11-4511",
      "t": "Black, Gray, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        183,
        153,
        94
      ],
      "id": "11-4512",
      "t": "Beige, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        100,
        43,
        29
      ],
      "id": "11-4513",
      "t": "Red, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        127,
        140,
        117
      ],
      "id": "11-4514",
      "t": "Blue, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        162,
        158,
        90
      ],
      "id": "11-4515",
      "t": "Green, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        66,
        86,
        94
      ],
      "id": "11-4516",
      "t": "Blue, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        165,
        135,
        92
      ],
      "id": "11-4517",
      "t": "Brown, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        68,
        83,
        100
      ],
      "id": "11-4518",
      "t": "Blue, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        104,
        81,
        42
      ],
      "id": "11-4519",
      "t": "Green, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        92,
        83,
        68
      ],
      "id": "11-4551",
      "t": "Orange, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 50, 53, 66 ],
      "id": "11-4555",
      "t": "AB",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        81,
        75,
        78
      ],
      "id": "11-4556",
      "t": "Blue, Purple, Transparent",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        126,
        124,
        121
      ],
      "id": "11-4557",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        179,
        179,
        187
      ],
      "id": "11-4558",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [ 45, 51, 54 ],
      "id": "11-4560",
      "t": "Black / Marea",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 1,
      "c": [ 73, 75, 78 ],
      "id": "11-4561",
      "t": "Valentinite Matte",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        74,
        72,
        74
      ],
      "id": "11-4571",
      "t": "Pink, Purple, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        63,
        69,
        75
      ],
      "id": "11-4572",
      "t": "Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        78,
        64,
        60
      ],
      "id": "11-4573",
      "t": "Gold, Red, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [ 80, 82, 88 ],
      "id": "11-4574",
      "t": "Vitrail Light (VL)",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [ 183, 183, 183 ],
      "id": "11-4575",
      "t": "Crystal Labrador Full",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [ 200, 200, 200 ],
      "id": "11-4587",
      "t": "Aluminium Silver",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [ 170, 154, 120 ],
      "id": "11-4588",
      "t": "Aztec Gold",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [ 223, 171, 144 ],
      "id": "11-4589",
      "t": "Vintage Copper",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [ 192, 131, 108 ],
      "id": "11-4590",
      "t": "B. Bronze",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 2,
      "c": [ 150, 87, 84 ],
      "id": "11-4591",
      "t": "Lava Red",
      "dt": "Special Coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        199,
        177,
        139
      ],
      "id": "11-4691",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        206,
        182,
        70
      ],
      "id": "11-4692",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        193,
        172,
        89
      ],
      "id": "11-4693",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        168,
        146,
        126
      ],
      "id": "11-4694",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        170,
        104,
        96
      ],
      "id": "11-4695",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        131,
        80,
        84
      ],
      "id": "11-4696",
      "t": "Iridescent, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        163,
        162,
        76
      ],
      "id": "11-4697",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        132,
        145,
        110
      ],
      "id": "11-4698",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        100,
        129,
        107
      ],
      "id": "11-4699",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        97,
        118,
        89
      ],
      "id": "11-4700",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        124,
        145,
        132
      ],
      "id": "11-4701",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        98,
        127,
        134
      ],
      "id": "11-4702",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        99,
        109,
        127
      ],
      "id": "11-4703",
      "t": "Blue, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 2,
      "c": [
        114,
        130,
        172
      ],
      "id": "11-4704",
      "t": "Blue, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 1,
      "c": [
        143,
        150,
        146
      ],
      "id": "11-4705",
      "t": "Gray, Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        218,
        196,
        143
      ],
      "id": "11-5101",
      "t": "Gold Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        231,
        217,
        163
      ],
      "id": "11-5102",
      "t": "Gold Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        187,
        135,
        116
      ],
      "id": "11-5103",
      "t": "Copper Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        185,
        135,
        93
      ],
      "id": "11-5104",
      "t": "Bronze Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        118,
        172,
        142
      ],
      "id": "11-5105",
      "t": "Green Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        53,
        155,
        140
      ],
      "id": "11-5106",
      "t": "Teal Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        24,
        27,
        24
      ],
      "id": "11-5107",
      "t": "Black Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        96,
        56,
        110
      ],
      "id": "11-5108",
      "t": "Purple Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        122,
        86,
        150
      ],
      "id": "11-5109",
      "t": "Violet Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        59,
        47,
        109
      ],
      "id": "11-5110",
      "t": "Violet Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        29,
        49,
        105
      ],
      "id": "11-5111",
      "t": "Blue Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        138,
        139,
        113
      ],
      "id": "11-5112",
      "t": "Yellow Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        32,
        127,
        158
      ],
      "id": "11-5113",
      "t": "Blue Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        21,
        108,
        161
      ],
      "id": "11-5114",
      "t": "Blue Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        75,
        109,
        134
      ],
      "id": "11-5115",
      "t": "Blue Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        22,
        67,
        116
      ],
      "id": "11-5116",
      "t": "Blue Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 1,
      "b": 3,
      "c": [
        33,
        54,
        112
      ],
      "id": "11-5117",
      "t": "Purple Duracoat Galvanized",
      "dt": "Extra durable galvanized coating"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        198,
        186,
        174
      ],
      "id": "15-1",
      "t": "Silver, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        204,
        193,
        185
      ],
      "id": "15-1F",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        193,
        151,
        87
      ],
      "id": "15-3",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        194,
        153,
        92
      ],
      "id": "15-3F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        183,
        136,
        73
      ],
      "id": "15-4F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        79,
        59,
        47
      ],
      "id": "15-5D",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        84,
        61,
        48
      ],
      "id": "15-5F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        116,
        72,
        41
      ],
      "id": "15-5L",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        192,
        166,
        21
      ],
      "id": "15-6",
      "t": "Yellow, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        199,
        177,
        34
      ],
      "id": "15-6F",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        222,
        103,
        24
      ],
      "id": "15-8F",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        188,
        65,
        24
      ],
      "id": "15-9",
      "t": "Orange, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        158,
        25,
        16
      ],
      "id": "15-10",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        169,
        42,
        42
      ],
      "id": "15-10F",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        107,
        11,
        18
      ],
      "id": "15-11",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        93,
        43,
        29
      ],
      "id": "15-11D",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        135,
        104,
        111
      ],
      "id": "15-12",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        134,
        100,
        105
      ],
      "id": "15-12F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        93,
        64,
        69
      ],
      "id": "15-13",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        95,
        63,
        65
      ],
      "id": "15-13F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        149,
        153,
        68
      ],
      "id": "15-14",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        160,
        165,
        13
      ],
      "id": "15-14F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        28,
        95,
        43
      ],
      "id": "15-16",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        32,
        103,
        38
      ],
      "id": "15-16F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        9,
        97,
        61
      ],
      "id": "15-17",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        17,
        89,
        62
      ],
      "id": "15-17F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        102,
        156,
        175
      ],
      "id": "15-18",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        92,
        163,
        183
      ],
      "id": "15-18F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        48,
        98,
        156
      ],
      "id": "15-19",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        68,
        103,
        148
      ],
      "id": "15-19F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        36,
        34,
        120
      ],
      "id": "15-20",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        47,
        42,
        115
      ],
      "id": "15-20F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        95,
        93,
        89
      ],
      "id": "15-21F",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        204,
        168,
        149
      ],
      "id": "15-23F",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        92,
        76,
        93
      ],
      "id": "15-24",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        99,
        83,
        99
      ],
      "id": "15-24F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        37,
        85,
        114
      ],
      "id": "15-25",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        15,
        89,
        130
      ],
      "id": "15-25F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        95,
        109,
        61
      ],
      "id": "15-26",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        92,
        105,
        60
      ],
      "id": "15-26F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        34,
        85,
        56
      ],
      "id": "15-27F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        211,
        209,
        218
      ],
      "id": "15-131",
      "t": "Crystal, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        237,
        236,
        246
      ],
      "id": "15-131F",
      "t": "Crystal, White, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        241,
        242,
        252
      ],
      "id": "15-131FR",
      "t": "Crystal, White, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        209,
        138,
        65
      ],
      "id": "15-132",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        227,
        176,
        127
      ],
      "id": "15-132FR",
      "t": "Brown, Gold, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        88,
        37,
        14
      ],
      "id": "15-134",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        132,
        100,
        88
      ],
      "id": "15-134FR",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        49,
        34,
        28
      ],
      "id": "15-135",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        63,
        47,
        43
      ],
      "id": "15-135F",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        219,
        181,
        8
      ],
      "id": "15-136",
      "t": "Yellow, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        220,
        38,
        11
      ],
      "id": "15-139",
      "t": "Orange, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        185,
        4,
        9
      ],
      "id": "15-140",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        203,
        77,
        93
      ],
      "id": "15-140FR",
      "t": "Pink, Red, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        105,
        5,
        12
      ],
      "id": "15-141",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        98,
        11,
        17
      ],
      "id": "15-141D",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        120,
        84,
        98
      ],
      "id": "15-142",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        131,
        99,
        112
      ],
      "id": "15-142F",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        149,
        121,
        148
      ],
      "id": "15-142FR",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        155,
        177,
        38
      ],
      "id": "15-143",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        164,
        183,
        60
      ],
      "id": "15-143F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        171,
        191,
        76
      ],
      "id": "15-143FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        15,
        78,
        27
      ],
      "id": "15-146",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        9,
        98,
        42
      ],
      "id": "15-146F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        59,
        119,
        88
      ],
      "id": "15-146FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        8,
        81,
        65
      ],
      "id": "15-147",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        60,
        168,
        217
      ],
      "id": "15-148",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        61,
        167,
        233
      ],
      "id": "15-148F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        94,
        178,
        228
      ],
      "id": "15-148FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        8,
        65,
        110
      ],
      "id": "15-149",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        23,
        111,
        167
      ],
      "id": "15-149FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        12,
        61,
        180
      ],
      "id": "15-150",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        47,
        93,
        195
      ],
      "id": "15-150F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        69,
        117,
        200
      ],
      "id": "15-150FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        22,
        10,
        130
      ],
      "id": "15-151",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        33,
        15,
        129
      ],
      "id": "15-151F",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        65,
        66,
        154
      ],
      "id": "15-151FR",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        109,
        116,
        122
      ],
      "id": "15-152FR",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        75,
        44,
        55
      ],
      "id": "15-153",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        113,
        93,
        112
      ],
      "id": "15-153FR",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        10,
        50,
        28
      ],
      "id": "15-156",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        22,
        63,
        43
      ],
      "id": "15-156F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        61,
        100,
        103
      ],
      "id": "15-156FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        77,
        63,
        85
      ],
      "id": "15-157",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        44,
        61,
        26
      ],
      "id": "15-158",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        76,
        109,
        98
      ],
      "id": "15-158FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        226,
        186,
        13
      ],
      "id": "15-163",
      "t": "Yellow, Transparent",
      "dt": "Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        124,
        124,
        144
      ],
      "id": "15-174",
      "t": "Crystal, Gray, Transparent",
      "dt": "Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        62,
        58,
        156
      ],
      "id": "15-177",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        38,
        108,
        76
      ],
      "id": "15-179",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        196,
        187,
        170
      ],
      "id": "15-181",
      "t": "Silver, Transparent",
      "dt": "Galvanized"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        184,
        135,
        87
      ],
      "id": "15-182",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        159,
        110,
        97
      ],
      "id": "15-187",
      "t": "Brown, Opaque",
      "dt": "Plating, Copper"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        113,
        85,
        70
      ],
      "id": "15-188",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Nickel"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        121,
        111,
        106
      ],
      "id": "15-190",
      "t": "Silver, Opaque",
      "dt": "Plating, Nickel"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        123,
        115,
        109
      ],
      "id": "15-190F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Nickel"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        208,
        169,
        102
      ],
      "id": "15-191",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        209,
        172,
        112
      ],
      "id": "15-191F",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        188,
        163,
        121
      ],
      "id": "15-193",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        191,
        160,
        125
      ],
      "id": "15-193F",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        158,
        153,
        150
      ],
      "id": "15-194",
      "t": "Silver, Opaque",
      "dt": "Plating, Palladium"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        173,
        165,
        165
      ],
      "id": "15-194F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Palladium"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        175,
        123,
        78
      ],
      "id": "15-195",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        187,
        153,
        127
      ],
      "id": "15-196",
      "t": "Gold, Alabaster",
      "dt": "Goldline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        147,
        111,
        102
      ],
      "id": "15-197",
      "t": "Pink, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        153,
        131,
        132
      ],
      "id": "15-198",
      "t": "Pink, Alabaster",
      "dt": "Copperline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        154,
        100,
        55
      ],
      "id": "15-199",
      "t": "Gold, Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        248,
        215,
        119
      ],
      "id": "15-201",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        225,
        106,
        115
      ],
      "id": "15-204",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        233,
        205,
        226
      ],
      "id": "15-207",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        222,
        98,
        144
      ],
      "id": "15-208",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        203,
        60,
        156
      ],
      "id": "15-209",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        200,
        101,
        94
      ],
      "id": "15-214",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        212,
        186,
        182
      ],
      "id": "15-215",
      "t": "Beige, Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        80,
        115,
        116
      ],
      "id": "15-217",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        105,
        153,
        198
      ],
      "id": "15-221",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        189,
        142,
        219
      ],
      "id": "15-222",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        94,
        85,
        114
      ],
      "id": "15-223",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        140,
        110,
        111
      ],
      "id": "15-224",
      "t": "Beige, Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        197,
        78,
        100
      ],
      "id": "15-226",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        99,
        182,
        92
      ],
      "id": "15-228",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        139,
        140,
        151
      ],
      "id": "15-242",
      "t": "Crystal, Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        206,
        211,
        223
      ],
      "id": "15-250",
      "t": "Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        216,
        166,
        108
      ],
      "id": "15-251",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        210,
        179,
        68
      ],
      "id": "15-252",
      "t": "Yellow, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        180,
        50,
        61
      ],
      "id": "15-254",
      "t": "Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        137,
        110,
        126
      ],
      "id": "15-256",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        109,
        71,
        62
      ],
      "id": "15-257",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        170,
        184,
        85
      ],
      "id": "15-258",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        78,
        176,
        226
      ],
      "id": "15-260",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        75,
        118,
        195
      ],
      "id": "15-261",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        113,
        134,
        142
      ],
      "id": "15-263",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        139,
        94,
        142
      ],
      "id": "15-264",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        228,
        222,
        228
      ],
      "id": "15-265",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        223,
        207,
        220
      ],
      "id": "15-266",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        127,
        180,
        214
      ],
      "id": "15-269",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        114,
        197,
        167
      ],
      "id": "15-271",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        230,
        211,
        227
      ],
      "id": "15-272",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        238,
        203,
        116
      ],
      "id": "15-273",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        108,
        105,
        141
      ],
      "id": "15-274",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        174,
        136,
        127
      ],
      "id": "15-275",
      "t": "Brown, Orange, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        206,
        104,
        125
      ],
      "id": "15-276",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        117,
        139,
        127
      ],
      "id": "15-277",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        88,
        159,
        195
      ],
      "id": "15-278",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        91,
        120,
        143
      ],
      "id": "15-279",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        236,
        204,
        185
      ],
      "id": "15-281",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        84,
        95,
        127
      ],
      "id": "15-283",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        232,
        226,
        227
      ],
      "id": "15-284",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        29,
        93,
        131
      ],
      "id": "15-291",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        82,
        68,
        97
      ],
      "id": "15-294",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        31,
        114,
        119
      ],
      "id": "15-295",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        68,
        72,
        87
      ],
      "id": "15-296",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        212,
        71,
        67
      ],
      "id": "15-297",
      "t": "Orange, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        112,
        59,
        80
      ],
      "id": "15-298",
      "t": "Purple, Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        123,
        82,
        65
      ],
      "id": "15-301",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        81,
        54,
        71
      ],
      "id": "15-302",
      "t": "Pink, Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        76,
        28,
        24
      ],
      "id": "15-304",
      "t": "Purple, Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        53,
        71,
        85
      ],
      "id": "15-305",
      "t": "Blue, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        44,
        59,
        29
      ],
      "id": "15-306",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        55,
        39,
        52
      ],
      "id": "15-308",
      "t": "Blue, Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        132,
        94,
        78
      ],
      "id": "15-310",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        108,
        81,
        58
      ],
      "id": "15-311",
      "t": "Brown, Gold, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        99,
        64,
        83
      ],
      "id": "15-312",
      "t": "Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        91,
        46,
        63
      ],
      "id": "15-313",
      "t": "Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        74,
        29,
        30
      ],
      "id": "15-315",
      "t": "Red, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        62,
        94,
        65
      ],
      "id": "15-331",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        17,
        78,
        56
      ],
      "id": "15-332",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        60,
        60,
        69
      ],
      "id": "15-335",
      "t": "Blue, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        107,
        69,
        63
      ],
      "id": "15-336",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        136,
        97,
        90
      ],
      "id": "15-337",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        57,
        82,
        105
      ],
      "id": "15-339",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        117,
        95,
        95
      ],
      "id": "15-342",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        75,
        92,
        85
      ],
      "id": "15-344",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        47,
        61,
        92
      ],
      "id": "15-346",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        44,
        70,
        81
      ],
      "id": "15-347",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        93,
        75,
        70
      ],
      "id": "15-348",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        99,
        57,
        101
      ],
      "id": "15-352",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        66,
        88,
        165
      ],
      "id": "15-353",
      "t": "Blue, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        185,
        80,
        117
      ],
      "id": "15-355",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        95,
        84,
        117
      ],
      "id": "15-356",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        96,
        104,
        136
      ],
      "id": "15-360",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        146,
        54,
        70
      ],
      "id": "15-363",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        159,
        96,
        105
      ],
      "id": "15-364",
      "t": "Orange, Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        203,
        142,
        137
      ],
      "id": "15-366",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        115,
        83,
        60
      ],
      "id": "15-379",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        11,
        11,
        11
      ],
      "id": "15-401",
      "t": "Black, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        35,
        34,
        34
      ],
      "id": "15-401F",
      "t": "Black, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        61,
        94,
        105
      ],
      "id": "15-401FR",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        37,
        37,
        38
      ],
      "id": "15-401SF",
      "t": "Black, Opaque",
      "dt": "Semi-Frost"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        242,
        240,
        243
      ],
      "id": "15-402",
      "t": "White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        243,
        242,
        247
      ],
      "id": "15-402F",
      "t": "White, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        249,
        223,
        6
      ],
      "id": "15-404",
      "t": "Yellow, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        253,
        133,
        2
      ],
      "id": "15-405",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        253,
        93,
        1
      ],
      "id": "15-406",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        185,
        11,
        27
      ],
      "id": "15-408",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        186,
        17,
        43
      ],
      "id": "15-408F",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        75,
        43,
        35
      ],
      "id": "15-409",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        100,
        89,
        104
      ],
      "id": "15-409FR",
      "t": "Pink, Red, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        155,
        123,
        137
      ],
      "id": "15-410",
      "t": "Purple, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        60,
        123,
        55
      ],
      "id": "15-411",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        99,
        149,
        115
      ],
      "id": "15-411FR",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        44,
        154,
        154
      ],
      "id": "15-412",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        59,
        154,
        157
      ],
      "id": "15-412F",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        82,
        164,
        169
      ],
      "id": "15-412FR",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        73,
        175,
        218
      ],
      "id": "15-413",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        69,
        174,
        222
      ],
      "id": "15-413F",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        34,
        17,
        123
      ],
      "id": "15-414",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        49,
        36,
        141
      ],
      "id": "15-414F",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        75,
        78,
        145
      ],
      "id": "15-414FR",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        106,
        129,
        214
      ],
      "id": "15-417L",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        230,
        156,
        141
      ],
      "id": "15-429",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        163,
        208,
        237
      ],
      "id": "15-430",
      "t": "Blue, Opaque",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        59,
        64,
        75
      ],
      "id": "15-451",
      "t": "Gray, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        34,
        42,
        48
      ],
      "id": "15-452",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        35,
        40,
        33
      ],
      "id": "15-453",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        46,
        38,
        42
      ],
      "id": "15-454",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        37,
        55,
        71
      ],
      "id": "15-455",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        69,
        72,
        83
      ],
      "id": "15-456",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        79,
        59,
        47
      ],
      "id": "15-457",
      "t": "Gold, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        124,
        89,
        58
      ],
      "id": "15-457L",
      "t": "Gold, Transparent",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        47,
        42,
        43
      ],
      "id": "15-458",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        72,
        70,
        50
      ],
      "id": "15-459",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        58,
        34,
        37
      ],
      "id": "15-460",
      "t": "Purple, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        77,
        60,
        50
      ],
      "id": "15-461",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        107,
        84,
        50
      ],
      "id": "15-462",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        48,
        52,
        63
      ],
      "id": "15-469",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        228,
        227,
        232
      ],
      "id": "15-470",
      "t": "Crystal, White, Alabaster",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        239,
        235,
        238
      ],
      "id": "15-471",
      "t": "White, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        241,
        220,
        31
      ],
      "id": "15-472",
      "t": "Yellow, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        192,
        44,
        68
      ],
      "id": "15-476",
      "t": "Red, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        73,
        136,
        99
      ],
      "id": "15-480",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        64,
        155,
        149
      ],
      "id": "15-481",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        63,
        61,
        151
      ],
      "id": "15-484",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        224,
        184,
        137
      ],
      "id": "15-488",
      "t": "Beige, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        233,
        206,
        168
      ],
      "id": "15-492",
      "t": "Beige, White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        235,
        208,
        174
      ],
      "id": "15-492FR",
      "t": "Beige, White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        227,
        191,
        140
      ],
      "id": "15-493",
      "t": "Beige, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        212,
        219,
        237
      ],
      "id": "15-511",
      "t": "White, Alabaster",
      "dt": "Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        243,
        229,
        169
      ],
      "id": "15-514",
      "t": "Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        249,
        199,
        137
      ],
      "id": "15-516",
      "t": "Orange, Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        252,
        201,
        221
      ],
      "id": "15-517",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        230,
        164,
        159
      ],
      "id": "15-519",
      "t": "Pink, Alabaster",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        222,
        151,
        142
      ],
      "id": "15-519D",
      "t": "Pink, Alabaster",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        109,
        187,
        159
      ],
      "id": "15-520",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        157,
        209,
        229
      ],
      "id": "15-522",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        129,
        159,
        210
      ],
      "id": "15-524",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        121,
        116,
        145
      ],
      "id": "15-525",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        141,
        141,
        151
      ],
      "id": "15-526",
      "t": "Gray, Alabaster",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        237,
        210,
        154
      ],
      "id": "15-527",
      "t": "Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        241,
        239,
        246
      ],
      "id": "15-528",
      "t": "White, Alabaster",
      "dt": "Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        76,
        164,
        167
      ],
      "id": "15-536",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        246,
        156,
        142
      ],
      "id": "15-539",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        93,
        124,
        160
      ],
      "id": "15-545",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        230,
        229,
        236
      ],
      "id": "15-550",
      "t": "White, Alabaster",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        198,
        193,
        193
      ],
      "id": "15-551",
      "t": "Silver, Alabaster",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        212,
        159,
        121
      ],
      "id": "15-552",
      "t": "Gold, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        193,
        118,
        116
      ],
      "id": "15-553",
      "t": "Orange, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        201,
        100,
        129
      ],
      "id": "15-556",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        106,
        174,
        166
      ],
      "id": "15-571",
      "t": "Green, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        9,
        152,
        138
      ],
      "id": "15-572",
      "t": "Green, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        64,
        137,
        184
      ],
      "id": "15-573",
      "t": "Blue, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        136,
        107,
        165
      ],
      "id": "15-574",
      "t": "Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        160,
        158,
        171
      ],
      "id": "15-576",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        232,
        219,
        206
      ],
      "id": "15-591",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        226,
        213,
        205
      ],
      "id": "15-592",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        217,
        181,
        151
      ],
      "id": "15-593",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        223,
        184,
        153
      ],
      "id": "15-595",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        241,
        165,
        156
      ],
      "id": "15-596",
      "t": "Pink, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        215,
        177,
        155
      ],
      "id": "15-597",
      "t": "Beige, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        205,
        164,
        178
      ],
      "id": "15-599",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        200,
        194,
        182
      ],
      "id": "15-600",
      "t": "White, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        125,
        95,
        87
      ],
      "id": "15-641",
      "t": "Brown, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        204,
        131,
        125
      ],
      "id": "15-642",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        164,
        91,
        117
      ],
      "id": "15-645",
      "t": "Red, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        77,
        170,
        203
      ],
      "id": "15-647",
      "t": "Blue, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        76,
        112,
        149
      ],
      "id": "15-648",
      "t": "Blue, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        114,
        117,
        184
      ],
      "id": "15-649",
      "t": "Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        104,
        99,
        98
      ],
      "id": "15-650",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        233,
        226,
        226
      ],
      "id": "15-961",
      "t": "Silver, Opaque",
      "dt": "Plating, Silver"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        220,
        213,
        209
      ],
      "id": "15-961F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Silver"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        42,
        66,
        37
      ],
      "id": "15-972",
      "t": "Green, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        39,
        38,
        74
      ],
      "id": "15-973",
      "t": "Blue, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        196,
        189,
        187
      ],
      "id": "15-1001",
      "t": "Silver, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        144,
        129,
        146
      ],
      "id": "15-1012",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        64,
        111,
        92
      ],
      "id": "15-1016",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        73,
        110,
        174
      ],
      "id": "15-1019",
      "t": "Blue, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        123,
        105,
        112
      ],
      "id": "15-1024",
      "t": "Purple, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        96,
        108,
        97
      ],
      "id": "15-1026",
      "t": "Green, Transparent",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        217,
        185,
        143
      ],
      "id": "15-1052",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        203,
        157,
        108
      ],
      "id": "15-1053",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        151,
        152,
        162
      ],
      "id": "15-1105",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        214,
        228,
        128
      ],
      "id": "15-1119",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        124,
        234,
        130
      ],
      "id": "15-1120",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        251,
        190,
        66
      ],
      "id": "15-1121",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        251,
        149,
        121
      ],
      "id": "15-1122",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        69,
        77,
        100
      ],
      "id": "15-1254",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        178,
        6,
        136
      ],
      "id": "15-1310",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        93,
        31,
        56
      ],
      "id": "15-1312",
      "t": "Pink, Purple, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        63,
        27,
        99
      ],
      "id": "15-1314",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        158,
        35,
        31
      ],
      "id": "15-1419",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        107,
        28,
        28
      ],
      "id": "15-1420",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        108,
        86,
        33
      ],
      "id": "15-1421",
      "t": "Yellow, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        27,
        80,
        58
      ],
      "id": "15-1422",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        51,
        59,
        51
      ],
      "id": "15-1423",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        31,
        85,
        86
      ],
      "id": "15-1424",
      "t": "Blue, Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        18,
        73,
        102
      ],
      "id": "15-1425",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        46,
        32,
        61
      ],
      "id": "15-1426",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        45,
        23,
        124
      ],
      "id": "15-1427",
      "t": "Blue, Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        63,
        53,
        62
      ],
      "id": "15-1428",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        47,
        32,
        21
      ],
      "id": "15-1429",
      "t": "Brown, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        125,
        9,
        6
      ],
      "id": "15-1434",
      "t": "Orange, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        42,
        24,
        113
      ],
      "id": "15-1446",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        140,
        32,
        42
      ],
      "id": "15-1464",
      "t": "Red, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        176,
        104,
        32
      ],
      "id": "15-1479",
      "t": "Brown, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        85,
        88,
        172
      ],
      "id": "15-1486",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        49,
        64,
        36
      ],
      "id": "15-1488",
      "t": "Green, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        159,
        134,
        118
      ],
      "id": "15-1521",
      "t": "Gold, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        166,
        115,
        91
      ],
      "id": "15-1522",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        170,
        114,
        143
      ],
      "id": "15-1524",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        170,
        168,
        130
      ],
      "id": "15-1527",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        113,
        98,
        147
      ],
      "id": "15-1531",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        139,
        83,
        93
      ],
      "id": "15-1554",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        27,
        149,
        138
      ],
      "id": "15-1555",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        88,
        72,
        123
      ],
      "id": "15-1558",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        88,
        86,
        95
      ],
      "id": "15-1559",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        129,
        89,
        71
      ],
      "id": "15-1602",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        124,
        85,
        86
      ],
      "id": "15-1606",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        163,
        13,
        3
      ],
      "id": "15-1609",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        31,
        69,
        32
      ],
      "id": "15-1611",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        11,
        94,
        143
      ],
      "id": "15-1614",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        36,
        31,
        157
      ],
      "id": "15-1617",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        114,
        62,
        102
      ],
      "id": "15-1620",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        138,
        49,
        25
      ],
      "id": "15-1621",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        193,
        95,
        13
      ],
      "id": "15-1625",
      "t": "Orange, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        161,
        88,
        81
      ],
      "id": "15-1627",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        95,
        102,
        99
      ],
      "id": "15-1630",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        155,
        135,
        73
      ],
      "id": "15-1631",
      "t": "Yellow, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        160,
        20,
        6
      ],
      "id": "15-1639",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        59,
        83,
        56
      ],
      "id": "15-1642",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        84,
        146,
        157
      ],
      "id": "15-1643",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        56,
        64,
        147
      ],
      "id": "15-1647",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        118,
        72,
        98
      ],
      "id": "15-1650",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        57,
        56,
        109
      ],
      "id": "15-1653",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        88,
        87,
        156
      ],
      "id": "15-1654",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        83,
        66,
        86
      ],
      "id": "15-1655",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        24,
        17,
        122
      ],
      "id": "15-1656",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        81,
        93,
        87
      ],
      "id": "15-1657",
      "t": "Gray, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        187,
        3,
        2
      ],
      "id": "15-1684",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        80,
        122,
        134
      ],
      "id": "15-1685",
      "t": "Blue, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        83,
        90,
        66
      ],
      "id": "15-1816",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        47,
        72,
        76
      ],
      "id": "15-1826",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        76,
        81,
        135
      ],
      "id": "15-1827",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        93,
        61,
        89
      ],
      "id": "15-1834",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        128,
        105,
        88
      ],
      "id": "15-1837",
      "t": "Beige, Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        80,
        68,
        70
      ],
      "id": "15-1839",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        69,
        65,
        66
      ],
      "id": "15-1840",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        125,
        118,
        110
      ],
      "id": "15-1865",
      "t": "Gray, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        158,
        156,
        155
      ],
      "id": "15-1866",
      "t": "Gray, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        165,
        117,
        145
      ],
      "id": "15-1867",
      "t": "Pink, Purple, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        137,
        137,
        131
      ],
      "id": "15-1881",
      "t": "Gray, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        120,
        90,
        68
      ],
      "id": "15-1882",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        102,
        32,
        43
      ],
      "id": "15-1883",
      "t": "Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        85,
        62,
        80
      ],
      "id": "15-1884",
      "t": "Blue, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        134,
        78,
        58
      ],
      "id": "15-1887",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        140,
        130,
        72
      ],
      "id": "15-1889",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        64,
        77,
        74
      ],
      "id": "15-1890",
      "t": "Green, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        109,
        101,
        73
      ],
      "id": "15-1897",
      "t": "Green, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        81,
        60,
        95
      ],
      "id": "15-1899",
      "t": "Blue, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        186,
        8,
        30
      ],
      "id": "15-1943",
      "t": "Red, Opaque",
      "dt": "Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        36,
        32,
        135
      ],
      "id": "15-1945",
      "t": "Blue, Opaque",
      "dt": "Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        40,
        49,
        66
      ],
      "id": "15-1959",
      "t": "Blue, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        48,
        75,
        62
      ],
      "id": "15-1961",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        104,
        89,
        61
      ],
      "id": "15-1981",
      "t": "Iridescent, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        158,
        113,
        64
      ],
      "id": "15-1983",
      "t": "Gold, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        138,
        101,
        79
      ],
      "id": "15-1984",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        166,
        123,
        98
      ],
      "id": "15-1985",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        68,
        77,
        97
      ],
      "id": "15-2001",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        96,
        101,
        110
      ],
      "id": "15-2002",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        58,
        51,
        39
      ],
      "id": "15-2004",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        55,
        43,
        61
      ],
      "id": "15-2005",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        101,
        81,
        65
      ],
      "id": "15-2006",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        79,
        100,
        100
      ],
      "id": "15-2008",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        61,
        87,
        100
      ],
      "id": "15-2009",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        72,
        67,
        66
      ],
      "id": "15-2013",
      "t": "Brown, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        237,
        218,
        189
      ],
      "id": "15-2021",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        226,
        190,
        164
      ],
      "id": "15-2022",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        229,
        182,
        165
      ],
      "id": "15-2023",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        193,
        152,
        174
      ],
      "id": "15-2024",
      "t": "Pink, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        175,
        163,
        181
      ],
      "id": "15-2025",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        117,
        147,
        141
      ],
      "id": "15-2028",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        107,
        160,
        170
      ],
      "id": "15-2029",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        87,
        116,
        141
      ],
      "id": "15-2030",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        95,
        113,
        93
      ],
      "id": "15-2031",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        134,
        118,
        85
      ],
      "id": "15-2032",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        126,
        125,
        87
      ],
      "id": "15-2033",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        162,
        134,
        145
      ],
      "id": "15-2034",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Gold Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        121,
        91,
        87
      ],
      "id": "15-2035",
      "t": "Iridescent, Transparent",
      "dt": "Frosted (Matte), Glazed Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        63,
        65,
        114
      ],
      "id": "15-2039",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        143,
        41,
        49
      ],
      "id": "15-2040",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        82,
        96,
        120
      ],
      "id": "15-2064",
      "t": "Blue, Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        64,
        66,
        74
      ],
      "id": "15-2065",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        59,
        68,
        60
      ],
      "id": "15-2066",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        96,
        125,
        151
      ],
      "id": "15-2074",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        67,
        71,
        120
      ],
      "id": "15-2075",
      "t": "Blue, Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        179,
        60,
        77
      ],
      "id": "15-2076",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        114,
        103,
        100
      ],
      "id": "15-2195",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        157,
        108,
        44
      ],
      "id": "15-2196",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        225,
        166,
        136
      ],
      "id": "15-2197",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        179,
        135,
        120
      ],
      "id": "15-2199",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        214,
        127,
        141
      ],
      "id": "15-2200",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        172,
        118,
        150
      ],
      "id": "15-2201",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        138,
        79,
        138
      ],
      "id": "15-2202",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        86,
        151,
        205
      ],
      "id": "15-2205",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        58,
        115,
        176
      ],
      "id": "15-2206",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        133,
        191,
        213
      ],
      "id": "15-2207",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        75,
        146,
        151
      ],
      "id": "15-2208",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        169,
        167,
        184
      ],
      "id": "15-2209",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        109,
        113,
        120
      ],
      "id": "15-2210",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        177,
        212,
        225
      ],
      "id": "15-2212",
      "t": "Blue, Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        88,
        85,
        83
      ],
      "id": "15-2213",
      "t": "Iridescent, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        163,
        109,
        38
      ],
      "id": "15-2238",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        86,
        129,
        56
      ],
      "id": "15-2240",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        26,
        71,
        67
      ],
      "id": "15-2241",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        50,
        76,
        75
      ],
      "id": "15-2242",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        40,
        28,
        111
      ],
      "id": "15-2243",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        52,
        49,
        89
      ],
      "id": "15-2244",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        104,
        50,
        101
      ],
      "id": "15-2247",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        170,
        6,
        18
      ],
      "id": "15-2248",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        63,
        32,
        41
      ],
      "id": "15-2249",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        101,
        122,
        86
      ],
      "id": "15-2318",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        135,
        104,
        111
      ],
      "id": "15-2331",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        97,
        107,
        120
      ],
      "id": "15-2333",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 229, 207, 188 ],
      "id": "15-2370",
      "t": "Light Pearl",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 202, 177, 150 ],
      "id": "15-2371",
      "t": "Pearl",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 162, 142, 109 ],
      "id": "15-2372",
      "t": "Dark Pearl",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 167, 143, 149 ],
      "id": "15-2373",
      "t": "Thistle",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 143, 146, 114 ],
      "id": "15-2374",
      "t": "Lilac",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 140, 156, 135 ],
      "id": "15-2375",
      "t": "Sage",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 136, 158, 159 ],
      "id": "15-2376",
      "t": "Ocean",
      "dt": "Gem Stone Coating"
    },

    {
      "a": 2,
      "b": 2,
      "c": [ 154, 150, 171 ],
      "id": "15-2377",
      "t": "Cyan",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 136, 148, 161 ],
      "id": "15-2378",
      "t": "Purple",
      "dt": "Gem Stone Coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        7,
        86,
        80
      ],
      "id": "15-2405",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        3,
        96,
        91
      ],
      "id": "15-2405F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        14,
        119,
        135
      ],
      "id": "15-2405FR",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        50,
        60,
        69
      ],
      "id": "15-2411",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        150,
        90,
        38
      ],
      "id": "15-2422F",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        27,
        102,
        101
      ],
      "id": "15-2425",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        26,
        112,
        105
      ],
      "id": "15-2425F",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        84,
        86,
        83
      ],
      "id": "15-2426",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        71,
        144,
        171
      ],
      "id": "15-2429",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        92,
        113,
        171
      ],
      "id": "15-2431",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        183,
        134,
        100
      ],
      "id": "15-2439",
      "t": "Brown, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        116,
        119,
        125
      ],
      "id": "15-2440",
      "t": "Blue, Gray, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        105,
        63,
        61
      ],
      "id": "15-2441",
      "t": "Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        218,
        204,
        190
      ],
      "id": "15-2442",
      "t": "Crystal, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        89,
        100,
        111
      ],
      "id": "15-2444",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        86,
        128,
        120
      ],
      "id": "15-2445",
      "t": "Green, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        119,
        89,
        74
      ],
      "id": "15-2449",
      "t": "Gold, Iridescent, Transparent",
      "dt": "Metallic"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        104,
        161,
        182
      ],
      "id": "15-2470",
      "t": "Blue, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        166,
        112,
        120
      ],
      "id": "15-2601",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        80,
        148,
        152
      ],
      "id": "15-2605",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        78,
        132,
        170
      ],
      "id": "15-2606",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        131,
        115,
        98
      ],
      "id": "15-3051",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        119,
        109,
        115
      ],
      "id": "15-3056",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        198,
        179,
        137
      ],
      "id": "15-4201",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        243,
        228,
        189
      ],
      "id": "15-4201F",
      "t": "Silver, White, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        222,
        180,
        107
      ],
      "id": "15-4202",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        207,
        159,
        92
      ],
      "id": "15-4202F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        185,
        127,
        55
      ],
      "id": "15-4203",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        207,
        140,
        82
      ],
      "id": "15-4203F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        173,
        139,
        104
      ],
      "id": "15-4204",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        184,
        147,
        104
      ],
      "id": "15-4204F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        209,
        189,
        70
      ],
      "id": "15-4205",
      "t": "Yellow, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        218,
        140,
        93
      ],
      "id": "15-4206",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        197,
        122,
        101
      ],
      "id": "15-4207",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        166,
        55,
        49
      ],
      "id": "15-4208",
      "t": "Red, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        175,
        113,
        116
      ],
      "id": "15-4209",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        184,
        101,
        137
      ],
      "id": "15-4210",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        177,
        64,
        81
      ],
      "id": "15-4211",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        136,
        63,
        52
      ],
      "id": "15-4212",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        129,
        99,
        91
      ],
      "id": "15-4213",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        123,
        182,
        136
      ],
      "id": "15-4214",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        102,
        131,
        114
      ],
      "id": "15-4215",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        131,
        150,
        150
      ],
      "id": "15-4216",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        62,
        125,
        124
      ],
      "id": "15-4217",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        159,
        105,
        130
      ],
      "id": "15-4218",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        146,
        89,
        112
      ],
      "id": "15-4219",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        124,
        94,
        119
      ],
      "id": "15-4220",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        136,
        130,
        112
      ],
      "id": "15-4221",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        113,
        98,
        83
      ],
      "id": "15-4222",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 26, 26, 185 ],
      "id": "15-4281",
      "t": "Navy Blue",
      "dt": "Duracoat, Silverline Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [ 38, 38, 84 ],
      "id": "15-4282",
      "t": "Navy Blue",
      "dt": "Duracoat, Silverline Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        252,
        173,
        141
      ],
      "id": "15-4298",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        251,
        129,
        188
      ],
      "id": "15-4299",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 1,
      "c": [
        102,
        173,
        222
      ],
      "id": "15-4300",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        248,
        77,
        166
      ],
      "id": "15-4301",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        213,
        104,
        200
      ],
      "id": "15-4302",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 3,
      "c": [
        189,
        101,
        210
      ],
      "id": "15-4303",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        243,
        233,
        164
      ],
      "id": "15-4451",
      "t": "Yellow Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        228,
        185,
        95
      ],
      "id": "15-4452",
      "t": "Gold Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        247,
        167,
        39
      ],
      "id": "15-4453",
      "t": "Orange Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        249,
        144,
        52
      ],
      "id": "15-4454",
      "t": "Orange Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        149,
        121,
        99
      ],
      "id": "15-4455",
      "t": "Coffee Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        172,
        108,
        28
      ],
      "id": "15-4456",
      "t": "Tan Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        158,
        108,
        67
      ],
      "id": "15-4457",
      "t": "Rust Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        142,
        78,
        35
      ],
      "id": "15-4458",
      "t": "Chocolate Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        121,
        72,
        19
      ],
      "id": "15-4459",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        139,
        86,
        36
      ],
      "id": "15-4460",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        250,
        178,
        154
      ],
      "id": "15-4461",
      "t": "Rose Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        249,
        145,
        130
      ],
      "id": "15-4462",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        243,
        164,
        165
      ],
      "id": "15-4463",
      "t": "Rose Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        191,
        108,
        101
      ],
      "id": "15-4464",
      "t": "Salmon Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        218,
        118,
        127
      ],
      "id": "15-4465",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        242,
        164,
        183
      ],
      "id": "15-4466",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        249,
        128,
        156
      ],
      "id": "15-4467",
      "t": "Pink Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        157,
        75,
        103
      ],
      "id": "15-4468",
      "t": "Blackberry Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        119,
        30,
        32
      ],
      "id": "15-4469",
      "t": "Red Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        96,
        26,
        22
      ],
      "id": "15-4470",
      "t": "Maroon Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        141,
        202,
        66
      ],
      "id": "15-4471",
      "t": "Lime Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        103,
        199,
        183
      ],
      "id": "15-4472",
      "t": "Cyan Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        144,
        160,
        105
      ],
      "id": "15-4473",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        130,
        137,
        91
      ],
      "id": "15-4474",
      "t": "Olive Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        77,
        167,
        141
      ],
      "id": "15-4475",
      "t": "Teal Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        57,
        149,
        71
      ],
      "id": "15-4476",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        53,
        122,
        91
      ],
      "id": "15-4477",
      "t": "Green Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        69,
        194,
        182
      ],
      "id": "15-4478",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        93,
        146,
        152
      ],
      "id": "15-4479",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        40,
        154,
        177
      ],
      "id": "15-4480",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        65,
        98,
        94
      ],
      "id": "15-4481",
      "t": "Teal Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        85,
        128,
        152
      ],
      "id": "15-4482",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        19,
        114,
        135
      ],
      "id": "15-4483",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        20,
        104,
        179
      ],
      "id": "15-4484",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        47,
        112,
        142
      ],
      "id": "15-4485",
      "t": "Blue Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        143,
        129,
        170
      ],
      "id": "15-4486",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        142,
        101,
        115
      ],
      "id": "15-4487",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        144,
        113,
        169
      ],
      "id": "15-4488",
      "t": "Purple Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        125,
        99,
        115
      ],
      "id": "15-4489",
      "t": "Lavender Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        98,
        70,
        103
      ],
      "id": "15-4490",
      "t": "Violet Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        106,
        96,
        49
      ],
      "id": "15-4491",
      "t": "Olive Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 2,
      "c": [
        100,
        68,
        43
      ],
      "id": "15-4492",
      "t": "Brown Duracoat Opaque",
      "dt": "Dyed Color, Extra durable coating"
    },
    {
      "a": 2,
      "b": 1,
      "c": [ 26, 26, 185 ],
      "id": "15-4493",
      "t": "Navy Blue",
      "dt": "Duracoat, Opaque Dyed"
    },
    {
      "a": 2,
      "b": 1,
      "c": [ 38, 38, 84 ],
      "id": "15-4494",
      "t": "Navy Blue",
      "dt": "Duracoat, Opaque Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        44,
        47,
        58
      ],
      "id": "DB1",
      "t": "Gray, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        32,
        46,
        57
      ],
      "id": "DB2",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        59,
        60,
        47
      ],
      "id": "DB3",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        32,
        30,
        33
      ],
      "id": "DB4",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        48,
        61,
        83
      ],
      "id": "DB5",
      "t": "Iridescent, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        69,
        79,
        90
      ],
      "id": "DB6",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        45,
        38,
        29
      ],
      "id": "DB7",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        12,
        12,
        13
      ],
      "id": "DB10",
      "t": "Black, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        48,
        46,
        29
      ],
      "id": "DB11",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        50,
        23,
        24
      ],
      "id": "DB12",
      "t": "Purple, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        129,
        120,
        117
      ],
      "id": "DB21",
      "t": "Silver, Opaque",
      "dt": "Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        84,
        66,
        50
      ],
      "id": "DB22",
      "t": "Gold, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        120,
        83,
        60
      ],
      "id": "DB22L",
      "t": "Gold, Transparent",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        72,
        55
      ],
      "id": "DB23",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        94,
        78
      ],
      "id": "DB24",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        46,
        59,
        72
      ],
      "id": "DB25",
      "t": "Blue, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        71,
        67,
        58
      ],
      "id": "DB26",
      "t": "Gray, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        62,
        88,
        76
      ],
      "id": "DB27",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        110,
        92,
        80
      ],
      "id": "DB29",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Nickel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        193,
        148,
        73
      ],
      "id": "DB31",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        177,
        128,
        69
      ],
      "id": "DB33",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        177,
        140,
        92
      ],
      "id": "DB34",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        191,
        180,
        162
      ],
      "id": "DB35",
      "t": "Silver, Transparent",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        139,
        104,
        96
      ],
      "id": "DB37",
      "t": "Pink, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        157,
        149,
        147
      ],
      "id": "DB38",
      "t": "Silver, Opaque",
      "dt": "Plating, Palladium"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        156,
        97,
        83
      ],
      "id": "DB40",
      "t": "Brown, Opaque",
      "dt": "Plating, Copper"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        199,
        193,
        193
      ],
      "id": "DB41",
      "t": "Silver, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        185,
        144,
        88
      ],
      "id": "DB42",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        187,
        46,
        14
      ],
      "id": "DB43",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        89,
        139,
        164
      ],
      "id": "DB44",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        208,
        110,
        32
      ],
      "id": "DB45",
      "t": "Orange, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        58,
        94,
        53
      ],
      "id": "DB46",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        44,
        40,
        120
      ],
      "id": "DB47",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        101,
        101,
        100
      ],
      "id": "DB48",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        216,
        215,
        226
      ],
      "id": "DB50",
      "t": "Crystal, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        213,
        214,
        228
      ],
      "id": "DB51",
      "t": "Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        239,
        218,
        211
      ],
      "id": "DB52",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        246,
        209,
        132
      ],
      "id": "DB53",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        189,
        121,
        108
      ],
      "id": "DB54",
      "t": "Brown, Orange, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        233,
        213,
        226
      ],
      "id": "DB55",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        131,
        108,
        129
      ],
      "id": "DB56",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        76,
        158,
        194
      ],
      "id": "DB57",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        82,
        123,
        145
      ],
      "id": "DB58",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        89,
        92,
        113
      ],
      "id": "DB59",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        75,
        115,
        119
      ],
      "id": "DB60",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        78,
        56,
        54
      ],
      "id": "DB61",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        139,
        46,
        65
      ],
      "id": "DB62",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        66,
        79,
        172
      ],
      "id": "DB63",
      "t": "Blue, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        98,
        90,
        85
      ],
      "id": "DB64",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        145,
        89,
        33
      ],
      "id": "DB65",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        227,
        223,
        221
      ],
      "id": "DB66",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        220,
        155,
        124
      ],
      "id": "DB67",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        219,
        141,
        126
      ],
      "id": "DB68",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        172,
        130,
        116
      ],
      "id": "DB69",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        222,
        115,
        122
      ],
      "id": "DB70",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        224,
        203,
        219
      ],
      "id": "DB71",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        181,
        121,
        157
      ],
      "id": "DB72",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        132,
        71,
        141
      ],
      "id": "DB73",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        148,
        61,
        118
      ],
      "id": "DB74",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        207,
        94,
        124
      ],
      "id": "DB75",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        71,
        147,
        200
      ],
      "id": "DB76",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        35,
        95,
        167
      ],
      "id": "DB77",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        162,
        204,
        216
      ],
      "id": "DB78",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        66,
        148,
        155
      ],
      "id": "DB79",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        173,
        164,
        182
      ],
      "id": "DB80",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        110,
        114,
        120
      ],
      "id": "DB81",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        223,
        216,
        226
      ],
      "id": "DB82",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        182,
        213,
        225
      ],
      "id": "DB83",
      "t": "Blue, Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        107,
        130,
        141
      ],
      "id": "DB84",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        52,
        74,
        94
      ],
      "id": "DB85",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        59,
        74,
        92
      ],
      "id": "DB86",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        90,
        70,
        60
      ],
      "id": "DB87",
      "t": "Iridescent, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        138,
        95,
        69
      ],
      "id": "DB88",
      "t": "Purple, Red, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        97,
        87,
        75
      ],
      "id": "DB89",
      "t": "Green, Iridescent, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        118,
        92,
        89
      ],
      "id": "DB91",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        179,
        50,
        60
      ],
      "id": "DB98",
      "t": "Red, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        192,
        134,
        87
      ],
      "id": "DB99",
      "t": "Brown, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        202,
        144,
        96
      ],
      "id": "DB100",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        186,
        132,
        96
      ],
      "id": "DB101",
      "t": "Brown, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        122,
        90,
        69
      ],
      "id": "DB102",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        109,
        70,
        68
      ],
      "id": "DB103",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        82,
        59,
        71
      ],
      "id": "DB104",
      "t": "Pink, Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        80,
        40,
        46
      ],
      "id": "DB105",
      "t": "Purple, Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        210,
        135,
        131
      ],
      "id": "DB106",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        120,
        123,
        129
      ],
      "id": "DB107",
      "t": "Blue, Gray, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        97,
        68,
        68
      ],
      "id": "DB108",
      "t": "Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        222,
        209,
        180
      ],
      "id": "DB109",
      "t": "Crystal, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        144,
        155,
        167
      ],
      "id": "DB110",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        90,
        95,
        102
      ],
      "id": "DB111",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        73,
        112,
        117
      ],
      "id": "DB112",
      "t": "Green, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        53,
        110,
        157
      ],
      "id": "DB113",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        133,
        131,
        127
      ],
      "id": "DB114",
      "t": "Gray, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        129,
        90,
        58
      ],
      "id": "DB115",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        89,
        37,
        35
      ],
      "id": "DB116",
      "t": "Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        78,
        59,
        67
      ],
      "id": "DB117",
      "t": "Blue, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        134,
        83,
        39
      ],
      "id": "DB118",
      "t": "Yellow, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        137,
        83,
        41
      ],
      "id": "DB119",
      "t": "Yellow, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        93,
        45,
        48
      ],
      "id": "DB120",
      "t": "Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        108,
        73,
        43
      ],
      "id": "DB121",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        90,
        82,
        82
      ],
      "id": "DB122",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        76,
        62,
        49
      ],
      "id": "DB123",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        148,
        132,
        89
      ],
      "id": "DB124",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        68,
        81,
        74
      ],
      "id": "DB125",
      "t": "Green, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        100,
        76,
        71
      ],
      "id": "DB126",
      "t": "Gold, Iridescent, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        93,
        81,
        86
      ],
      "id": "DB127",
      "t": "Green, Iridescent, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        83,
        74,
        84
      ],
      "id": "DB128",
      "t": "Iridescent, Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        93,
        66,
        75
      ],
      "id": "DB129",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        74,
        68,
        55
      ],
      "id": "DB131",
      "t": "Green, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        82,
        86,
        103
      ],
      "id": "DB132",
      "t": "Blue, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        120,
        102,
        63
      ],
      "id": "DB133",
      "t": "Green, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        88,
        88,
        105
      ],
      "id": "DB134",
      "t": "Iridescent, Purple, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        72,
        62,
        100
      ],
      "id": "DB135",
      "t": "Blue, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        198,
        196,
        205
      ],
      "id": "DB141",
      "t": "Crystal, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        108,
        57,
        31
      ],
      "id": "DB144",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        198,
        174,
        36
      ],
      "id": "DB145",
      "t": "Yellow, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        128,
        100,
        94
      ],
      "id": "DB146",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        181,
        182,
        79
      ],
      "id": "DB147",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        43,
        71,
        47
      ],
      "id": "DB148",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        79,
        105,
        105
      ],
      "id": "DB149",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        94,
        72,
        58
      ],
      "id": "DB150",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        231,
        106,
        43
      ],
      "id": "DB151",
      "t": "Orange, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        35,
        107,
        76
      ],
      "id": "DB152",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        245,
        208,
        172
      ],
      "id": "DB157",
      "t": "Beige, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        167,
        139,
        159
      ],
      "id": "DB158",
      "t": "Purple, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        225,
        55,
        66
      ],
      "id": "DB159",
      "t": "Red, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        244,
        231,
        33
      ],
      "id": "DB160",
      "t": "Yellow, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        231,
        86,
        42
      ],
      "id": "DB161",
      "t": "Orange, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        165,
        40,
        60
      ],
      "id": "DB162",
      "t": "Red, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        93,
        144,
        90
      ],
      "id": "DB163",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        72,
        165,
        217
      ],
      "id": "DB164",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        47,
        42,
        142
      ],
      "id": "DB165",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        75,
        164,
        162
      ],
      "id": "DB166",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        111,
        135,
        216
      ],
      "id": "DB167",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        116,
        118,
        119
      ],
      "id": "DB168",
      "t": "Gray, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        167,
        188,
        98
      ],
      "id": "DB169",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        113,
        82,
        91
      ],
      "id": "DB170",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        224,
        187,
        87
      ],
      "id": "DB171",
      "t": "Yellow, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        171,
        28,
        48
      ],
      "id": "DB172",
      "t": "Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        115,
        99,
        122
      ],
      "id": "DB173",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        160,
        178,
        88
      ],
      "id": "DB174",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        40,
        94,
        88
      ],
      "id": "DB175",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        82,
        156,
        225
      ],
      "id": "DB176",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        27,
        105,
        161
      ],
      "id": "DB177",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        56,
        60,
        146
      ],
      "id": "DB178",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        100,
        121,
        138
      ],
      "id": "DB179",
      "t": "Gray, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        83,
        74,
        75
      ],
      "id": "DB180",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        147,
        91,
        55
      ],
      "id": "DB181",
      "t": "Brown, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        55,
        72,
        44
      ],
      "id": "DB182",
      "t": "Green, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        46,
        41,
        83
      ],
      "id": "DB183",
      "t": "Blue, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        85,
        72,
        68
      ],
      "id": "DB184",
      "t": "Brown, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        170,
        137,
        134
      ],
      "id": "DB191",
      "t": "Pink, Alabaster",
      "dt": "Copperline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        245,
        242,
        249
      ],
      "id": "DB200",
      "t": "White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        238,
        236,
        240
      ],
      "id": "DB201",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        243,
        237,
        239
      ],
      "id": "DB202",
      "t": "White, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        240,
        222,
        203
      ],
      "id": "DB203",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        224,
        190,
        164
      ],
      "id": "DB204",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        217,
        170,
        134
      ],
      "id": "DB205",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        245,
        177,
        157
      ],
      "id": "DB206",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        241,
        160,
        147
      ],
      "id": "DB207",
      "t": "Pink, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        221,
        170,
        140
      ],
      "id": "DB208",
      "t": "Beige, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        192,
        197,
        210
      ],
      "id": "DB209",
      "t": "Gray, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        194,
        142,
        164
      ],
      "id": "DB210",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        218,
        208,
        199
      ],
      "id": "DB211",
      "t": "White, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        175,
        19,
        38
      ],
      "id": "DB214",
      "t": "Red, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        76,
        162,
        202
      ],
      "id": "DB215",
      "t": "Blue, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        37,
        41,
        137
      ],
      "id": "DB216",
      "t": "Blue, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        95,
        163,
        182
      ],
      "id": "DB217",
      "t": "Blue, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        97,
        158,
        187
      ],
      "id": "DB218",
      "t": "Blue, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        230,
        226,
        232
      ],
      "id": "DB220",
      "t": "White, Alabaster",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        202,
        193,
        190
      ],
      "id": "DB221",
      "t": "Silver, Alabaster",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        229,
        227,
        233
      ],
      "id": "DB222",
      "t": "Crystal, Alabaster",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        189,
        184,
        182
      ],
      "id": "DB223",
      "t": "Silver, Alabaster",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        189,
        146,
        111
      ],
      "id": "DB230",
      "t": "Gold, Alabaster",
      "dt": "Goldline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        223,
        222,
        233
      ],
      "id": "DB231",
      "t": "White, Alabaster",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        242,
        225,
        149
      ],
      "id": "DB232",
      "t": "Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        242,
        182,
        103
      ],
      "id": "DB233",
      "t": "Orange, Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        244,
        185,
        190
      ],
      "id": "DB234",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        237,
        128,
        116
      ],
      "id": "DB235",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        219,
        110,
        132
      ],
      "id": "DB236",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        142,
        202,
        168
      ],
      "id": "DB237",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        63,
        152,
        148
      ],
      "id": "DB238",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        125,
        202,
        235
      ],
      "id": "DB239",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        79,
        120,
        215
      ],
      "id": "DB240",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        168,
        159,
        188
      ],
      "id": "DB241",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        119,
        123,
        143
      ],
      "id": "DB242",
      "t": "Gray, Alabaster",
      "dt": "Color-Lined, Glazed Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        104,
        115,
        165
      ],
      "id": "DB243",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        251,
        198,
        225
      ],
      "id": "DB244",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        251,
        177,
        219
      ],
      "id": "DB245",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        253,
        150,
        203
      ],
      "id": "DB246",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        218,
        105,
        195
      ],
      "id": "DB247",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        220,
        156,
        221
      ],
      "id": "DB248",
      "t": "Pink, Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        123,
        100,
        179
      ],
      "id": "DB249",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        102,
        94,
        138
      ],
      "id": "DB250",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        161,
        157,
        148
      ],
      "id": "DB251",
      "t": "Gray, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        166,
        167,
        171
      ],
      "id": "DB252",
      "t": "Gray, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        163,
        119,
        148
      ],
      "id": "DB253",
      "t": "Pink, Purple, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        105,
        93,
        81
      ],
      "id": "DB254",
      "t": "Brown, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        161,
        133,
        131
      ],
      "id": "DB256",
      "t": "Brown, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        155,
        169,
        208
      ],
      "id": "DB257",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        203,
        192,
        176
      ],
      "id": "DB261",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        175,
        178,
        92
      ],
      "id": "DB262",
      "t": "Green, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        120,
        125,
        87
      ],
      "id": "DB263",
      "t": "Green, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        85,
        113,
        117
      ],
      "id": "DB264",
      "t": "Green, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        133,
        101,
        122
      ],
      "id": "DB265",
      "t": "Purple, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        105,
        122,
        153
      ],
      "id": "DB266",
      "t": "Blue, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        102,
        134
      ],
      "id": "DB267",
      "t": "Blue, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        99,
        98,
        102
      ],
      "id": "DB268",
      "t": "Gray, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        177,
        178,
        187
      ],
      "id": "DB271",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        161,
        111,
        54
      ],
      "id": "DB272",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        74,
        80,
        64
      ],
      "id": "DB273",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        67,
        116,
        45
      ],
      "id": "DB274",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        39,
        66,
        69
      ],
      "id": "DB275",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        51,
        64,
        93
      ],
      "id": "DB276",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        53,
        46,
        92
      ],
      "id": "DB277",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        63,
        62,
        77
      ],
      "id": "DB278",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        63,
        61,
        69
      ],
      "id": "DB279",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        106,
        46,
        54
      ],
      "id": "DB280",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        120,
        62,
        117
      ],
      "id": "DB281",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        55,
        62
      ],
      "id": "DB282",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        129,
        71,
        79
      ],
      "id": "DB283",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        80,
        82,
        139
      ],
      "id": "DB284",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        62,
        80,
        141
      ],
      "id": "DB285",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        56,
        73,
        85
      ],
      "id": "DB286",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        109,
        79,
        69
      ],
      "id": "DB287",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        134,
        106,
        84
      ],
      "id": "DB288",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        138,
        43,
        44
      ],
      "id": "DB295",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        69,
        40,
        44
      ],
      "id": "DB296",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        58,
        35,
        38
      ],
      "id": "DB297",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        97,
        113
      ],
      "id": "DB301",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        91,
        97
      ],
      "id": "DB306",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        106,
        105,
        104
      ],
      "id": "DB307",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        50,
        49,
        49
      ],
      "id": "DB310",
      "t": "Black, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        80,
        72,
        67
      ],
      "id": "DB311",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        86,
        69,
        83
      ],
      "id": "DB312",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        145,
        136,
        135
      ],
      "id": "DB321",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        102,
        83,
        66
      ],
      "id": "DB322",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        79,
        74,
        87
      ],
      "id": "DB323",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        113,
        110,
        95
      ],
      "id": "DB324",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        58,
        70,
        79
      ],
      "id": "DB325",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        77,
        79,
        68
      ],
      "id": "DB327",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        214,
        174,
        129
      ],
      "id": "DB331",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        178,
        146,
        117
      ],
      "id": "DB334",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        207,
        194,
        175
      ],
      "id": "DB335",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Galvanized"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        148,
        141,
        142
      ],
      "id": "DB338",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Plating, Palladium"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        155,
        111,
        102
      ],
      "id": "DB340",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Plating, Copper"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        242,
        238,
        244
      ],
      "id": "DB351",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        238,
        227,
        208
      ],
      "id": "DB352",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        230,
        196,
        169
      ],
      "id": "DB353",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        226,
        184,
        171
      ],
      "id": "DB354",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        183,
        141,
        163
      ],
      "id": "DB355",
      "t": "Pink, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        175,
        162,
        182
      ],
      "id": "DB356",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        203,
        203,
        217
      ],
      "id": "DB357",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        85,
        87,
        164
      ],
      "id": "DB361",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        183,
        53,
        91
      ],
      "id": "DB362",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        142,
        127,
        86
      ],
      "id": "DB371",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        126,
        119,
        91
      ],
      "id": "DB372",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        102,
        121,
        112
      ],
      "id": "DB373",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        125,
        150,
        147
      ],
      "id": "DB374",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        105,
        154,
        164
      ],
      "id": "DB375",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        114,
        128,
        156
      ],
      "id": "DB376",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        79,
        83,
        129
      ],
      "id": "DB377",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        135,
        46,
        46
      ],
      "id": "DB378",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        168,
        135,
        142
      ],
      "id": "DB379",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Gold Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        114,
        87,
        85
      ],
      "id": "DB380",
      "t": "Iridescent, Transparent",
      "dt": "Frosted (Matte), Glazed Luster, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        116,
        128,
        150
      ],
      "id": "DB381",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        191,
        160,
        112
      ],
      "id": "DB382",
      "t": "Beige, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        144,
        139,
        129
      ],
      "id": "DB383",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        85,
        74,
        61
      ],
      "id": "DB384",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        105,
        136,
        132
      ],
      "id": "DB385",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        75,
        67,
        82
      ],
      "id": "DB386",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        72,
        81,
        90
      ],
      "id": "DB387",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        197,
        183,
        160
      ],
      "id": "DB388",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        207,
        161,
        131
      ],
      "id": "DB389",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        141,
        124,
        93
      ],
      "id": "DB390",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        110,
        113,
        85
      ],
      "id": "DB391",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        196,
        144,
        91
      ],
      "id": "DB410",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        215,
        174,
        151
      ],
      "id": "DB411",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        174,
        152,
        92
      ],
      "id": "DB412",
      "t": "Yellow, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        146,
        160,
        133
      ],
      "id": "DB413",
      "t": "Green, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        112,
        145,
        142
      ],
      "id": "DB414",
      "t": "Blue, Green, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        117,
        151,
        142
      ],
      "id": "DB415",
      "t": "Blue, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        110,
        145,
        151
      ],
      "id": "DB416",
      "t": "Blue, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        180,
        158,
        154
      ],
      "id": "DB417",
      "t": "Pink, Silver, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        197,
        157,
        159
      ],
      "id": "DB418",
      "t": "Pink, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        167,
        144,
        158
      ],
      "id": "DB419",
      "t": "Pink, Purple, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        185,
        104,
        124
      ],
      "id": "DB420",
      "t": "Pink, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        149,
        75,
        32
      ],
      "id": "DB421",
      "t": "Orange, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        154,
        57,
        146
      ],
      "id": "DB422",
      "t": "Pink, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        164,
        94,
        100
      ],
      "id": "DB423",
      "t": "Orange, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        195,
        168,
        58
      ],
      "id": "DB424",
      "t": "Yellow, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        165,
        63,
        144
      ],
      "id": "DB425",
      "t": "Pink, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        75,
        143,
        129
      ],
      "id": "DB426",
      "t": "Green, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        39,
        110,
        126
      ],
      "id": "DB427",
      "t": "Blue, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        171,
        79,
        95
      ],
      "id": "DB428",
      "t": "Red, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        163,
        145,
        159
      ],
      "id": "DB429",
      "t": "Purple, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        117,
        95,
        144
      ],
      "id": "DB430",
      "t": "Purple, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        134,
        62,
        143
      ],
      "id": "DB431",
      "t": "Pink, Purple, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        84,
        113,
        118
      ],
      "id": "DB432",
      "t": "Blue, Green, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        185,
        148,
        118
      ],
      "id": "DB433",
      "t": "Beige, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        202,
        149,
        122
      ],
      "id": "DB434",
      "t": "Beige, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        193,
        129,
        135
      ],
      "id": "DB435",
      "t": "Pink, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        140,
        125,
        105
      ],
      "id": "DB436",
      "t": "Silver, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        44,
        59,
        77
      ],
      "id": "DB451",
      "t": "Blue, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        100,
        95,
        89
      ],
      "id": "DB452",
      "t": "Gray, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        77,
        81,
        94
      ],
      "id": "DB453",
      "t": "Gray, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        110,
        87,
        93
      ],
      "id": "DB454",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        73,
        61,
        74
      ],
      "id": "DB455",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        123,
        105,
        69
      ],
      "id": "DB456",
      "t": "Green, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        85,
        87,
        83
      ],
      "id": "DB457",
      "t": "Green, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        60,
        88,
        79
      ],
      "id": "DB458",
      "t": "Green, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        36,
        69,
        93
      ],
      "id": "DB459",
      "t": "Blue, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        96,
        62,
        48
      ],
      "id": "DB460",
      "t": "Brown, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        92,
        49,
        19
      ],
      "id": "DB461",
      "t": "Brown, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        123,
        94,
        96
      ],
      "id": "DB462",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        79,
        33,
        76
      ],
      "id": "DB463",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        71,
        57,
        81
      ],
      "id": "DB464",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        47,
        59,
        66
      ],
      "id": "DB465",
      "t": "Blue, Opaque",
      "dt": "Outside-Dyed, Plating, Nickel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        166,
        122,
        55
      ],
      "id": "DB501",
      "t": "Gold, Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        119,
        80,
        42
      ],
      "id": "DB505",
      "t": "Gold, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        120,
        70,
        42
      ],
      "id": "DB506",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        151,
        111,
        73
      ],
      "id": "DB507",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        132,
        129,
        90
      ],
      "id": "DB508",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        63,
        84,
        109
      ],
      "id": "DB514",
      "t": "Blue, Opaque",
      "dt": "Plating, Rainbow, Nickel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        133,
        113,
        121
      ],
      "id": "DB541",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Palladium"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        98,
        87,
        90
      ],
      "id": "DB542",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Palladium"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        91,
        89,
        117
      ],
      "id": "DB543",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Palladium"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        111,
        121,
        134
      ],
      "id": "DB544",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Palladium"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        109,
        121,
        126
      ],
      "id": "DB545",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Palladium"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        152,
        144,
        129
      ],
      "id": "DB546",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Palladium"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        207,
        200,
        189
      ],
      "id": "DB551",
      "t": "Silver, Opaque",
      "dt": "Plating, Silver"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        229,
        219,
        209
      ],
      "id": "DB551F",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Silver"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        105,
        43,
        43
      ],
      "id": "DB601",
      "t": "Orange, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        156,
        33,
        42
      ],
      "id": "DB602",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        115,
        33,
        26
      ],
      "id": "DB603",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        88,
        77,
        44
      ],
      "id": "DB604",
      "t": "Yellow, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        26,
        76,
        52
      ],
      "id": "DB605",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        70,
        73,
        73
      ],
      "id": "DB606",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        45,
        93,
        95
      ],
      "id": "DB607",
      "t": "Blue, Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        40,
        63,
        74
      ],
      "id": "DB608",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        63,
        46,
        76
      ],
      "id": "DB609",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        57,
        34,
        108
      ],
      "id": "DB610",
      "t": "Blue, Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        60,
        37,
        52
      ],
      "id": "DB611",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        80,
        54,
        32
      ],
      "id": "DB612",
      "t": "Brown, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        56,
        53,
        47
      ],
      "id": "DB613",
      "t": "Gray, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        214,
        171,
        128
      ],
      "id": "DB621",
      "t": "Gold, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        183,
        118,
        104
      ],
      "id": "DB622",
      "t": "Orange, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        199,
        173,
        83
      ],
      "id": "DB623",
      "t": "Yellow, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        213,
        166,
        161
      ],
      "id": "DB624",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        211,
        140,
        163
      ],
      "id": "DB625",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        116,
        182,
        177
      ],
      "id": "DB626",
      "t": "Green, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        62,
        156,
        141
      ],
      "id": "DB627",
      "t": "Green, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        162,
        185
      ],
      "id": "DB628",
      "t": "Blue, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        169,
        141,
        183
      ],
      "id": "DB629",
      "t": "Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        131,
        122,
        117
      ],
      "id": "DB630",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        106,
        100,
        100
      ],
      "id": "DB631",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        237,
        236,
        244
      ],
      "id": "DB635",
      "t": "White, Silk",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        241,
        149,
        17
      ],
      "id": "DB651",
      "t": "Orange, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        120,
        118,
        120
      ],
      "id": "DB652",
      "t": "Gray, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        162,
        105,
        10
      ],
      "id": "DB653",
      "t": "Brown, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        126,
        27,
        39
      ],
      "id": "DB654",
      "t": "Red, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        11,
        128,
        62
      ],
      "id": "DB655",
      "t": "Green, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        5,
        103,
        74
      ],
      "id": "DB656",
      "t": "Green, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        99,
        86,
        69
      ],
      "id": "DB657",
      "t": "Green, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        3,
        174,
        190
      ],
      "id": "DB658",
      "t": "Blue, Green, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        10,
        141,
        208
      ],
      "id": "DB659",
      "t": "Blue, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        114,
        89,
        131
      ],
      "id": "DB660",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        95,
        97,
        189
      ],
      "id": "DB661",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        108,
        95,
        118
      ],
      "id": "DB662",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        60,
        78,
        47
      ],
      "id": "DB663",
      "t": "Green, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        167,
        104,
        27
      ],
      "id": "DB664",
      "t": "Brown, Opaque",
      "dt": "Luster, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        236,
        238,
        243
      ],
      "id": "DB670",
      "t": "White, Silk",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        152,
        131,
        99
      ],
      "id": "DB671",
      "t": "Brown, Silk",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        230,
        219,
        186
      ],
      "id": "DB672",
      "t": "White, Silk",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        208,
        181,
        156
      ],
      "id": "DB673",
      "t": "White, Silk",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        223,
        176,
        139
      ],
      "id": "DB674",
      "t": "Beige, Silk",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        225,
        193,
        214
      ],
      "id": "DB675",
      "t": "Pink, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        198,
        196,
        210
      ],
      "id": "DB676",
      "t": "White, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        177,
        184,
        207
      ],
      "id": "DB677",
      "t": "Blue, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        176,
        140,
        156
      ],
      "id": "DB678",
      "t": "Pink, Silk",
      "dt": "Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        151,
        144,
        148
      ],
      "id": "DB679",
      "t": "Gray, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        165,
        143,
        123
      ],
      "id": "DB680",
      "t": "Brown, Silk",
      "dt": "Rainbow, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        194,
        117,
        27
      ],
      "id": "DB681",
      "t": "Orange, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        192,
        99,
        37
      ],
      "id": "DB682",
      "t": "Orange, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        160,
        50,
        44
      ],
      "id": "DB683",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        204,
        109,
        84
      ],
      "id": "DB684",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        153,
        95,
        86
      ],
      "id": "DB685",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        155,
        135,
        96
      ],
      "id": "DB686",
      "t": "Yellow, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        162,
        130,
        73
      ],
      "id": "DB687",
      "t": "Green, Yellow, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        47,
        99,
        66
      ],
      "id": "DB688",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        98,
        104,
        104
      ],
      "id": "DB689",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        56,
        83,
        64
      ],
      "id": "DB690",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        89,
        146,
        162
      ],
      "id": "DB691",
      "t": "Blue, Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        75,
        140,
        175
      ],
      "id": "DB692",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        52,
        57,
        112
      ],
      "id": "DB693",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        95,
        103,
        170
      ],
      "id": "DB694",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        104,
        86,
        101
      ],
      "id": "DB695",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        71,
        65,
        138
      ],
      "id": "DB696",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        97,
        101,
        102
      ],
      "id": "DB697",
      "t": "Gray, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        190,
        122,
        44
      ],
      "id": "DB702",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        236,
        93,
        6
      ],
      "id": "DB703",
      "t": "Orange, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        188,
        6,
        9
      ],
      "id": "DB704",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        4,
        77,
        24
      ],
      "id": "DB705",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        38,
        132,
        205
      ],
      "id": "DB706",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        27,
        8,
        121
      ],
      "id": "DB707",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        66,
        71,
        75
      ],
      "id": "DB708",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        85,
        32,
        15
      ],
      "id": "DB709",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        218,
        181,
        33
      ],
      "id": "DB710",
      "t": "Yellow, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        97,
        63,
        77
      ],
      "id": "DB711",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        137,
        154,
        23
      ],
      "id": "DB712",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        24,
        58,
        40
      ],
      "id": "DB713",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        15,
        79,
        129
      ],
      "id": "DB714",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        51,
        38,
        31
      ],
      "id": "DB715",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        245,
        226,
        6
      ],
      "id": "DB721",
      "t": "Yellow, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        252,
        86,
        9
      ],
      "id": "DB722",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        194,
        24,
        34
      ],
      "id": "DB723",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        82,
        139,
        72
      ],
      "id": "DB724",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        85,
        167,
        206
      ],
      "id": "DB725",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        35,
        22,
        143
      ],
      "id": "DB726",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        230,
        54,
        33
      ],
      "id": "DB727",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        169,
        139,
        156
      ],
      "id": "DB728",
      "t": "Purple, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        61,
        161,
        166
      ],
      "id": "DB729",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        104,
        126,
        216
      ],
      "id": "DB730",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        121,
        121,
        121
      ],
      "id": "DB731",
      "t": "Gray, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        237,
        215,
        181
      ],
      "id": "DB732",
      "t": "Beige, White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        171,
        189,
        89
      ],
      "id": "DB733",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        58,
        30,
        31
      ],
      "id": "DB734",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        99,
        76,
        76
      ],
      "id": "DB735",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        238,
        237,
        248
      ],
      "id": "DB741",
      "t": "Crystal, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        209,
        136,
        65
      ],
      "id": "DB742",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        219,
        192,
        36
      ],
      "id": "DB743",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        248,
        112,
        9
      ],
      "id": "DB744",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        192,
        24,
        32
      ],
      "id": "DB745",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        34,
        104,
        64
      ],
      "id": "DB746",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        65,
        147,
        220
      ],
      "id": "DB747",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        47,
        25,
        137
      ],
      "id": "DB748",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        91,
        97,
        99
      ],
      "id": "DB749",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        250,
        229,
        1
      ],
      "id": "DB751",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        250,
        74,
        16
      ],
      "id": "DB752",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        203,
        29,
        43
      ],
      "id": "DB753",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        87,
        143,
        77
      ],
      "id": "DB754",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        75,
        178,
        232
      ],
      "id": "DB755",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        48,
        39,
        162
      ],
      "id": "DB756",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        225,
        35,
        36
      ],
      "id": "DB757",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        152,
        124,
        143
      ],
      "id": "DB758",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        85,
        171,
        184
      ],
      "id": "DB759",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        112,
        132,
        221
      ],
      "id": "DB760",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        124,
        123,
        123
      ],
      "id": "DB761",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        243,
        221,
        189
      ],
      "id": "DB762",
      "t": "Beige, White, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        181,
        199,
        106
      ],
      "id": "DB763",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        99,
        59,
        46
      ],
      "id": "DB764",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        117,
        87,
        98
      ],
      "id": "DB765",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        168,
        181,
        50
      ],
      "id": "DB766",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        36,
        65,
        50
      ],
      "id": "DB767",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        29,
        89,
        142
      ],
      "id": "DB768",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        58,
        46,
        42
      ],
      "id": "DB769",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        137,
        121,
        92
      ],
      "id": "DB771",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        99,
        77,
        68
      ],
      "id": "DB772",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        119,
        65,
        62
      ],
      "id": "DB773",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        146,
        33,
        36
      ],
      "id": "DB774",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        152,
        5,
        48
      ],
      "id": "DB775",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        7,
        68,
        46
      ],
      "id": "DB776",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        169,
        89,
        51
      ],
      "id": "DB777",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        159,
        90,
        89
      ],
      "id": "DB778",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        172,
        46,
        41
      ],
      "id": "DB779",
      "t": "Pink, Red, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        213,
        64,
        98
      ],
      "id": "DB780",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        178,
        90,
        55
      ],
      "id": "DB781",
      "t": "Brown, Orange, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        71,
        56,
        70
      ],
      "id": "DB782",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        104,
        74,
        187
      ],
      "id": "DB783",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        67,
        50,
        60
      ],
      "id": "DB784",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        53,
        39,
        95
      ],
      "id": "DB785",
      "t": "Blue, Purple, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        2,
        118,
        122
      ],
      "id": "DB786",
      "t": "Blue, Green, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        7,
        92,
        162
      ],
      "id": "DB787",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        35,
        77,
        87
      ],
      "id": "DB788",
      "t": "Blue, Green, Transparent",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        174,
        7,
        29
      ],
      "id": "DB791",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        96,
        124,
        138
      ],
      "id": "DB792",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        4,
        166,
        175
      ],
      "id": "DB793",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        145,
        84,
        52
      ],
      "id": "DB794",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        191,
        64,
        34
      ],
      "id": "DB795",
      "t": "Orange, Red, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        166,
        51,
        59
      ],
      "id": "DB796",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        73,
        94,
        61
      ],
      "id": "DB797",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        77,
        133,
        159
      ],
      "id": "DB798",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        101,
        105,
        141
      ],
      "id": "DB799",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        166,
        118,
        141
      ],
      "id": "DB800",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        210,
        172,
        192
      ],
      "id": "DB820",
      "t": "Pink, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        243,
        183,
        149
      ],
      "id": "DB821",
      "t": "Beige, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        167,
        154,
        157
      ],
      "id": "DB822",
      "t": "Gray, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        244,
        224,
        144
      ],
      "id": "DB823",
      "t": "Yellow, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        236,
        172,
        153
      ],
      "id": "DB824",
      "t": "Orange, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        235,
        157,
        150
      ],
      "id": "DB825",
      "t": "Pink, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        164,
        131,
        124
      ],
      "id": "DB826",
      "t": "Purple, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        145,
        131,
        130
      ],
      "id": "DB827",
      "t": "Gray, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        149,
        186,
        157
      ],
      "id": "DB828",
      "t": "Green, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        149,
        162,
        151
      ],
      "id": "DB829",
      "t": "Green, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        181,
        209,
        238
      ],
      "id": "DB830",
      "t": "Blue, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        154,
        169,
        214
      ],
      "id": "DB831",
      "t": "Blue, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        179,
        183,
        216
      ],
      "id": "DB832",
      "t": "Blue, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        207,
        177,
        196
      ],
      "id": "DB833",
      "t": "Purple, Silk",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        247,
        247,
        253
      ],
      "id": "DB851",
      "t": "Crystal, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        213,
        157,
        114
      ],
      "id": "DB852",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        127,
        93,
        91
      ],
      "id": "DB853",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        228,
        202,
        116
      ],
      "id": "DB854",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        242,
        122,
        87
      ],
      "id": "DB855",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        207,
        69,
        89
      ],
      "id": "DB856",
      "t": "Pink, Red, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        139,
        114,
        130
      ],
      "id": "DB857",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        73,
        124,
        110
      ],
      "id": "DB858",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        69,
        111,
        117
      ],
      "id": "DB859",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        176,
        192,
        112
      ],
      "id": "DB860",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        115,
        170,
        231
      ],
      "id": "DB861",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        61,
        114,
        166
      ],
      "id": "DB862",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        109,
        123,
        136
      ],
      "id": "DB863",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        79,
        82,
        169
      ],
      "id": "DB864",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        87,
        87,
        94
      ],
      "id": "DB865",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        161,
        111,
        108
      ],
      "id": "DB866",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        151,
        81,
        104
      ],
      "id": "DB867",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        237,
        203,
        205
      ],
      "id": "DB868",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        109,
        103,
        114
      ],
      "id": "DB869",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        119,
        111,
        141
      ],
      "id": "DB870",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        71,
        86,
        114
      ],
      "id": "DB871",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        246,
        114,
        97
      ],
      "id": "DB872",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        230,
        83,
        107
      ],
      "id": "DB873",
      "t": "Pink, Red, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        200,
        75,
        99
      ],
      "id": "DB874",
      "t": "Pink, Red, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        169,
        145,
        165
      ],
      "id": "DB875",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        188,
        203,
        126
      ],
      "id": "DB876",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        114,
        156,
        127
      ],
      "id": "DB877",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        100,
        163,
        174
      ],
      "id": "DB878",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        107,
        179,
        219
      ],
      "id": "DB879",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        86,
        88,
        163
      ],
      "id": "DB880",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        128,
        146,
        224
      ],
      "id": "DB881",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        146,
        148,
        157
      ],
      "id": "DB882",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        236,
        217,
        195
      ],
      "id": "DB883",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        108,
        94,
        94
      ],
      "id": "DB884",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        152,
        114,
        94
      ],
      "id": "DB901",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        172,
        103,
        132
      ],
      "id": "DB902",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        163,
        162,
        114
      ],
      "id": "DB903",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        66,
        149,
        145
      ],
      "id": "DB904",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        52,
        121,
        171
      ],
      "id": "DB905",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        97,
        76,
        137
      ],
      "id": "DB906",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        138,
        117,
        105
      ],
      "id": "DB907",
      "t": "Gold, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        144,
        133,
        89
      ],
      "id": "DB908",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        129,
        105,
        55
      ],
      "id": "DB909",
      "t": "Gold, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        171,
        166,
        114
      ],
      "id": "DB910",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        169,
        139,
        94
      ],
      "id": "DB911",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        120,
        100,
        107
      ],
      "id": "DB912",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        153,
        92,
        93
      ],
      "id": "DB913",
      "t": "Orange, Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        178,
        85,
        114
      ],
      "id": "DB914",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        145,
        103,
        97
      ],
      "id": "DB915",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        76,
        127,
        94
      ],
      "id": "DB916",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        87,
        103,
        74
      ],
      "id": "DB917",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        30,
        127,
        121
      ],
      "id": "DB918",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        53,
        92,
        90
      ],
      "id": "DB919",
      "t": "Blue, Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        46,
        111,
        161
      ],
      "id": "DB920",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        62,
        81,
        95
      ],
      "id": "DB921",
      "t": "Blue, Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        104,
        88,
        124
      ],
      "id": "DB922",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        89,
        77,
        123
      ],
      "id": "DB923",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        134,
        86,
        93
      ],
      "id": "DB924",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        71,
        75,
        89
      ],
      "id": "DB925",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        141,
        109,
        80
      ],
      "id": "DB981",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        139,
        103,
        111
      ],
      "id": "DB982",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        153,
        152,
        86
      ],
      "id": "DB983",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        50,
        115,
        111
      ],
      "id": "DB984",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        60,
        106,
        117
      ],
      "id": "DB985",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        119,
        113,
        129
      ],
      "id": "DB986",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        70,
        70,
        80
      ],
      "id": "DB1001",
      "t": "Iridescent, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        62,
        40,
        32
      ],
      "id": "DB1002",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        57,
        59,
        62
      ],
      "id": "DB1003",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        76,
        59,
        62
      ],
      "id": "DB1004",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        49,
        57,
        85
      ],
      "id": "DB1005",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        48,
        67,
        75
      ],
      "id": "DB1006",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        111,
        83,
        78
      ],
      "id": "DB1010",
      "t": "Gold, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        94,
        91
      ],
      "id": "DB1011",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        95,
        71,
        89
      ],
      "id": "DB1012",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        110,
        78,
        82
      ],
      "id": "DB1013",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        90,
        69,
        82
      ],
      "id": "DB1014",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        140,
        88,
        101
      ],
      "id": "DB1015",
      "t": "Purple, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        136,
        81,
        89
      ],
      "id": "DB1016",
      "t": "Red, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        83,
        49,
        27
      ],
      "id": "DB1051",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        66,
        82,
        106
      ],
      "id": "DB1052",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        84,
        77,
        94
      ],
      "id": "DB1053",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        77,
        91,
        125
      ],
      "id": "DB1054",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        107,
        98,
        93
      ],
      "id": "DB1055",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        97,
        91,
        100
      ],
      "id": "DB1056",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        142,
        115,
        116
      ],
      "id": "DB1061",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        119,
        107,
        121
      ],
      "id": "DB1062",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        129,
        132,
        147
      ],
      "id": "DB1063",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        129,
        108,
        123
      ],
      "id": "DB1064",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        140,
        132,
        151
      ],
      "id": "DB1065",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        156,
        116,
        129
      ],
      "id": "DB1066",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        136,
        122,
        130
      ],
      "id": "DB1067",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        139,
        73,
        25
      ],
      "id": "DB1101",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        120,
        6,
        14
      ],
      "id": "DB1102",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        222,
        170,
        159
      ],
      "id": "DB1103",
      "t": "Pink, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        70,
        50,
        57
      ],
      "id": "DB1104",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        82,
        67,
        91
      ],
      "id": "DB1105",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        71,
        136,
        43
      ],
      "id": "DB1106",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        66,
        81,
        46
      ],
      "id": "DB1107",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        7,
        87,
        94
      ],
      "id": "DB1108",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        6,
        126,
        202
      ],
      "id": "DB1109",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        46,
        82,
        186
      ],
      "id": "DB1110",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        142,
        135,
        129
      ],
      "id": "DB1111",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        210,
        166,
        94
      ],
      "id": "DB1112",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        216,
        177,
        132
      ],
      "id": "DB1131",
      "t": "Beige, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        253,
        192,
        1
      ],
      "id": "DB1132",
      "t": "Yellow, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        253,
        141,
        6
      ],
      "id": "DB1133",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        106,
        33,
        38
      ],
      "id": "DB1134",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        94,
        106,
        70
      ],
      "id": "DB1135",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        88,
        171,
        164
      ],
      "id": "DB1136",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        157,
        176,
        235
      ],
      "id": "DB1137",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        66,
        71,
        176
      ],
      "id": "DB1138",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        150,
        150,
        160
      ],
      "id": "DB1139",
      "t": "Gray, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        199,
        184,
        144
      ],
      "id": "DB1151",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        201,
        162,
        138
      ],
      "id": "DB1152",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        200,
        162,
        120
      ],
      "id": "DB1153",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        197,
        168,
        100
      ],
      "id": "DB1154",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        187,
        141,
        121
      ],
      "id": "DB1155",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        191,
        137,
        140
      ],
      "id": "DB1156",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        153,
        118,
        116
      ],
      "id": "DB1157",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        188,
        172,
        160
      ],
      "id": "DB1158",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        158,
        145,
        129
      ],
      "id": "DB1159",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        162,
        133,
        115
      ],
      "id": "DB1162",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        166,
        127,
        91
      ],
      "id": "DB1163",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        191,
        165,
        107
      ],
      "id": "DB1164",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        183,
        140,
        121
      ],
      "id": "DB1165",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        178,
        134,
        135
      ],
      "id": "DB1166",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        140,
        100,
        107
      ],
      "id": "DB1167",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        159,
        145,
        141
      ],
      "id": "DB1168",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        146,
        135,
        123
      ],
      "id": "DB1169",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        148,
        145,
        124
      ],
      "id": "DB1170",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        102,
        149,
        133
      ],
      "id": "DB1171",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        96,
        124,
        129
      ],
      "id": "DB1172",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        157,
        113,
        143
      ],
      "id": "DB1173",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        118,
        101,
        119
      ],
      "id": "DB1174",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        101,
        96,
        92
      ],
      "id": "DB1175",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        167,
        153,
        140
      ],
      "id": "DB1176",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        169,
        163,
        140
      ],
      "id": "DB1181",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        90,
        149,
        129
      ],
      "id": "DB1182",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        93,
        146,
        154
      ],
      "id": "DB1183",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        176,
        104,
        155
      ],
      "id": "DB1184",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        131,
        106,
        142
      ],
      "id": "DB1185",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        101,
        96,
        93
      ],
      "id": "DB1186",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Galvanized, Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        143,
        82,
        43
      ],
      "id": "DB1201",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        90,
        47,
        36
      ],
      "id": "DB1202",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        190,
        160,
        145
      ],
      "id": "DB1203",
      "t": "Pink, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        94,
        66,
        65
      ],
      "id": "DB1204",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        91,
        79,
        96
      ],
      "id": "DB1205",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        98,
        135,
        55
      ],
      "id": "DB1206",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        75,
        91,
        50
      ],
      "id": "DB1207",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        24,
        119,
        117
      ],
      "id": "DB1208",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        80,
        142,
        171
      ],
      "id": "DB1209",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        65,
        101,
        149
      ],
      "id": "DB1210",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        149,
        141,
        132
      ],
      "id": "DB1211",
      "t": "Silver, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        184,
        155,
        106
      ],
      "id": "DB1212",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        153,
        101,
        83
      ],
      "id": "DB1221",
      "t": "Brown, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        122,
        64,
        81
      ],
      "id": "DB1222",
      "t": "Red, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        220,
        179,
        176
      ],
      "id": "DB1223",
      "t": "Pink, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        100,
        81,
        98
      ],
      "id": "DB1224",
      "t": "Purple, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        97,
        93,
        121
      ],
      "id": "DB1225",
      "t": "Purple, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        112,
        161,
        107
      ],
      "id": "DB1226",
      "t": "Green, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        101,
        117,
        110
      ],
      "id": "DB1227",
      "t": "Green, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        45,
        116,
        128
      ],
      "id": "DB1228",
      "t": "Green, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        45,
        139,
        206
      ],
      "id": "DB1229",
      "t": "Blue, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        79,
        114,
        190
      ],
      "id": "DB1230",
      "t": "Blue, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        154,
        154,
        156
      ],
      "id": "DB1231",
      "t": "Gray, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        158,
        113,
        73
      ],
      "id": "DB1241",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        106,
        49,
        59
      ],
      "id": "DB1242",
      "t": "Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        220,
        179,
        174
      ],
      "id": "DB1243",
      "t": "Pink, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        87,
        79,
        107
      ],
      "id": "DB1244",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        120,
        122,
        139
      ],
      "id": "DB1245",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        109,
        151,
        80
      ],
      "id": "DB1246",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        75,
        102,
        87
      ],
      "id": "DB1247",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        32,
        110,
        117
      ],
      "id": "DB1248",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        52,
        141,
        196
      ],
      "id": "DB1249",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        76,
        118,
        188
      ],
      "id": "DB1250",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        151,
        146,
        155
      ],
      "id": "DB1251",
      "t": "Gray, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        206,
        172,
        122
      ],
      "id": "DB1252",
      "t": "Gold, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        147,
        80,
        35
      ],
      "id": "DB1261",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        131,
        48,
        56
      ],
      "id": "DB1262",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        231,
        183,
        175
      ],
      "id": "DB1263",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        77,
        57,
        63
      ],
      "id": "DB1264",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        88,
        73,
        99
      ],
      "id": "DB1265",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        79,
        132,
        56
      ],
      "id": "DB1266",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        71,
        88,
        54
      ],
      "id": "DB1267",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        6,
        87,
        88
      ],
      "id": "DB1268",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        2,
        134,
        206
      ],
      "id": "DB1269",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        66,
        107,
        199
      ],
      "id": "DB1270",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        145,
        141,
        137
      ],
      "id": "DB1271",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        216,
        175,
        108
      ],
      "id": "DB1272",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        125,
        170,
        113
      ],
      "id": "DB1281",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        110,
        125,
        110
      ],
      "id": "DB1282",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        47,
        127,
        137
      ],
      "id": "DB1283",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        49,
        153,
        218
      ],
      "id": "DB1284",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        95,
        130,
        206
      ],
      "id": "DB1285",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        161,
        161,
        165
      ],
      "id": "DB1286",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        225,
        193,
        149
      ],
      "id": "DB1287",
      "t": "Gold, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        246,
        187,
        5
      ],
      "id": "DB1301",
      "t": "Yellow, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        177,
        72,
        54
      ],
      "id": "DB1302",
      "t": "Orange, Pink, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        4,
        147,
        136
      ],
      "id": "DB1304",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        198,
        51,
        83
      ],
      "id": "DB1308",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        173,
        7,
        119
      ],
      "id": "DB1310",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        76,
        39,
        55
      ],
      "id": "DB1312",
      "t": "Pink, Purple, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        89,
        42,
        125
      ],
      "id": "DB1315",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        4,
        93,
        147
      ],
      "id": "DB1318",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        51,
        49,
        49
      ],
      "id": "DB1319",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        141,
        70,
        29
      ],
      "id": "DB1333",
      "t": "Orange, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        192,
        171,
        181
      ],
      "id": "DB1335",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        179,
        64,
        82
      ],
      "id": "DB1338",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        160,
        44,
        126
      ],
      "id": "DB1340",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        141,
        58,
        74
      ],
      "id": "DB1341",
      "t": "Pink, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        96,
        47,
        64
      ],
      "id": "DB1342",
      "t": "Pink, Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        119,
        82,
        142
      ],
      "id": "DB1343",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        127,
        62,
        137
      ],
      "id": "DB1345",
      "t": "Pink, Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        122,
        99,
        163
      ],
      "id": "DB1347",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        218,
        138,
        124
      ],
      "id": "DB1363",
      "t": "Orange, Pink, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        233,
        120,
        159
      ],
      "id": "DB1371",
      "t": "Pink, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        168,
        92,
        122
      ],
      "id": "DB1376",
      "t": "Pink, Purple, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        138,
        99,
        191
      ],
      "id": "DB1379",
      "t": "Purple, Opaque",
      "dt": "Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        117,
        82,
        32
      ],
      "id": "DB1391",
      "t": "Brown, Transparent",
      "dt": "Glazed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        80,
        48,
        33
      ],
      "id": "DB1392",
      "t": "Brown, Transparent",
      "dt": "Glazed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        57,
        29
      ],
      "id": "DB1393",
      "t": "Brown, Transparent",
      "dt": "Glazed, Silverline"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        234,
        207,
        91
      ],
      "id": "DB1401",
      "t": "Yellow, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        175,
        131,
        155
      ],
      "id": "DB1402",
      "t": "Pink, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        160,
        103,
        125
      ],
      "id": "DB1403",
      "t": "Pink, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        185,
        199,
        170
      ],
      "id": "DB1404",
      "t": "Blue, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        101,
        128,
        197
      ],
      "id": "DB1405",
      "t": "Blue, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        113,
        125
      ],
      "id": "DB1406",
      "t": "Blue, Gray, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        149,
        149,
        197
      ],
      "id": "DB1407",
      "t": "Blue, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        130,
        126,
        128
      ],
      "id": "DB1408",
      "t": "Blue, Gray, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        232,
        196,
        160
      ],
      "id": "DB1409",
      "t": "Crystal, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        221,
        157,
        131
      ],
      "id": "DB1410",
      "t": "Pink, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        214,
        107,
        80
      ],
      "id": "DB1411",
      "t": "Orange, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        208,
        86,
        67
      ],
      "id": "DB1412",
      "t": "Red, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        142,
        87,
        112
      ],
      "id": "DB1413",
      "t": "Pink, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        94,
        138,
        101
      ],
      "id": "DB1414",
      "t": "Green, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        85,
        108,
        93
      ],
      "id": "DB1415",
      "t": "Green, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        116,
        100,
        96
      ],
      "id": "DB1416",
      "t": "Gray, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        87,
        74,
        71
      ],
      "id": "DB1417",
      "t": "Gray, Transparent",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        180,
        182,
        168
      ],
      "id": "DB1431",
      "t": "Silver, Transparent",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        181,
        165,
        133
      ],
      "id": "DB1432",
      "t": "Silver, Transparent",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        158,
        131,
        137
      ],
      "id": "DB1433",
      "t": "Pink, Transparent",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        148,
        116,
        123
      ],
      "id": "DB1434",
      "t": "Pink, Transparent",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        153,
        150,
        165
      ],
      "id": "DB1435",
      "t": "Blue, Transparent",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        224,
        206,
        190
      ],
      "id": "DB1451",
      "t": "Beige, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        207,
        175,
        162
      ],
      "id": "DB1452",
      "t": "Beige, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        179,
        177,
        155
      ],
      "id": "DB1453",
      "t": "Green, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        170,
        183,
        169
      ],
      "id": "DB1454",
      "t": "Green, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        161,
        160,
        164
      ],
      "id": "DB1455",
      "t": "Gray, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        149,
        139,
        139
      ],
      "id": "DB1456",
      "t": "Gray, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        199,
        171,
        183
      ],
      "id": "DB1457",
      "t": "Pink, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        193,
        165,
        134
      ],
      "id": "DB1458",
      "t": "Gold, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        162,
        129,
        121
      ],
      "id": "DB1459",
      "t": "Brown, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        152,
        131,
        127
      ],
      "id": "DB1460",
      "t": "Gray, Alabaster",
      "dt": "Glass enamel, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        232,
        211,
        141
      ],
      "id": "DB1471",
      "t": "Yellow, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        190,
        152,
        169
      ],
      "id": "DB1472",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        170,
        135,
        157
      ],
      "id": "DB1473",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        192,
        208,
        186
      ],
      "id": "DB1474",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        121,
        145,
        199
      ],
      "id": "DB1475",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        155,
        156,
        193
      ],
      "id": "DB1476",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        154,
        154,
        160
      ],
      "id": "DB1477",
      "t": "Gray, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        237,
        184,
        122
      ],
      "id": "DB1478",
      "t": "Yellow, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        223,
        163,
        145
      ],
      "id": "DB1479",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        222,
        131,
        114
      ],
      "id": "DB1480",
      "t": "Orange, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        199,
        109,
        107
      ],
      "id": "DB1481",
      "t": "Red, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        166,
        126,
        149
      ],
      "id": "DB1482",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        116,
        153,
        127
      ],
      "id": "DB1483",
      "t": "Green, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        117,
        136,
        131
      ],
      "id": "DB1484",
      "t": "Green, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        132,
        122,
        124
      ],
      "id": "DB1485",
      "t": "Gray, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        120,
        114,
        122
      ],
      "id": "DB1486",
      "t": "Gray, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        239,
        220,
        214
      ],
      "id": "DB1490",
      "t": "Pink, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        253,
        238,
        182
      ],
      "id": "DB1491",
      "t": "Yellow, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        252,
        210,
        185
      ],
      "id": "DB1492",
      "t": "Beige, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        234,
        179,
        176
      ],
      "id": "DB1493",
      "t": "Pink, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        219,
        193,
        215
      ],
      "id": "DB1494",
      "t": "Pink, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        209,
        178,
        179
      ],
      "id": "DB1495",
      "t": "Pink, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        178,
        205,
        185
      ],
      "id": "DB1496",
      "t": "Green, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        192,
        207,
        246
      ],
      "id": "DB1497",
      "t": "Blue, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        173,
        170,
        173
      ],
      "id": "DB1498",
      "t": "Gray, Opaque",
      "dt": "Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        243,
        219,
        213
      ],
      "id": "DB1500",
      "t": "White, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        250,
        235,
        177
      ],
      "id": "DB1501",
      "t": "Yellow, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        249,
        200,
        172
      ],
      "id": "DB1502",
      "t": "Orange, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        235,
        174,
        167
      ],
      "id": "DB1503",
      "t": "Pink, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        221,
        194,
        215
      ],
      "id": "DB1504",
      "t": "Pink, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        208,
        177,
        175
      ],
      "id": "DB1505",
      "t": "Pink, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        184,
        213,
        194
      ],
      "id": "DB1506",
      "t": "Green, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        187,
        203,
        233
      ],
      "id": "DB1507",
      "t": "Blue, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        166,
        162,
        166
      ],
      "id": "DB1508",
      "t": "Gray, Opaque",
      "dt": "Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        245,
        229,
        226
      ],
      "id": "DB1510",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        248,
        232,
        177
      ],
      "id": "DB1511",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        250,
        200,
        176
      ],
      "id": "DB1512",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        235,
        180,
        179
      ],
      "id": "DB1513",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        224,
        199,
        220
      ],
      "id": "DB1514",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        212,
        179,
        179
      ],
      "id": "DB1515",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        198,
        223,
        207
      ],
      "id": "DB1516",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        192,
        211,
        250
      ],
      "id": "DB1517",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        165,
        163,
        167
      ],
      "id": "DB1518",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glass enamel"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        244,
        221,
        220
      ],
      "id": "DB1520",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        249,
        237,
        183
      ],
      "id": "DB1521",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        244,
        200,
        180
      ],
      "id": "DB1522",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        231,
        177,
        171
      ],
      "id": "DB1523",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        223,
        195,
        219
      ],
      "id": "DB1524",
      "t": "Pink, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        211,
        183,
        187
      ],
      "id": "DB1525",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        187,
        216,
        203
      ],
      "id": "DB1526",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        189,
        206,
        243
      ],
      "id": "DB1527",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        169,
        164,
        172
      ],
      "id": "DB1528",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glass enamel, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        245,
        220,
        207
      ],
      "id": "DB1530",
      "t": "White, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        246,
        230,
        175
      ],
      "id": "DB1531",
      "t": "Yellow, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        247,
        200,
        176
      ],
      "id": "DB1532",
      "t": "Orange, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        229,
        171,
        163
      ],
      "id": "DB1533",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        206,
        182,
        202
      ],
      "id": "DB1534",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        200,
        173,
        172
      ],
      "id": "DB1535",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        178,
        205,
        189
      ],
      "id": "DB1536",
      "t": "Green, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        191,
        205,
        240
      ],
      "id": "DB1537",
      "t": "Blue, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        164,
        162,
        166
      ],
      "id": "DB1538",
      "t": "Gray, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        209,
        169,
        134
      ],
      "id": "DB1561",
      "t": "Beige, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        247,
        192,
        70
      ],
      "id": "DB1562",
      "t": "Yellow, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        238,
        139,
        68
      ],
      "id": "DB1563",
      "t": "Orange, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        160,
        58,
        80
      ],
      "id": "DB1564",
      "t": "Red, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        109,
        70,
        81
      ],
      "id": "DB1565",
      "t": "Red, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        95,
        104,
        92
      ],
      "id": "DB1566",
      "t": "Green, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        117,
        183,
        189
      ],
      "id": "DB1567",
      "t": "Green, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        157,
        173,
        226
      ],
      "id": "DB1568",
      "t": "Blue, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        93,
        98,
        183
      ],
      "id": "DB1569",
      "t": "Blue, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        150,
        151,
        164
      ],
      "id": "DB1570",
      "t": "Gray, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        228,
        186,
        142
      ],
      "id": "DB1571",
      "t": "Beige, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        253,
        186,
        24
      ],
      "id": "DB1572",
      "t": "Yellow, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        248,
        152,
        48
      ],
      "id": "DB1573",
      "t": "Orange, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        110,
        65,
        76
      ],
      "id": "DB1574",
      "t": "Red, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        101,
        114,
        105
      ],
      "id": "DB1575",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        95,
        178,
        183
      ],
      "id": "DB1576",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        152,
        171,
        228
      ],
      "id": "DB1577",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        79,
        91,
        185
      ],
      "id": "DB1578",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        152,
        154,
        164
      ],
      "id": "DB1579",
      "t": "Gray, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        228,
        193,
        148
      ],
      "id": "DB1581",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        254,
        192,
        1
      ],
      "id": "DB1582",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        253,
        143,
        4
      ],
      "id": "DB1583",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        114,
        52,
        55
      ],
      "id": "DB1584",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        99,
        110,
        78
      ],
      "id": "DB1585",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        104,
        187,
        195
      ],
      "id": "DB1586",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        158,
        178,
        236
      ],
      "id": "DB1587",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        79,
        86,
        194
      ],
      "id": "DB1588",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        153,
        153,
        164
      ],
      "id": "DB1589",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        222,
        194,
        165
      ],
      "id": "DB1591",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        252,
        198,
        61
      ],
      "id": "DB1592",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        252,
        152,
        85
      ],
      "id": "DB1593",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        111,
        128,
        109
      ],
      "id": "DB1594",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        120,
        189,
        199
      ],
      "id": "DB1595",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        164,
        182,
        233
      ],
      "id": "DB1596",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        104,
        109,
        192
      ],
      "id": "DB1597",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        169,
        169,
        181
      ],
      "id": "DB1598",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        208,
        208,
        208
      ],
      "id": "DB1671",
      "t": "White, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        130,
        187,
        206
      ],
      "id": "DB1672",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        199,
        147,
        168
      ],
      "id": "DB1673",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        197,
        178,
        175
      ],
      "id": "DB1674",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        156,
        196,
        185
      ],
      "id": "DB1675",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        209,
        198,
        158
      ],
      "id": "DB1676",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        159,
        168,
        185
      ],
      "id": "DB1677",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        101,
        73,
        37
      ],
      "id": "DB1681",
      "t": "Brown, Transparent",
      "dt": "Glazed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        78,
        46
      ],
      "id": "DB1682",
      "t": "Brown, Transparent",
      "dt": "Glazed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        117,
        69,
        40
      ],
      "id": "DB1683",
      "t": "Brown, Transparent",
      "dt": "Glazed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        80,
        48,
        36
      ],
      "id": "DB1684",
      "t": "Brown, Transparent",
      "dt": "Glazed, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        73,
        52,
        43
      ],
      "id": "DB1685",
      "t": "Red, Transparent",
      "dt": "Glazed, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        125,
        83,
        62
      ],
      "id": "DB1691",
      "t": "Brown, Transparent",
      "dt": "Glazed, Rainbow, Silverline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        116,
        80,
        66
      ],
      "id": "DB1692",
      "t": "Purple, Transparent",
      "dt": "Glazed, Rainbow, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        95,
        73,
        90
      ],
      "id": "DB1694",
      "t": "Purple, Transparent",
      "dt": "Glazed, Rainbow, Silverline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        228,
        221,
        212
      ],
      "id": "DB1701",
      "t": "White, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        172,
        109,
        73
      ],
      "id": "DB1702",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        138,
        105,
        91
      ],
      "id": "DB1703",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        139,
        92,
        88
      ],
      "id": "DB1704",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        104,
        64,
        69
      ],
      "id": "DB1705",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        116,
        108,
        120
      ],
      "id": "DB1706",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        126,
        196,
        184
      ],
      "id": "DB1707",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        76,
        164,
        178
      ],
      "id": "DB1708",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        62,
        125,
        173
      ],
      "id": "DB1709",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        87,
        65,
        53
      ],
      "id": "DB1710",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        171,
        169,
        164
      ],
      "id": "DB1711",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        104,
        116,
        116
      ],
      "id": "DB1712",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        162,
        141,
        125
      ],
      "id": "DB1731",
      "t": "Beige, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        126,
        98,
        86
      ],
      "id": "DB1732",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        155,
        101,
        90
      ],
      "id": "DB1733",
      "t": "Brown, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        151,
        99,
        50
      ],
      "id": "DB1734",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        126,
        90,
        57
      ],
      "id": "DB1735",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        118,
        87,
        73
      ],
      "id": "DB1736",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        141,
        103,
        99
      ],
      "id": "DB1737",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        119,
        93,
        58
      ],
      "id": "DB1738",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        79,
        69,
        60
      ],
      "id": "DB1739",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        83,
        81,
        69
      ],
      "id": "DB1740",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        68,
        61,
        46
      ],
      "id": "DB1741",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        178,
        94,
        118
      ],
      "id": "DB1742",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        171,
        55,
        118
      ],
      "id": "DB1743",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        155,
        82,
        138
      ],
      "id": "DB1744",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        139,
        109,
        124
      ],
      "id": "DB1745",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        140,
        89,
        105
      ],
      "id": "DB1746",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        94,
        49,
        81
      ],
      "id": "DB1747",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        80,
        52,
        56
      ],
      "id": "DB1748",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        131,
        105,
        101
      ],
      "id": "DB1749",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        101,
        60,
        50
      ],
      "id": "DB1750",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        68,
        41,
        52
      ],
      "id": "DB1751",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        158,
        126,
        147
      ],
      "id": "DB1752",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        118,
        102,
        161
      ],
      "id": "DB1753",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        120,
        101,
        137
      ],
      "id": "DB1754",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        66,
        50,
        117
      ],
      "id": "DB1755",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        79,
        73,
        97
      ],
      "id": "DB1756",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        119,
        84,
        101
      ],
      "id": "DB1757",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        78,
        110
      ],
      "id": "DB1758",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        107,
        85,
        80
      ],
      "id": "DB1759",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        102,
        87,
        93
      ],
      "id": "DB1760",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        74,
        133,
        171
      ],
      "id": "DB1761",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        79,
        102,
        126
      ],
      "id": "DB1762",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        24,
        48,
        96
      ],
      "id": "DB1763",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        8,
        80,
        93
      ],
      "id": "DB1764",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        163,
        166,
        141
      ],
      "id": "DB1765",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        148,
        137,
        112
      ],
      "id": "DB1766",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        86,
        132,
        136
      ],
      "id": "DB1767",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        79,
        112,
        111
      ],
      "id": "DB1768",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        44,
        80,
        89
      ],
      "id": "DB1769",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        136,
        136,
        142
      ],
      "id": "DB1770",
      "t": "Gray, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        152,
        144,
        153
      ],
      "id": "DB1771",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        129,
        117,
        114
      ],
      "id": "DB1772",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        97,
        90,
        74
      ],
      "id": "DB1773",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        94,
        99,
        107
      ],
      "id": "DB1774",
      "t": "Gray, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        73,
        74,
        71
      ],
      "id": "DB1775",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        217,
        204,
        103
      ],
      "id": "DB1776",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        241,
        132,
        19
      ],
      "id": "DB1777",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        173,
        115,
        63
      ],
      "id": "DB1778",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        144,
        98,
        63
      ],
      "id": "DB1779",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        178,
        78,
        65
      ],
      "id": "DB1780",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        142,
        65,
        53
      ],
      "id": "DB1781",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        52,
        142,
        152
      ],
      "id": "DB1782",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        74,
        134,
        175
      ],
      "id": "DB1783",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        96,
        149,
        214
      ],
      "id": "DB1784",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        71,
        78,
        170
      ],
      "id": "DB1785",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        121,
        140,
        87
      ],
      "id": "DB1786",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        67,
        149,
        96
      ],
      "id": "DB1787",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        35,
        113,
        82
      ],
      "id": "DB1788",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        136,
        123,
        145
      ],
      "id": "DB1789",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        120,
        96,
        87
      ],
      "id": "DB1790",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        170,
        144,
        156
      ],
      "id": "DB1791",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        135,
        108,
        120
      ],
      "id": "DB1792",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        134,
        138,
        144
      ],
      "id": "DB1793",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        220,
        177,
        115
      ],
      "id": "DB1801",
      "t": "Yellow, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        159,
        131,
        110
      ],
      "id": "DB1802",
      "t": "Beige, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        178,
        134,
        114
      ],
      "id": "DB1803",
      "t": "Beige, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        163,
        94,
        61
      ],
      "id": "DB1804",
      "t": "Orange, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        157,
        81,
        84
      ],
      "id": "DB1805",
      "t": "Red, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        170,
        122,
        146
      ],
      "id": "DB1806",
      "t": "Purple, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        180,
        81,
        112
      ],
      "id": "DB1807",
      "t": "Pink, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        162,
        78,
        133
      ],
      "id": "DB1808",
      "t": "Pink, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        108,
        88,
        140
      ],
      "id": "DB1809",
      "t": "Purple, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        93,
        67,
        131
      ],
      "id": "DB1810",
      "t": "Purple, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        68,
        96,
        137
      ],
      "id": "DB1811",
      "t": "Blue, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        82,
        153,
        152
      ],
      "id": "DB1812",
      "t": "Green, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        7,
        147,
        138
      ],
      "id": "DB1813",
      "t": "Green, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        56,
        100,
        87
      ],
      "id": "DB1814",
      "t": "Green, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        171,
        170,
        146
      ],
      "id": "DB1815",
      "t": "Green, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        172,
        172,
        176
      ],
      "id": "DB1816",
      "t": "Gray, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        128,
        127,
        129
      ],
      "id": "DB1817",
      "t": "Gray, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        75,
        74,
        76
      ],
      "id": "DB1818",
      "t": "Gray, Silk",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        203,
        193,
        156
      ],
      "id": "DB1831",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        161,
        145,
        115
      ],
      "id": "DB1831F",
      "t": "Silver, White, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        175,
        124,
        54
      ],
      "id": "DB1832",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        208,
        153,
        90
      ],
      "id": "DB1832F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        184,
        118,
        37
      ],
      "id": "DB1833",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        209,
        140,
        90
      ],
      "id": "DB1833F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        160,
        124,
        92
      ],
      "id": "DB1834",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        171,
        135,
        103
      ],
      "id": "DB1834F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        192,
        177,
        90
      ],
      "id": "DB1835",
      "t": "Yellow, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        159,
        106,
        74
      ],
      "id": "DB1836",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        163,
        85,
        69
      ],
      "id": "DB1837",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        161,
        65,
        57
      ],
      "id": "DB1838",
      "t": "Red, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        189,
        103,
        101
      ],
      "id": "DB1838F",
      "t": "Red, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        183,
        117,
        118
      ],
      "id": "DB1839",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        156,
        89,
        121
      ],
      "id": "DB1840",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        191,
        107,
        131
      ],
      "id": "DB1840F",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        181,
        67,
        83
      ],
      "id": "DB1841",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        212,
        106,
        108
      ],
      "id": "DB1841F",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        122,
        65,
        58
      ],
      "id": "DB1842",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        156,
        98,
        91
      ],
      "id": "DB1842F",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        118,
        84,
        77
      ],
      "id": "DB1843",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        121,
        94,
        87
      ],
      "id": "DB1843F",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        119,
        174,
        135
      ],
      "id": "DB1844",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        141,
        196,
        146
      ],
      "id": "DB1844F",
      "t": "Green, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        108,
        127,
        106
      ],
      "id": "DB1845",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        104,
        123,
        127
      ],
      "id": "DB1846",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        56,
        120,
        126
      ],
      "id": "DB1847",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        79,
        130,
        137
      ],
      "id": "DB1847F",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        148,
        106,
        129
      ],
      "id": "DB1848",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        162,
        90,
        115
      ],
      "id": "DB1849",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        107,
        78,
        99
      ],
      "id": "DB1850",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        143,
        136,
        117
      ],
      "id": "DB1851",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        151,
        141,
        121
      ],
      "id": "DB1851F",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        114,
        97,
        85
      ],
      "id": "DB1852",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        253,
        216,
        100
      ],
      "id": "DB1855",
      "t": "Orange, Silk",
      "dt": "Color-Lined, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        251,
        169,
        155
      ],
      "id": "DB1856",
      "t": "Pink, Silk",
      "dt": "Color-Lined, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        234,
        240,
        153
      ],
      "id": "DB1857",
      "t": "Green, Yellow, Silk",
      "dt": "Color-Lined, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        200,
        236,
        178
      ],
      "id": "DB1858",
      "t": "Green, Silk",
      "dt": "Color-Lined, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        166,
        223,
        242
      ],
      "id": "DB1859",
      "t": "Blue, Silk",
      "dt": "Color-Lined, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        19,
        116,
        171
      ],
      "id": "DB1860",
      "t": "Blue, Silk",
      "dt": "Color-Lined, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        247,
        193,
        96
      ],
      "id": "DB1861",
      "t": "Yellow, Silk",
      "dt": "Color-Lined, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        153,
        125,
        104
      ],
      "id": "DB1862",
      "t": "Brown, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        208,
        131,
        119
      ],
      "id": "DB1863",
      "t": "Pink, Red, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        207,
        130,
        87
      ],
      "id": "DB1864",
      "t": "Brown, Orange, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        168,
        73,
        89
      ],
      "id": "DB1865",
      "t": "Red, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        178,
        121,
        172
      ],
      "id": "DB1866",
      "t": "Purple, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        206,
        101,
        141
      ],
      "id": "DB1867",
      "t": "Pink, Purple, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        139,
        117,
        186
      ],
      "id": "DB1868",
      "t": "Purple, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        15,
        161,
        148
      ],
      "id": "DB1869",
      "t": "Green, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        83,
        128,
        130
      ],
      "id": "DB1870",
      "t": "Green, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        162,
        167,
        174
      ],
      "id": "DB1871",
      "t": "Gray, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        112,
        111,
        112
      ],
      "id": "DB1872",
      "t": "Black, Gray, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        235,
        232,
        129
      ],
      "id": "DB1873",
      "t": "Yellow, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        209,
        186,
        165
      ],
      "id": "DB1874",
      "t": "Orange, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        226,
        134,
        173
      ],
      "id": "DB1875",
      "t": "Pink, Purple, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        137,
        127,
        102
      ],
      "id": "DB1876",
      "t": "Brown, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        143,
        134,
        127
      ],
      "id": "DB1877",
      "t": "Gray, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        130,
        90,
        96
      ],
      "id": "DB1878",
      "t": "Red, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        157,
        121,
        113
      ],
      "id": "DB1879",
      "t": "Pink, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        142,
        95,
        112
      ],
      "id": "DB1880",
      "t": "Purple, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        88,
        75,
        118
      ],
      "id": "DB1881",
      "t": "Purple, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        89,
        110,
        143
      ],
      "id": "DB1882",
      "t": "Blue, Silk",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        212,
        193,
        97
      ],
      "id": "DB1886",
      "t": "Yellow, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        226,
        112,
        29
      ],
      "id": "DB1887",
      "t": "Orange, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        174,
        185,
        79
      ],
      "id": "DB1888",
      "t": "Yellow, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        33,
        119,
        76
      ],
      "id": "DB1889",
      "t": "Green, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        92,
        163,
        211
      ],
      "id": "DB1890",
      "t": "Blue, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        95,
        62,
        50
      ],
      "id": "DB1891",
      "t": "Brown, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        74,
        60,
        59
      ],
      "id": "DB1892",
      "t": "Brown, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        125,
        94,
        114
      ],
      "id": "DB1893",
      "t": "Purple, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        24,
        68,
        54
      ],
      "id": "DB1894",
      "t": "Green, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        25,
        102,
        154
      ],
      "id": "DB1895",
      "t": "Blue, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        45,
        34,
        141
      ],
      "id": "DB1896",
      "t": "Blue, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        78,
        87,
        95
      ],
      "id": "DB1897",
      "t": "Gray, Transparent",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        227,
        211,
        185
      ],
      "id": "DB1900",
      "t": "Yellow, Opaque",
      "dt": "Luster"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        233,
        171,
        188
      ],
      "id": "DB1906",
      "t": "Pink, Opaque",
      "dt": "Glazed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        221,
        171,
        185
      ],
      "id": "DB1907",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        97,
        68,
        66
      ],
      "id": "DB1910",
      "t": "Black, Brown, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        47,
        36,
        42
      ],
      "id": "DB1991",
      "t": "Black, Purple, Opaque",
      "dt": "Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        221,
        244,
        37
      ],
      "id": "DB2031",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        254,
        199,
        52
      ],
      "id": "DB2032",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        252,
        156,
        82
      ],
      "id": "DB2033",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        252,
        129,
        123
      ],
      "id": "DB2034",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        251,
        81,
        179
      ],
      "id": "DB2035",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        252,
        107,
        171
      ],
      "id": "DB2036",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        236,
        95,
        180
      ],
      "id": "DB2037",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        191,
        85,
        173
      ],
      "id": "DB2038",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        100,
        179,
        234
      ],
      "id": "DB2039",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        97,
        213,
        120
      ],
      "id": "DB2040",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        202,
        170,
        91
      ],
      "id": "DB2041",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        227,
        137,
        106
      ],
      "id": "DB2042",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        191,
        149,
        87
      ],
      "id": "DB2043",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        192,
        127,
        105
      ],
      "id": "DB2044",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        237,
        138,
        59
      ],
      "id": "DB2045",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        142,
        132,
        75
      ],
      "id": "DB2046",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        247,
        100,
        61
      ],
      "id": "DB2047",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        196,
        88,
        137
      ],
      "id": "DB2048",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        208,
        73,
        161
      ],
      "id": "DB2049",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        197,
        55,
        135
      ],
      "id": "DB2050",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        240,
        70,
        68
      ],
      "id": "DB2051",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        142,
        146,
        121
      ],
      "id": "DB2052",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        82,
        186,
        159
      ],
      "id": "DB2053",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        78,
        115,
        136
      ],
      "id": "DB2054",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        219,
        162,
        24
      ],
      "id": "DB2061",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        244,
        132,
        84
      ],
      "id": "DB2062",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        229,
        52,
        22
      ],
      "id": "DB2063",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        225,
        59,
        106
      ],
      "id": "DB2064",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        133,
        101,
        169
      ],
      "id": "DB2065",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        166,
        174,
        63
      ],
      "id": "DB2066",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        101,
        154,
        178
      ],
      "id": "DB2067",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        107,
        127,
        154
      ],
      "id": "DB2068",
      "t": "Mix, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        247,
        226,
        164
      ],
      "id": "DB2101",
      "t": "White, Yellow, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        229,
        179,
        83
      ],
      "id": "DB2102",
      "t": "Beige, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        251,
        163,
        14
      ],
      "id": "DB2103",
      "t": "Orange, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        250,
        151,
        22
      ],
      "id": "DB2104",
      "t": "Orange, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        161,
        131,
        118
      ],
      "id": "DB2105",
      "t": "Brown, Gray, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        185,
        127,
        25
      ],
      "id": "DB2106",
      "t": "Brown, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        179,
        116,
        79
      ],
      "id": "DB2107",
      "t": "Brown, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        177,
        100,
        17
      ],
      "id": "DB2108",
      "t": "Brown, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        147,
        93,
        46
      ],
      "id": "DB2109",
      "t": "Brown, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        154,
        106,
        25
      ],
      "id": "DB2110",
      "t": "Pink, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        233,
        160,
        137
      ],
      "id": "DB2111",
      "t": "Pink, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        243,
        151,
        135
      ],
      "id": "DB2112",
      "t": "Pink, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        235,
        152,
        153
      ],
      "id": "DB2113",
      "t": "Pink, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        214,
        117,
        112
      ],
      "id": "DB2114",
      "t": "Pink, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        232,
        131,
        144
      ],
      "id": "DB2115",
      "t": "Pink, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        250,
        155,
        178
      ],
      "id": "DB2116",
      "t": "Pink, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        237,
        127,
        158
      ],
      "id": "DB2117",
      "t": "Pink, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        162,
        87,
        110
      ],
      "id": "DB2118",
      "t": "Pink, Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        137,
        40,
        33
      ],
      "id": "DB2119",
      "t": "Brown, Red, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        119,
        47,
        36
      ],
      "id": "DB2120",
      "t": "Brown, Red, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        125,
        201,
        18
      ],
      "id": "DB2121",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        110,
        225,
        211
      ],
      "id": "DB2122",
      "t": "Blue, Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        166,
        169,
        129
      ],
      "id": "DB2123",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        156,
        144,
        98
      ],
      "id": "DB2124",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        104,
        165,
        152
      ],
      "id": "DB2125",
      "t": "Blue, Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        66,
        164,
        92
      ],
      "id": "DB2126",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        60,
        133,
        113
      ],
      "id": "DB2127",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        94,
        167,
        192
      ],
      "id": "DB2128",
      "t": "Blue, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        123,
        142,
        154
      ],
      "id": "DB2129",
      "t": "Blue, Gray, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        18,
        165,
        182
      ],
      "id": "DB2130",
      "t": "Blue, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        78,
        125,
        124
      ],
      "id": "DB2131",
      "t": "Blue, Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        81,
        124,
        157
      ],
      "id": "DB2132",
      "t": "Blue, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        9,
        132,
        160
      ],
      "id": "DB2133",
      "t": "Blue, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        15,
        117,
        198
      ],
      "id": "DB2134",
      "t": "Blue, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        37,
        103,
        149
      ],
      "id": "DB2135",
      "t": "Blue, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        172,
        135,
        186
      ],
      "id": "DB2136",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        168,
        115,
        136
      ],
      "id": "DB2137",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        171,
        143,
        212
      ],
      "id": "DB2138",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        143,
        111,
        149
      ],
      "id": "DB2139",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        120,
        87,
        134
      ],
      "id": "DB2140",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        140,
        117,
        28
      ],
      "id": "DB2141",
      "t": "Brown, Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        113,
        78,
        49
      ],
      "id": "DB2142",
      "t": "Brown, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        53,
        68,
        111
      ],
      "id": "DB2143",
      "t": "Blue, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        33,
        41,
        96
      ],
      "id": "DB2144",
      "t": "Blue, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        173,
        99,
        68
      ],
      "id": "DB2151",
      "t": "Orange, Pink, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        138,
        54,
        53
      ],
      "id": "DB2152",
      "t": "Red, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        172,
        99,
        129
      ],
      "id": "DB2153",
      "t": "Pink, Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        182,
        76,
        86
      ],
      "id": "DB2154",
      "t": "Pink, Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        162,
        125,
        104
      ],
      "id": "DB2155",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        143,
        78,
        105
      ],
      "id": "DB2156",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        172,
        109,
        41
      ],
      "id": "DB2157",
      "t": "Gold, Yellow, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        180,
        74,
        44
      ],
      "id": "DB2158",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        179,
        81,
        71
      ],
      "id": "DB2159",
      "t": "Pink, Red, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        126,
        78,
        75
      ],
      "id": "DB2160",
      "t": "Red, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        135,
        65,
        72
      ],
      "id": "DB2161",
      "t": "Pink, Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        128,
        71,
        97
      ],
      "id": "DB2162",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        126,
        127,
        94
      ],
      "id": "DB2163",
      "t": "Green, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        141,
        118,
        65
      ],
      "id": "DB2164",
      "t": "Green, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        118,
        135,
        122
      ],
      "id": "DB2165",
      "t": "Blue, Green, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        71,
        75,
        73
      ],
      "id": "DB2166",
      "t": "Blue, Green, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        100,
        98,
        114
      ],
      "id": "DB2167",
      "t": "Blue, Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        105,
        76,
        127
      ],
      "id": "DB2168",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        115,
        79,
        98
      ],
      "id": "DB2169",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        103,
        72,
        69
      ],
      "id": "DB2170",
      "t": "Brown, Purple, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        186,
        136,
        89
      ],
      "id": "DB2171",
      "t": "Yellow, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        182,
        116,
        95
      ],
      "id": "DB2172",
      "t": "Orange, Pink, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        157,
        65,
        63
      ],
      "id": "DB2173",
      "t": "Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        179,
        100,
        147
      ],
      "id": "DB2174",
      "t": "Pink, Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        190,
        95,
        115
      ],
      "id": "DB2175",
      "t": "Pink, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        95,
        130,
        163
      ],
      "id": "DB2176",
      "t": "Blue, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        167,
        131,
        115
      ],
      "id": "DB2177",
      "t": "Beige, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        170,
        99,
        88
      ],
      "id": "DB2178",
      "t": "Orange, Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        137,
        90,
        88
      ],
      "id": "DB2179",
      "t": "Brown, Red, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        155,
        98,
        134
      ],
      "id": "DB2180",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        151,
        97,
        123
      ],
      "id": "DB2181",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        125,
        95,
        124
      ],
      "id": "DB2182",
      "t": "Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        85,
        78
      ],
      "id": "DB2183",
      "t": "Brown, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        115,
        101,
        89
      ],
      "id": "DB2184",
      "t": "Brown, Gray, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        108,
        102,
        102
      ],
      "id": "DB2185",
      "t": "Brown, Gray, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        207,
        175,
        120
      ],
      "id": "DB2186",
      "t": "Yellow, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        199,
        187,
        86
      ],
      "id": "DB2187",
      "t": "Yellow, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        104,
        171,
        139
      ],
      "id": "DB2188",
      "t": "Green, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        188,
        118,
        136
      ],
      "id": "DB2189",
      "t": "Pink, Purple, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        122,
        110
      ],
      "id": "DB2190",
      "t": "Green, Alabaster",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        39,
        43,
        64
      ],
      "id": "DB2191",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        56,
        58,
        69
      ],
      "id": "DB2192",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Outside-Dyed, Silverline, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        104,
        98,
        87
      ],
      "id": "DB2201",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        117,
        114,
        115
      ],
      "id": "DB2203",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        167,
        166,
        171
      ],
      "id": "DB2204",
      "t": "Gray, White, Opaque",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        66,
        68,
        63
      ],
      "id": "DB2205",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        68,
        71,
        75
      ],
      "id": "DB2206",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        75,
        59,
        60
      ],
      "id": "DB2207",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        67,
        60,
        51
      ],
      "id": "DB2261",
      "t": "Brown, Mix, Yellow, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        191,
        176,
        142
      ],
      "id": "DB2262",
      "t": "Black, Blue, Mix, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        88,
        55,
        47
      ],
      "id": "DB2263",
      "t": "Gray, Mix, Yellow, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        114,
        141,
        130
      ],
      "id": "DB2264",
      "t": "Gray, Mix, Red, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        146,
        140,
        78
      ],
      "id": "DB2265",
      "t": "Blue, Mix, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        116,
        91,
        61
      ],
      "id": "DB2267",
      "t": "Green, Mix, Opaque",
      "dt": "Picasso Coating"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        158,
        122,
        114
      ],
      "id": "DB2271",
      "t": "Purple, Opaque",
      "dt": "Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        174,
        147,
        81
      ],
      "id": "DB2272",
      "t": "Green, Yellow, Opaque",
      "dt": "Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        173,
        120,
        54
      ],
      "id": "DB2273",
      "t": "Orange, Opaque",
      "dt": "Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        199,
        105,
        46
      ],
      "id": "DB2274",
      "t": "Orange, Opaque",
      "dt": "Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        156,
        62,
        59
      ],
      "id": "DB2275",
      "t": "Red, Opaque",
      "dt": "Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        164,
        173,
        178
      ],
      "id": "DB2281",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        156,
        151,
        136
      ],
      "id": "DB2282",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        207,
        191,
        55
      ],
      "id": "DB2283",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        225,
        187,
        70
      ],
      "id": "DB2284",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        241,
        175,
        73
      ],
      "id": "DB2285",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        166,
        111,
        46
      ],
      "id": "DB2286",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        189,
        112,
        34
      ],
      "id": "DB2287",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        163,
        76,
        54
      ],
      "id": "DB2288",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        171,
        162,
        95
      ],
      "id": "DB2290",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        90,
        102,
        74
      ],
      "id": "DB2291",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        120,
        116,
        142
      ],
      "id": "DB2292",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        110,
        96,
        136
      ],
      "id": "DB2293",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        161,
        115,
        128
      ],
      "id": "DB2294",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        133,
        98,
        117
      ],
      "id": "DB2295",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        188,
        167,
        139
      ],
      "id": "DB2301",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        218,
        171,
        93
      ],
      "id": "DB2302",
      "t": "Yellow, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        186,
        147,
        101
      ],
      "id": "DB2303",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        168,
        143,
        139
      ],
      "id": "DB2305",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        178,
        93,
        94
      ],
      "id": "DB2306",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        129,
        86,
        101
      ],
      "id": "DB2308",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        158,
        165,
        97
      ],
      "id": "DB2309",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        133,
        148,
        126
      ],
      "id": "DB2310",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        107,
        139,
        123
      ],
      "id": "DB2311",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        98,
        119,
        101
      ],
      "id": "DB2312",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        141,
        168,
        163
      ],
      "id": "DB2313",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        113,
        152,
        170
      ],
      "id": "DB2315",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        98,
        123,
        139
      ],
      "id": "DB2316",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        95,
        115,
        153
      ],
      "id": "DB2317",
      "t": "Blue, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        122,
        139,
        183
      ],
      "id": "DB2318",
      "t": "Blue, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        84,
        92,
        128
      ],
      "id": "DB2319",
      "t": "Blue, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        156,
        168,
        175
      ],
      "id": "DB2320",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        149,
        128,
        134
      ],
      "id": "DB2321",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        118,
        112,
        135
      ],
      "id": "DB2322",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Glazed, Rainbow"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        233,
        197,
        151
      ],
      "id": "DB2351",
      "t": "Beige, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        161,
        83,
        28
      ],
      "id": "DB2352",
      "t": "Brown, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        145,
        69,
        100
      ],
      "id": "DB2353",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        113,
        36,
        31
      ],
      "id": "DB2354",
      "t": "Brown, Red, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        102,
        60,
        78
      ],
      "id": "DB2355",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        165,
        187,
        177
      ],
      "id": "DB2356",
      "t": "Blue, Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        90,
        41
      ],
      "id": "DB2357",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        58,
        72,
        67
      ],
      "id": "DB2358",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        84,
        162
      ],
      "id": "DB2359",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        96,
        69,
        96
      ],
      "id": "DB2360",
      "t": "Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 4,
      "c": [
        185,
        159,
        162
      ],
      "id": "DB2361",
      "t": "Pink, Purple, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        179,
        167,
        145
      ],
      "id": "DB2362",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        156,
        141,
        124
      ],
      "id": "DB2363",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        168,
        148,
        121
      ],
      "id": "DB2364",
      "t": "Beige, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        91,
        79,
        78
      ],
      "id": "DB2365",
      "t": "Green, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        162,
        160,
        159
      ],
      "id": "DB2366",
      "t": "Gray, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        112,
        99,
        103
      ],
      "id": "DB2367",
      "t": "Gray, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        68,
        63,
        62
      ],
      "id": "DB2368",
      "t": "Black, Gray, Opaque",
      "dt": "Duracoat, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        240,
        202,
        154
      ],
      "id": "DB2371",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        180,
        132,
        49
      ],
      "id": "DB2372",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        155,
        120,
        100
      ],
      "id": "DB2373",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        161,
        25,
        35
      ],
      "id": "DB2374",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        90,
        46,
        57
      ],
      "id": "DB2375",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        108,
        149,
        68
      ],
      "id": "DB2376",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        105,
        98,
        51
      ],
      "id": "DB2377",
      "t": "Green, Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        131,
        132,
        106
      ],
      "id": "DB2378",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        110,
        112,
        99
      ],
      "id": "DB2379",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        11,
        101,
        112
      ],
      "id": "DB2380",
      "t": "Blue, Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        48,
        93,
        81
      ],
      "id": "DB2381",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        42,
        143,
        170
      ],
      "id": "DB2382",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        84,
        121,
        144
      ],
      "id": "DB2383",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        57,
        105,
        131
      ],
      "id": "DB2384",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        15,
        77,
        112
      ],
      "id": "DB2385",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        54,
        64,
        101
      ],
      "id": "DB2386",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        76,
        84,
        114
      ],
      "id": "DB2387",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        108,
        120,
        196
      ],
      "id": "DB2388",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        113,
        42,
        97
      ],
      "id": "DB2389",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        92,
        58,
        82
      ],
      "id": "DB2390",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        191,
        186,
        186
      ],
      "id": "DB2391",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        140,
        144,
        158
      ],
      "id": "DB2392",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        126,
        125,
        127
      ],
      "id": "DB2393",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        61,
        62,
        68
      ],
      "id": "DB2394",
      "t": "Black, Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        133,
        114,
        109
      ],
      "id": "DB2395",
      "t": "Beige, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        128,
        107,
        86
      ],
      "id": "DB2396",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        228,
        189,
        104
      ],
      "id": "DB2521",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        169,
        171,
        117
      ],
      "id": "DB2522",
      "t": "Green, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        80,
        102,
        90
      ],
      "id": "DB2523",
      "t": "Green, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        169,
        138,
        88
      ],
      "id": "DB2524",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 5,
      "b": 5,
      "c": [
        189,
        165,
        86
      ],
      "id": "DB2525",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        240,
        224,
        128
      ],
      "id": "DB5101",
      "t": "Gold",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        242,
        228,
        148
      ],
      "id": "DB5102",
      "t": "Light Gold",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        242,
        178,
        147
      ],
      "id": "DB5103",
      "t": "Copper",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        242,
        211,
        147
      ],
      "id": "DB5104",
      "t": "Yellow",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        21,
        204,
        9
      ],
      "id": "DB5105",
      "t": "Bright Green",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        14,
        163,
        65
      ],
      "id": "DB5016",
      "t": "Forest Green",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        46,
        53,
        41
      ],
      "id": "DB5107",
      "t": "Dark Metal",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        135,
        81,
        142
      ],
      "id": "DB5108",
      "t": "Lavender",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        144,
        121,
        167
      ],
      "id": "DB5109",
      "t": "Pale Lavender",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        114,
        72,
        163
      ],
      "id": "DB5110",
      "t": "Grape",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        50,
        53,
        212
      ],
      "id": "DB5111",
      "t": "Deep Blue",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        169,
        171,
        116
      ],
      "id": "DB5112",
      "t": "Olive",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        134,
        203,
        217
      ],
      "id": "DB5113",
      "t": "Cyan",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        58,
        132,
        220
      ],
      "id": "DB5114",
      "t": "Sky Blue",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        17,
        151,
        148
      ],
      "id": "DB5115",
      "t": "Turquoise",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        61,
        112,
        190
      ],
      "id": "DB5116",
      "t": "Blue",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        77,
        94,
        190
      ],
      "id": "DB5117",
      "t": "Deep Blue",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        201,
        186,
        92
      ],
      "id": "DB2501",
      "t": "Gold",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        188,
        177,
        61
      ],
      "id": "DB2502",
      "t": "Gold",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        241,
        185,
        134
      ],
      "id": "DB2503",
      "t": "Copper",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        216,
        171,
        81
      ],
      "id": "DB2504",
      "t": "Warm Gold",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        56,
        179,
        70
      ],
      "id": "DB2505",
      "t": "Green",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        38,
        164,
        78
      ],
      "id": "DB2506",
      "t": "Forest Green",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        75,
        76,
        56
      ],
      "id": "DB2507",
      "t": "Dark Metal",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        151,
        61,
        159
      ],
      "id": "DB2508",
      "t": "Lavender",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        114,
        72,
        163
      ],
      "id": "DB2509",
      "t": "Grape",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        119,
        65,
        207
      ],
      "id": "DB2510",
      "t": "Dark Purple",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        33,
        32,
        198
      ],
      "id": "DB2511",
      "t": "Deep Blue",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        167,
        172,
        80
      ],
      "id": "DB2512",
      "t": "Olive",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        89,
        204,
        225
      ],
      "id": "DB2513",
      "t": "Cyan",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        36,
        107,
        169
      ],
      "id": "DB2514",
      "t": "Blue",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        47,
        172,
        183
      ],
      "id": "DB2515",
      "t": "Turquoise",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        56,
        102,
        191
      ],
      "id": "DB2516",
      "t": "Blue",
      "dt": "Galvanized"
    },
    {
      "a": 5,
      "b": 6,
      "c": [
        79,
        77,
        204
      ],
      "id": "DB2517",
      "t": "Blue Purple",
      "dt": "Galvanized"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        58,
        63,
        75
      ],
      "id": "DBL1",
      "t": "Gray, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        35,
        44,
        50
      ],
      "id": "DBL2",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        56,
        74,
        84
      ],
      "id": "DBL5",
      "t": "Iridescent, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        38,
        38,
        38
      ],
      "id": "DBL10",
      "t": "Black, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        84,
        78,
        46
      ],
      "id": "DBL11",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        78,
        56,
        68
      ],
      "id": "DBL12",
      "t": "Purple, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        113,
        105,
        103
      ],
      "id": "DBL21",
      "t": "Silver, Opaque",
      "dt": "Plating, Nickel"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        96,
        74,
        55
      ],
      "id": "DBL22",
      "t": "Gold, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        99,
        84,
        63
      ],
      "id": "DBL23",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        38,
        62,
        60
      ],
      "id": "DBL27",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        109,
        95,
        88
      ],
      "id": "DBL29",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Nickel"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        156,
        124,
        89
      ],
      "id": "DBL31",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        169,
        134,
        87
      ],
      "id": "DBL34",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        184,
        175,
        160
      ],
      "id": "DBL35",
      "t": "Silver, Transparent",
      "dt": "Galvanized"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        157,
        117,
        107
      ],
      "id": "DBL37",
      "t": "Pink, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        149,
        143,
        139
      ],
      "id": "DBL38",
      "t": "Silver, Opaque",
      "dt": "Plating, Palladium"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        202,
        193,
        184
      ],
      "id": "DBL41",
      "t": "Silver, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        194,
        136,
        70
      ],
      "id": "DBL42",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        166,
        43,
        30
      ],
      "id": "DBL43",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        77,
        133,
        167
      ],
      "id": "DBL44",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        36,
        88,
        47
      ],
      "id": "DBL46",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        41,
        26,
        121
      ],
      "id": "DBL47",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        210,
        211,
        227
      ],
      "id": "DBL50",
      "t": "Crystal, Transparent",
      "dt": "Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        212,
        217,
        228
      ],
      "id": "DBL51",
      "t": "Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        155,
        76,
        66
      ],
      "id": "DBL62",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        146,
        100,
        58
      ],
      "id": "DBL65",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        129,
        88,
        90
      ],
      "id": "DBL88",
      "t": "Purple, Red, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        81,
        66,
        63
      ],
      "id": "DBL89",
      "t": "Green, Iridescent, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        158,
        90,
        101
      ],
      "id": "DBL98",
      "t": "Red, Transparent",
      "dt": "Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        208,
        161,
        111
      ],
      "id": "DBL99",
      "t": "Brown, Transparent",
      "dt": "Luster"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        194,
        140,
        94
      ],
      "id": "DBL100",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        91,
        63,
        69
      ],
      "id": "DBL104",
      "t": "Pink, Purple, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        82,
        53,
        48
      ],
      "id": "DBL105",
      "t": "Purple, Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        208,
        112,
        109
      ],
      "id": "DBL106",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        109,
        115,
        120
      ],
      "id": "DBL107",
      "t": "Blue, Gray, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        117,
        79,
        73
      ],
      "id": "DBL108",
      "t": "Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        114,
        78,
        67
      ],
      "id": "DBL115",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        93,
        48,
        52
      ],
      "id": "DBL116",
      "t": "Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        129,
        77,
        55
      ],
      "id": "DBL121",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        104,
        95,
        92
      ],
      "id": "DBL122",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        95,
        82,
        66
      ],
      "id": "DBL123",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        192,
        190,
        198
      ],
      "id": "DBL141",
      "t": "Crystal, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        100,
        54,
        32
      ],
      "id": "DBL144",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        194,
        168,
        37
      ],
      "id": "DBL145",
      "t": "Yellow, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        114,
        82,
        84
      ],
      "id": "DBL146",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        54,
        103,
        87
      ],
      "id": "DBL152",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        224,
        201,
        172
      ],
      "id": "DBL157",
      "t": "Beige, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        181,
        67,
        86
      ],
      "id": "DBL162",
      "t": "Red, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        83,
        159,
        199
      ],
      "id": "DBL164",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        51,
        68,
        145
      ],
      "id": "DBL165",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        97,
        64,
        60
      ],
      "id": "DBL170",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        228,
        199,
        72
      ],
      "id": "DBL171",
      "t": "Yellow, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        150,
        48,
        67
      ],
      "id": "DBL172",
      "t": "Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        111,
        88,
        107
      ],
      "id": "DBL173",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        59,
        138,
        201
      ],
      "id": "DBL176",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        64,
        64,
        143
      ],
      "id": "DBL178",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        161,
        137,
        138
      ],
      "id": "DBL191",
      "t": "Pink, Alabaster",
      "dt": "Copperline"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        242,
        239,
        246
      ],
      "id": "DBL200",
      "t": "White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        239,
        235,
        241
      ],
      "id": "DBL201",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        243,
        239,
        244
      ],
      "id": "DBL202",
      "t": "White, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        236,
        219,
        193
      ],
      "id": "DBL203",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        216,
        179,
        147
      ],
      "id": "DBL204",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        184,
        30,
        38
      ],
      "id": "DBL214",
      "t": "Red, Opaque",
      "dt": "Luster"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        214,
        208,
        206
      ],
      "id": "DBL221",
      "t": "Silver, Alabaster",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        227,
        224,
        229
      ],
      "id": "DBL222",
      "t": "Crystal, Alabaster",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        237,
        235,
        242
      ],
      "id": "DBL231",
      "t": "White, Alabaster",
      "dt": "Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        241,
        215,
        157
      ],
      "id": "DBL232",
      "t": "Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        239,
        178,
        113
      ],
      "id": "DBL233",
      "t": "Orange, Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        213,
        163,
        161
      ],
      "id": "DBL234",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        244,
        187,
        210
      ],
      "id": "DBL244",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        130,
        118,
        180
      ],
      "id": "DBL249",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        193,
        181,
        166
      ],
      "id": "DBL261",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        128,
        129,
        140
      ],
      "id": "DBL271",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        55,
        36,
        35
      ],
      "id": "DBL297",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        79,
        86,
        98
      ],
      "id": "DBL301",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        127,
        129,
        134
      ],
      "id": "DBL307",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        47,
        47,
        49
      ],
      "id": "DBL310",
      "t": "Black, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        74,
        68,
        51
      ],
      "id": "DBL311",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        109,
        75,
        71
      ],
      "id": "DBL312",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        153,
        144,
        142
      ],
      "id": "DBL321",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Nickel"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        131,
        108,
        88
      ],
      "id": "DBL322",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        94,
        71,
        73
      ],
      "id": "DBL323",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        99,
        111,
        105
      ],
      "id": "DBL324",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        81,
        80,
        95
      ],
      "id": "DBL325",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        244,
        242,
        250
      ],
      "id": "DBL351",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        244,
        232,
        208
      ],
      "id": "DBL352",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        226,
        194,
        172
      ],
      "id": "DBL353",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        216,
        167,
        124
      ],
      "id": "DBL410",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        184,
        9,
        15
      ],
      "id": "DBL704",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        15,
        66,
        32
      ],
      "id": "DBL705",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        16,
        123,
        199
      ],
      "id": "DBL706",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        61,
        31,
        124
      ],
      "id": "DBL707",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        68,
        33,
        26
      ],
      "id": "DBL709",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        221,
        180,
        9
      ],
      "id": "DBL710",
      "t": "Yellow, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        113,
        74,
        88
      ],
      "id": "DBL711",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        185,
        13,
        30
      ],
      "id": "DBL723",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        92,
        182,
        223
      ],
      "id": "DBL725",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        44,
        27,
        118
      ],
      "id": "DBL726",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        239,
        217,
        186
      ],
      "id": "DBL732",
      "t": "Beige, White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        73,
        42,
        39
      ],
      "id": "DBL734",
      "t": "Brown, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        236,
        235,
        245
      ],
      "id": "DBL741",
      "t": "Crystal, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        225,
        183,
        2
      ],
      "id": "DBL743",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        185,
        44,
        51
      ],
      "id": "DBL745",
      "t": "Red, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        27,
        66,
        43
      ],
      "id": "DBL746",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        58,
        137,
        220
      ],
      "id": "DBL747",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        51,
        19,
        112
      ],
      "id": "DBL748",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        79,
        55,
        52
      ],
      "id": "DBL764",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        102,
        79,
        88
      ],
      "id": "DBL765",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        234,
        234,
        246
      ],
      "id": "DBL851",
      "t": "Crystal, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        114,
        93,
        116
      ],
      "id": "DBL853",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        228,
        200,
        103
      ],
      "id": "DBL854",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        183,
        69,
        100
      ],
      "id": "DBL856",
      "t": "Pink, Red, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        148,
        128,
        145
      ],
      "id": "DBL857",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        79,
        127,
        127
      ],
      "id": "DBL858",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        111,
        161,
        226
      ],
      "id": "DBL861",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        85,
        81,
        156
      ],
      "id": "DBL864",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        101,
        91,
        106
      ],
      "id": "DBL869",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        190,
        83,
        104
      ],
      "id": "DBL874",
      "t": "Pink, Red, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        110,
        182,
        225
      ],
      "id": "DBL879",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        79,
        83,
        150
      ],
      "id": "DBL880",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        236,
        213,
        181
      ],
      "id": "DBL883",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        164,
        125,
        99
      ],
      "id": "DBL901",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        171,
        110,
        138
      ],
      "id": "DBL902",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        151,
        152,
        124
      ],
      "id": "DBL903",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        62,
        137,
        134
      ],
      "id": "DBL904",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        67,
        123,
        164
      ],
      "id": "DBL905",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        94,
        78,
        127
      ],
      "id": "DBL906",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        151,
        141,
        88
      ],
      "id": "DBL910",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        133,
        86,
        81
      ],
      "id": "DBL915",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        98,
        81,
        118
      ],
      "id": "DBL922",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        130,
        71,
        74
      ],
      "id": "DBL924",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        61,
        43,
        48
      ],
      "id": "DBL1104",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        74,
        49,
        52
      ],
      "id": "DBL1204",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        100,
        79,
        87
      ],
      "id": "DBL1244",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 3,
      "b": 4,
      "c": [
        69,
        53,
        58
      ],
      "id": "DBL1264",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        249,
        194,
        170
      ],
      "id": "DBL1532",
      "t": "Orange, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        234,
        168,
        158
      ],
      "id": "DBL1533",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        213,
        188,
        209
      ],
      "id": "DBL1534",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        195,
        165,
        163
      ],
      "id": "DBL1535",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        199,
        183,
        151
      ],
      "id": "DBL1831",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        199,
        180,
        142
      ],
      "id": "DBL1831F",
      "t": "Silver, White, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        185,
        142,
        70
      ],
      "id": "DBL1832",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        203,
        155,
        93
      ],
      "id": "DBL1832F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        168,
        113,
        55
      ],
      "id": "DBL1833",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        193,
        125,
        73
      ],
      "id": "DBL1833F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        119,
        89,
        63
      ],
      "id": "DBL1834",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        170,
        130,
        97
      ],
      "id": "DBL1834F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        170,
        152,
        49
      ],
      "id": "DBL1835",
      "t": "Yellow, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        189,
        118,
        70
      ],
      "id": "DBL1836",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        169,
        60,
        36
      ],
      "id": "DBL1837",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        132,
        44,
        38
      ],
      "id": "DBL1838",
      "t": "Red, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        161,
        106,
        111
      ],
      "id": "DBL1839",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        185,
        99,
        128
      ],
      "id": "DBL1840",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        190,
        67,
        91
      ],
      "id": "DBL1841",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        108,
        52,
        43
      ],
      "id": "DBL1842",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        96,
        65,
        62
      ],
      "id": "DBL1843",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        98,
        167,
        112
      ],
      "id": "DBL1844",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        76,
        110,
        93
      ],
      "id": "DBL1845",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        119,
        140,
        137
      ],
      "id": "DBL1846",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        27,
        97,
        97
      ],
      "id": "DBL1847",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        128,
        71,
        103
      ],
      "id": "DBL1848",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        108,
        70,
        77
      ],
      "id": "DBL1849",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        101,
        72,
        90
      ],
      "id": "DBL1850",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        140,
        137,
        120
      ],
      "id": "DBL1851",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        108,
        93,
        72
      ],
      "id": "DBL1852",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        126,
        114,
        97
      ],
      "id": "DBL2201",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        115,
        113,
        120
      ],
      "id": "DBL2203",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        189,
        188,
        196
      ],
      "id": "DBL2204",
      "t": "Gray, White, Opaque",
      "dt": "Frosted (Matte), Special Coating"
    },
    {
      "a": 3,
      "b": 6,
      "c": [
        106,
        98,
        101
      ],
      "id": "DBL2205",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        67,
        72,
        96
      ],
      "id": "DBL2206",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 3,
      "b": 5,
      "c": [
        73,
        61,
        62
      ],
      "id": "DBL2207",
      "t": "Gray, Iridescent, Transparent",
      "dt": "Special Coating"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        58,
        60,
        71
      ],
      "id": "DBM1",
      "t": "Gray, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        34,
        38,
        42
      ],
      "id": "DBM2",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        46,
        54,
        62
      ],
      "id": "DBM3",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        53,
        38,
        40
      ],
      "id": "DBM4",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        54,
        70,
        79
      ],
      "id": "DBM5",
      "t": "Iridescent, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        55,
        52,
        51
      ],
      "id": "DBM7",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        37,
        36,
        37
      ],
      "id": "DBM10",
      "t": "Black, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        73,
        69,
        43
      ],
      "id": "DBM11",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        69,
        43,
        38
      ],
      "id": "DBM12",
      "t": "Purple, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        103,
        94,
        90
      ],
      "id": "DBM21",
      "t": "Silver, Opaque",
      "dt": "Plating, Nickel"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        98,
        76,
        61
      ],
      "id": "DBM22",
      "t": "Gold, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        119,
        89,
        60
      ],
      "id": "DBM22L",
      "t": "Gold, Transparent",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        87,
        73,
        57
      ],
      "id": "DBM23",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        87,
        105,
        94
      ],
      "id": "DBM27",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        120,
        100,
        85
      ],
      "id": "DBM29",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Nickel"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        187,
        135,
        70
      ],
      "id": "DBM31",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        179,
        132,
        82
      ],
      "id": "DBM33",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        187,
        150,
        103
      ],
      "id": "DBM34",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        185,
        179,
        168
      ],
      "id": "DBM35",
      "t": "Silver, Transparent",
      "dt": "Galvanized"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        145,
        106,
        93
      ],
      "id": "DBM37",
      "t": "Pink, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        165,
        158,
        155
      ],
      "id": "DBM38",
      "t": "Silver, Opaque",
      "dt": "Plating, Palladium"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        195,
        187,
        178
      ],
      "id": "DBM41",
      "t": "Silver, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        185,
        137,
        71
      ],
      "id": "DBM42",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        167,
        59,
        44
      ],
      "id": "DBM43",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        81,
        137,
        162
      ],
      "id": "DBM44",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        197,
        85,
        15
      ],
      "id": "DBM45",
      "t": "Orange, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        54,
        88,
        52
      ],
      "id": "DBM46",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        60,
        43,
        116
      ],
      "id": "DBM47",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        104,
        103,
        95
      ],
      "id": "DBM48",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        222,
        222,
        230
      ],
      "id": "DBM51",
      "t": "Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        241,
        219,
        206
      ],
      "id": "DBM52",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        243,
        207,
        110
      ],
      "id": "DBM53",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        178,
        113,
        94
      ],
      "id": "DBM54",
      "t": "Brown, Orange, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        229,
        194,
        222
      ],
      "id": "DBM55",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        121,
        89,
        121
      ],
      "id": "DBM56",
      "t": "Pink, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        86,
        167,
        202
      ],
      "id": "DBM57",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        91,
        122,
        144
      ],
      "id": "DBM58",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        87,
        94,
        120
      ],
      "id": "DBM59",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        85,
        119,
        106
      ],
      "id": "DBM60",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        146,
        61,
        88
      ],
      "id": "DBM62",
      "t": "Pink, Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        76,
        84,
        173
      ],
      "id": "DBM63",
      "t": "Blue, Purple, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        118,
        107,
        110
      ],
      "id": "DBM64",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        160,
        106,
        49
      ],
      "id": "DBM65",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        221,
        219,
        219
      ],
      "id": "DBM66",
      "t": "Crystal, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        215,
        125,
        134
      ],
      "id": "DBM70",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        64,
        139,
        142
      ],
      "id": "DBM79",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        170,
        208,
        224
      ],
      "id": "DBM83",
      "t": "Blue, Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        111,
        132,
        134
      ],
      "id": "DBM84",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        81,
        76,
        69
      ],
      "id": "DBM89",
      "t": "Green, Iridescent, Transparent",
      "dt": "Color-Lined, Rainbow, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        203,
        149,
        102
      ],
      "id": "DBM100",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        185,
        127,
        87
      ],
      "id": "DBM101",
      "t": "Brown, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        107,
        73,
        73
      ],
      "id": "DBM103",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        90,
        50,
        50
      ],
      "id": "DBM105",
      "t": "Purple, Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        207,
        130,
        129
      ],
      "id": "DBM106",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        132,
        128,
        134
      ],
      "id": "DBM107",
      "t": "Blue, Gray, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        113,
        74,
        78
      ],
      "id": "DBM108",
      "t": "Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        163,
        177,
        191
      ],
      "id": "DBM110",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        113,
        125,
        129
      ],
      "id": "DBM111",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        133,
        139,
        149
      ],
      "id": "DBM114",
      "t": "Gray, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        199,
        198,
        208
      ],
      "id": "DBM141",
      "t": "Crystal, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        123,
        74,
        45
      ],
      "id": "DBM144",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        198,
        178,
        70
      ],
      "id": "DBM145",
      "t": "Yellow, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        123,
        96,
        99
      ],
      "id": "DBM146",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        160,
        164,
        57
      ],
      "id": "DBM147",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        49,
        69,
        53
      ],
      "id": "DBM148",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        50,
        98,
        128
      ],
      "id": "DBM149",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        79,
        60,
        50
      ],
      "id": "DBM150",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        232,
        103,
        52
      ],
      "id": "DBM151",
      "t": "Orange, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        77,
        105,
        89
      ],
      "id": "DBM152",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        227,
        202,
        166
      ],
      "id": "DBM157",
      "t": "Beige, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        157,
        134,
        147
      ],
      "id": "DBM158",
      "t": "Purple, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        245,
        225,
        32
      ],
      "id": "DBM160",
      "t": "Yellow, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        243,
        92,
        90
      ],
      "id": "DBM161",
      "t": "Orange, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        173,
        58,
        85
      ],
      "id": "DBM162",
      "t": "Red, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        75,
        127,
        85
      ],
      "id": "DBM163",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        94,
        177,
        219
      ],
      "id": "DBM164",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        52,
        63,
        141
      ],
      "id": "DBM165",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        86,
        167,
        169
      ],
      "id": "DBM166",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        108,
        82,
        74
      ],
      "id": "DBM170",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        225,
        193,
        87
      ],
      "id": "DBM171",
      "t": "Yellow, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        173,
        39,
        59
      ],
      "id": "DBM172",
      "t": "Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        134,
        105,
        116
      ],
      "id": "DBM173",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        164,
        179,
        85
      ],
      "id": "DBM174",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        65,
        100,
        105
      ],
      "id": "DBM175",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        84,
        157,
        226
      ],
      "id": "DBM176",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        49,
        107,
        149
      ],
      "id": "DBM177",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        60,
        47,
        136
      ],
      "id": "DBM178",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        100,
        114,
        106
      ],
      "id": "DBM179",
      "t": "Gray, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        73,
        68,
        69
      ],
      "id": "DBM180",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        165,
        137,
        139
      ],
      "id": "DBM191",
      "t": "Pink, Alabaster",
      "dt": "Copperline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        247,
        244,
        250
      ],
      "id": "DBM200",
      "t": "White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        243,
        239,
        243
      ],
      "id": "DBM201",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        241,
        233,
        239
      ],
      "id": "DBM202",
      "t": "White, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        232,
        214,
        187
      ],
      "id": "DBM203",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        225,
        187,
        154
      ],
      "id": "DBM204",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        213,
        172,
        134
      ],
      "id": "DBM205",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        221,
        155,
        146
      ],
      "id": "DBM207",
      "t": "Pink, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        216,
        208,
        192
      ],
      "id": "DBM211",
      "t": "White, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        167,
        31,
        53
      ],
      "id": "DBM214",
      "t": "Red, Opaque",
      "dt": "Luster"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        49,
        40,
        132
      ],
      "id": "DBM216",
      "t": "Blue, Opaque",
      "dt": "Luster"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        87,
        148,
        169
      ],
      "id": "DBM217",
      "t": "Blue, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        212,
        205,
        201
      ],
      "id": "DBM221",
      "t": "Silver, Alabaster",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        226,
        222,
        224
      ],
      "id": "DBM222",
      "t": "Crystal, Alabaster",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        200,
        158,
        119
      ],
      "id": "DBM230",
      "t": "Gold, Alabaster",
      "dt": "Goldline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        236,
        235,
        245
      ],
      "id": "DBM231",
      "t": "White, Alabaster",
      "dt": "Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        238,
        224,
        148
      ],
      "id": "DBM232",
      "t": "Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        245,
        185,
        111
      ],
      "id": "DBM233",
      "t": "Orange, Yellow, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        239,
        200,
        203
      ],
      "id": "DBM234",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        230,
        117,
        112
      ],
      "id": "DBM235",
      "t": "Pink, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        116,
        192,
        166
      ],
      "id": "DBM237",
      "t": "Green, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        128,
        204,
        233
      ],
      "id": "DBM239",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        107,
        137,
        223
      ],
      "id": "DBM240",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        92,
        105,
        157
      ],
      "id": "DBM243",
      "t": "Blue, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        129,
        111,
        192
      ],
      "id": "DBM249",
      "t": "Purple, Alabaster",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        80,
        69,
        61
      ],
      "id": "DBM254",
      "t": "Brown, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        160,
        163,
        173
      ],
      "id": "DBM271",
      "t": "Gray, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        47,
        67,
        86
      ],
      "id": "DBM286",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        95,
        81,
        75
      ],
      "id": "DBM287",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        64,
        70,
        86
      ],
      "id": "DBM301",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        109,
        106,
        104
      ],
      "id": "DBM307",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        46,
        46,
        47
      ],
      "id": "DBM310",
      "t": "Black, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        85,
        66,
        63
      ],
      "id": "DBM312",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        127,
        119,
        115
      ],
      "id": "DBM321",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Nickel"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        107,
        86,
        70
      ],
      "id": "DBM322",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        71,
        64,
        75
      ],
      "id": "DBM323",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        85,
        101,
        104
      ],
      "id": "DBM324",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        68,
        73,
        90
      ],
      "id": "DBM325",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        64,
        82,
        66
      ],
      "id": "DBM327",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        201,
        157,
        106
      ],
      "id": "DBM331",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        244,
        241,
        250
      ],
      "id": "DBM351",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        234,
        218,
        189
      ],
      "id": "DBM352",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        95,
        96,
        163
      ],
      "id": "DBM361",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        173,
        56,
        89
      ],
      "id": "DBM362",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        87,
        108,
        101
      ],
      "id": "DBM373",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        105,
        118,
        146
      ],
      "id": "DBM376",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        140,
        119,
        108
      ],
      "id": "DBM380",
      "t": "Iridescent, Transparent",
      "dt": "Frosted (Matte), Glazed Luster, Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        188,
        137,
        83
      ],
      "id": "DBM410",
      "t": "Gold, Transparent",
      "dt": "Galvanized, Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        163,
        119,
        79
      ],
      "id": "DBM501",
      "t": "Gold, Iridescent, Opaque",
      "dt": "Plating, Rainbow, Gold"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        159,
        23,
        29
      ],
      "id": "DBM602",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        91,
        32,
        26
      ],
      "id": "DBM603",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        18,
        76,
        50
      ],
      "id": "DBM605",
      "t": "Green, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        33,
        56,
        75
      ],
      "id": "DBM608",
      "t": "Blue, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        63,
        47,
        97
      ],
      "id": "DBM610",
      "t": "Blue, Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        60,
        49,
        55
      ],
      "id": "DBM611",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        205,
        152,
        111
      ],
      "id": "DBM621",
      "t": "Gold, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        192,
        120,
        106
      ],
      "id": "DBM622",
      "t": "Orange, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        210,
        190,
        125
      ],
      "id": "DBM623",
      "t": "Yellow, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        208,
        163,
        179
      ],
      "id": "DBM624",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        207,
        118,
        149
      ],
      "id": "DBM625",
      "t": "Pink, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        101,
        156,
        189
      ],
      "id": "DBM628",
      "t": "Blue, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        164,
        136,
        186
      ],
      "id": "DBM629",
      "t": "Purple, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        130,
        124,
        126
      ],
      "id": "DBM630",
      "t": "Gray, Alabaster",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        245,
        245,
        250
      ],
      "id": "DBM635",
      "t": "White, Silk",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        235,
        234,
        239
      ],
      "id": "DBM670",
      "t": "White, Silk",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        214,
        193,
        170
      ],
      "id": "DBM673",
      "t": "White, Silk",
      "dt": "Glazed Luster"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        164,
        55,
        46
      ],
      "id": "DBM683",
      "t": "Red, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        100,
        98,
        154
      ],
      "id": "DBM694",
      "t": "Purple, Transparent",
      "dt": "Outside-Dyed, Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        199,
        122,
        40
      ],
      "id": "DBM702",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        232,
        97,
        14
      ],
      "id": "DBM703",
      "t": "Orange, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        179,
        7,
        13
      ],
      "id": "DBM704",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        11,
        81,
        38
      ],
      "id": "DBM705",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        38,
        138,
        213
      ],
      "id": "DBM706",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        47,
        8,
        129
      ],
      "id": "DBM707",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        67,
        69,
        70
      ],
      "id": "DBM708",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        86,
        36,
        24
      ],
      "id": "DBM709",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        223,
        186,
        21
      ],
      "id": "DBM710",
      "t": "Yellow, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        102,
        71,
        81
      ],
      "id": "DBM711",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        163,
        174,
        22
      ],
      "id": "DBM712",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        13,
        41,
        24
      ],
      "id": "DBM713",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        16,
        81,
        132
      ],
      "id": "DBM714",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        56,
        39,
        33
      ],
      "id": "DBM715",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        240,
        223,
        1
      ],
      "id": "DBM721",
      "t": "Yellow, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        250,
        94,
        11
      ],
      "id": "DBM722",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        182,
        4,
        27
      ],
      "id": "DBM723",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        84,
        131,
        77
      ],
      "id": "DBM724",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        84,
        178,
        221
      ],
      "id": "DBM725",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        53,
        43,
        141
      ],
      "id": "DBM726",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        156,
        128,
        144
      ],
      "id": "DBM728",
      "t": "Purple, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        75,
        168,
        170
      ],
      "id": "DBM729",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        235,
        210,
        183
      ],
      "id": "DBM732",
      "t": "Beige, White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        232,
        231,
        243
      ],
      "id": "DBM741",
      "t": "Crystal, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        243,
        241,
        251
      ],
      "id": "DBM851",
      "t": "Crystal, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        209,
        155,
        111
      ],
      "id": "DBM852",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        109,
        80,
        81
      ],
      "id": "DBM853",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        228,
        201,
        86
      ],
      "id": "DBM854",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        243,
        126,
        85
      ],
      "id": "DBM855",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        198,
        79,
        95
      ],
      "id": "DBM856",
      "t": "Pink, Red, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        131,
        116,
        137
      ],
      "id": "DBM857",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        85,
        132,
        116
      ],
      "id": "DBM858",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        74,
        106,
        111
      ],
      "id": "DBM859",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        179,
        191,
        102
      ],
      "id": "DBM860",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        99,
        163,
        223
      ],
      "id": "DBM861",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        61,
        117,
        162
      ],
      "id": "DBM862",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        116,
        116,
        134
      ],
      "id": "DBM863",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        99,
        98,
        163
      ],
      "id": "DBM864",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        96,
        85,
        89
      ],
      "id": "DBM865",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        109,
        95,
        107
      ],
      "id": "DBM869",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        252,
        118,
        93
      ],
      "id": "DBM872",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        184,
        94,
        115
      ],
      "id": "DBM874",
      "t": "Pink, Red, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        172,
        153,
        171
      ],
      "id": "DBM875",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        98,
        144,
        109
      ],
      "id": "DBM877",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        101,
        171,
        182
      ],
      "id": "DBM878",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        108,
        180,
        221
      ],
      "id": "DBM879",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        90,
        85,
        157
      ],
      "id": "DBM880",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        238,
        216,
        190
      ],
      "id": "DBM883",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        161,
        92,
        120
      ],
      "id": "DBM902",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        163,
        163,
        124
      ],
      "id": "DBM903",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        75,
        125,
        164
      ],
      "id": "DBM905",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        106,
        92,
        144
      ],
      "id": "DBM906",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        142,
        125,
        119
      ],
      "id": "DBM907",
      "t": "Gold, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        112,
        92,
        95
      ],
      "id": "DBM912",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        165,
        80,
        107
      ],
      "id": "DBM914",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        115,
        68,
        55
      ],
      "id": "DBM915",
      "t": "Brown, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        105,
        91,
        125
      ],
      "id": "DBM922",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        124,
        71,
        80
      ],
      "id": "DBM924",
      "t": "Red, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        64,
        44,
        51
      ],
      "id": "DBM1104",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        98,
        68,
        71
      ],
      "id": "DBM1204",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        106,
        83,
        93
      ],
      "id": "DBM1244",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        217,
        197,
        146
      ],
      "id": "DBM1831",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        218,
        201,
        164
      ],
      "id": "DBM1831F",
      "t": "Silver, White, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        200,
        153,
        81
      ],
      "id": "DBM1832",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        219,
        161,
        89
      ],
      "id": "DBM1832F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        182,
        124,
        50
      ],
      "id": "DBM1833",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        216,
        147,
        83
      ],
      "id": "DBM1833F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        164,
        124,
        84
      ],
      "id": "DBM1834",
      "t": "Gold, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        178,
        136,
        106
      ],
      "id": "DBM1834F",
      "t": "Brown, Gold, Transparent",
      "dt": "Duracoat, Frosted (Matte), Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        209,
        187,
        35
      ],
      "id": "DBM1835",
      "t": "Yellow, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        191,
        125,
        87
      ],
      "id": "DBM1836",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        166,
        76,
        64
      ],
      "id": "DBM1837",
      "t": "Orange, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        153,
        49,
        51
      ],
      "id": "DBM1838",
      "t": "Red, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        200,
        130,
        126
      ],
      "id": "DBM1839",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        174,
        89,
        134
      ],
      "id": "DBM1840",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        180,
        60,
        77
      ],
      "id": "DBM1841",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        126,
        68,
        64
      ],
      "id": "DBM1842",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        108,
        73,
        71
      ],
      "id": "DBM1843",
      "t": "Brown, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        146,
        204,
        156
      ],
      "id": "DBM1844",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        105,
        142,
        121
      ],
      "id": "DBM1845",
      "t": "Green, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        110,
        134,
        133
      ],
      "id": "DBM1846",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        34,
        120,
        124
      ],
      "id": "DBM1847",
      "t": "Blue, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        139,
        93,
        118
      ],
      "id": "DBM1848",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        145,
        71,
        93
      ],
      "id": "DBM1849",
      "t": "Pink, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        107,
        82,
        102
      ],
      "id": "DBM1850",
      "t": "Purple, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        172,
        163,
        144
      ],
      "id": "DBM1851",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        116,
        100,
        83
      ],
      "id": "DBM1852",
      "t": "Silver, Transparent",
      "dt": "Duracoat, Galvanized, Outside-Dyed, Duracoat Outside-Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        186,
        239,
        109
      ],
      "id": "DBM2031",
      "t": "Yellow, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        254,
        211,
        100
      ],
      "id": "DBM2032",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        253,
        179,
        107
      ],
      "id": "DBM2033",
      "t": "Orange, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        254,
        150,
        135
      ],
      "id": "DBM2034",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        251,
        58,
        173
      ],
      "id": "DBM2035",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        251,
        108,
        201
      ],
      "id": "DBM2036",
      "t": "Pink, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        201,
        115,
        188
      ],
      "id": "DBM2037",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 4,
      "c": [
        172,
        104,
        183
      ],
      "id": "DBM2038",
      "t": "Purple, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 5,
      "c": [
        87,
        167,
        218
      ],
      "id": "DBM2039",
      "t": "Blue, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 4,
      "b": 6,
      "c": [
        74,
        239,
        133
      ],
      "id": "DBM2040",
      "t": "Green, Transparent",
      "dt": "Color-Lined, Luster, Inside Dyed"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        60,
        64,
        73
      ],
      "id": "DBS1",
      "t": "Gray, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        57,
        58,
        61
      ],
      "id": "DBS2",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        60,
        54,
        62
      ],
      "id": "DBS4",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        64,
        67,
        78
      ],
      "id": "DBS5",
      "t": "Iridescent, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        59,
        58,
        64
      ],
      "id": "DBS7",
      "t": "Brown, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        41,
        41,
        41
      ],
      "id": "DBS10",
      "t": "Black, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        68,
        67,
        52
      ],
      "id": "DBS11",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        83,
        59,
        60
      ],
      "id": "DBS12",
      "t": "Purple, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        130,
        123,
        120
      ],
      "id": "DBS21",
      "t": "Silver, Opaque",
      "dt": "Plating, Nickel"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        92,
        74,
        65
      ],
      "id": "DBS22",
      "t": "Gold, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        104,
        79,
        60
      ],
      "id": "DBS22L",
      "t": "Gold, Transparent",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        92,
        73,
        67
      ],
      "id": "DBS23",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        52,
        66,
        59
      ],
      "id": "DBS27",
      "t": "Green, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        130,
        96,
        95
      ],
      "id": "DBS29",
      "t": "Iridescent, Opaque",
      "dt": "Plating, Rainbow, Nickel"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        197,
        160,
        103
      ],
      "id": "DBS31",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        171,
        127,
        86
      ],
      "id": "DBS33",
      "t": "Gold, Transparent",
      "dt": "Goldline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        175,
        154,
        122
      ],
      "id": "DBS34",
      "t": "Gold, Opaque",
      "dt": "Plating, Gold"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        155,
        120,
        112
      ],
      "id": "DBS37",
      "t": "Pink, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        149,
        147,
        145
      ],
      "id": "DBS38",
      "t": "Silver, Opaque",
      "dt": "Plating, Palladium"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        217,
        215,
        215
      ],
      "id": "DBS41",
      "t": "Silver, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        183,
        138,
        76
      ],
      "id": "DBS42",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        172,
        58,
        38
      ],
      "id": "DBS43",
      "t": "Red, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        124,
        161,
        178
      ],
      "id": "DBS44",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        215,
        135,
        26
      ],
      "id": "DBS45",
      "t": "Orange, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        60,
        115,
        66
      ],
      "id": "DBS46",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        65,
        59,
        142
      ],
      "id": "DBS47",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        115,
        115,
        106
      ],
      "id": "DBS48",
      "t": "Gray, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        226,
        224,
        230
      ],
      "id": "DBS50",
      "t": "Crystal, Transparent",
      "dt": "Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        233,
        235,
        245
      ],
      "id": "DBS51",
      "t": "Crystal, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        209,
        152,
        94
      ],
      "id": "DBS100",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        125,
        94,
        76
      ],
      "id": "DBS102",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        115,
        73,
        66
      ],
      "id": "DBS103",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        80,
        43,
        42
      ],
      "id": "DBS105",
      "t": "Purple, Red, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        205,
        131,
        127
      ],
      "id": "DBS106",
      "t": "Pink, Transparent",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        119,
        123,
        130
      ],
      "id": "DBS107",
      "t": "Blue, Gray, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        92,
        55,
        56
      ],
      "id": "DBS108",
      "t": "Purple, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        155,
        167,
        189
      ],
      "id": "DBS110",
      "t": "Blue, Transparent",
      "dt": "Glazed Luster, Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        149,
        155,
        163
      ],
      "id": "DBS114",
      "t": "Gray, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        120,
        86,
        67
      ],
      "id": "DBS115",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        82,
        55,
        67
      ],
      "id": "DBS117",
      "t": "Blue, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        132,
        84,
        49
      ],
      "id": "DBS118",
      "t": "Yellow, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        85,
        76,
        69
      ],
      "id": "DBS122",
      "t": "Brown, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        88,
        73,
        61
      ],
      "id": "DBS123",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        136,
        132,
        109
      ],
      "id": "DBS124",
      "t": "Green, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        79,
        93,
        87
      ],
      "id": "DBS125",
      "t": "Green, Transparent",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        98,
        72,
        75
      ],
      "id": "DBS129",
      "t": "Brown, Transparent",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        194,
        193,
        201
      ],
      "id": "DBS141",
      "t": "Crystal, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        129,
        79,
        26
      ],
      "id": "DBS144",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        185,
        162,
        74
      ],
      "id": "DBS145",
      "t": "Yellow, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        136,
        108,
        111
      ],
      "id": "DBS146",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        148,
        152,
        70
      ],
      "id": "DBS147",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        39,
        80,
        50
      ],
      "id": "DBS148",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        57,
        109,
        124
      ],
      "id": "DBS149",
      "t": "Blue, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        109,
        82,
        65
      ],
      "id": "DBS150",
      "t": "Brown, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        246,
        143,
        76
      ],
      "id": "DBS151",
      "t": "Orange, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        61,
        119,
        98
      ],
      "id": "DBS152",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        229,
        211,
        184
      ],
      "id": "DBS157",
      "t": "Beige, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        170,
        149,
        163
      ],
      "id": "DBS158",
      "t": "Purple, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        245,
        233,
        57
      ],
      "id": "DBS160",
      "t": "Yellow, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        244,
        107,
        68
      ],
      "id": "DBS161",
      "t": "Orange, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        179,
        29,
        56
      ],
      "id": "DBS162",
      "t": "Red, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        98,
        148,
        103
      ],
      "id": "DBS163",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        100,
        171,
        205
      ],
      "id": "DBS164",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        65,
        63,
        151
      ],
      "id": "DBS165",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        96,
        172,
        178
      ],
      "id": "DBS166",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        115,
        135,
        208
      ],
      "id": "DBS167",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        136,
        136,
        139
      ],
      "id": "DBS168",
      "t": "Gray, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        171,
        183,
        89
      ],
      "id": "DBS169",
      "t": "Green, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        126,
        85,
        78
      ],
      "id": "DBS170",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        220,
        187,
        106
      ],
      "id": "DBS171",
      "t": "Yellow, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        201,
        55,
        63
      ],
      "id": "DBS172",
      "t": "Red, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        132,
        114,
        130
      ],
      "id": "DBS173",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        166,
        185,
        85
      ],
      "id": "DBS174",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        30,
        93,
        78
      ],
      "id": "DBS175",
      "t": "Green, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        104,
        161,
        215
      ],
      "id": "DBS176",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        45,
        107,
        155
      ],
      "id": "DBS177",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        49,
        54,
        156
      ],
      "id": "DBS178",
      "t": "Blue, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        112,
        121,
        137
      ],
      "id": "DBS179",
      "t": "Gray, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        89,
        81,
        94
      ],
      "id": "DBS180",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        136,
        89,
        60
      ],
      "id": "DBS181",
      "t": "Brown, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        73,
        84,
        63
      ],
      "id": "DBS182",
      "t": "Green, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        43,
        41,
        82
      ],
      "id": "DBS183",
      "t": "Blue, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        90,
        73,
        67
      ],
      "id": "DBS184",
      "t": "Brown, Transparent",
      "dt": "Copperline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        176,
        141,
        138
      ],
      "id": "DBS191",
      "t": "Pink, Alabaster",
      "dt": "Copperline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        241,
        238,
        246
      ],
      "id": "DBS200",
      "t": "White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        236,
        235,
        241
      ],
      "id": "DBS201",
      "t": "White, Opaque",
      "dt": "Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        241,
        237,
        240
      ],
      "id": "DBS202",
      "t": "White, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        233,
        219,
        193
      ],
      "id": "DBS203",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        219,
        180,
        149
      ],
      "id": "DBS205",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        242,
        179,
        165
      ],
      "id": "DBS206",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        197,
        146,
        171
      ],
      "id": "DBS210",
      "t": "Pink, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        213,
        204,
        194
      ],
      "id": "DBS211",
      "t": "White, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        210,
        202,
        199
      ],
      "id": "DBS221",
      "t": "Silver, Alabaster",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        237,
        233,
        237
      ],
      "id": "DBS222",
      "t": "Crystal, Alabaster",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        189,
        149,
        114
      ],
      "id": "DBS230",
      "t": "Gold, Alabaster",
      "dt": "Goldline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        225,
        224,
        234
      ],
      "id": "DBS231",
      "t": "White, Alabaster",
      "dt": "Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        135,
        133,
        134
      ],
      "id": "DBS251",
      "t": "Gray, Opaque",
      "dt": "Gold Luster, Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        166,
        166,
        172
      ],
      "id": "DBS252",
      "t": "Gray, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        156,
        112,
        138
      ],
      "id": "DBS253",
      "t": "Pink, Purple, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        93,
        84,
        77
      ],
      "id": "DBS254",
      "t": "Brown, Opaque",
      "dt": "Gold Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        206,
        195,
        183
      ],
      "id": "DBS261",
      "t": "Beige, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        125,
        128,
        96
      ],
      "id": "DBS263",
      "t": "Green, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        87,
        117,
        126
      ],
      "id": "DBS264",
      "t": "Green, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        141,
        107,
        121
      ],
      "id": "DBS265",
      "t": "Purple, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        99,
        109,
        134
      ],
      "id": "DBS267",
      "t": "Blue, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        104,
        103,
        106
      ],
      "id": "DBS268",
      "t": "Gray, Opaque",
      "dt": "Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        87,
        93,
        107
      ],
      "id": "DBS301",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        104,
        105,
        111
      ],
      "id": "DBS307",
      "t": "Gray, Opaque",
      "dt": "Frosted (Matte), Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        50,
        49,
        49
      ],
      "id": "DBS310",
      "t": "Black, Opaque",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        93,
        76,
        87
      ],
      "id": "DBS312",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        152,
        143,
        142
      ],
      "id": "DBS321",
      "t": "Silver, Opaque",
      "dt": "Frosted (Matte), Plating, Nickel"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        114,
        95,
        83
      ],
      "id": "DBS322",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        80,
        93,
        95
      ],
      "id": "DBS324",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        66,
        78,
        91
      ],
      "id": "DBS325",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        213,
        169,
        123
      ],
      "id": "DBS331",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        190,
        160,
        133
      ],
      "id": "DBS334",
      "t": "Gold, Opaque",
      "dt": "Frosted (Matte), Plating, Gold"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        212,
        201,
        179
      ],
      "id": "DBS335",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Galvanized"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        148,
        142,
        140
      ],
      "id": "DBS338",
      "t": "Silver, Transparent",
      "dt": "Frosted (Matte), Plating, Palladium"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        134,
        98,
        92
      ],
      "id": "DBS340",
      "t": "Brown, Opaque",
      "dt": "Frosted (Matte), Plating, Copper"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        253,
        252,
        254
      ],
      "id": "DBS351",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        237,
        217,
        193
      ],
      "id": "DBS352",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        226,
        189,
        165
      ],
      "id": "DBS353",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        193,
        152,
        176
      ],
      "id": "DBS355",
      "t": "Pink, Purple, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        149,
        131,
        97
      ],
      "id": "DBS371",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Gold Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        123,
        143,
        135
      ],
      "id": "DBS374",
      "t": "Blue, Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        96,
        111,
        134
      ],
      "id": "DBS376",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Gold Luster, Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        145,
        56,
        58
      ],
      "id": "DBS378",
      "t": "Red, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        159,
        137,
        151
      ],
      "id": "DBS379",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Gold Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        120,
        102,
        96
      ],
      "id": "DBS380",
      "t": "Iridescent, Transparent",
      "dt": "Frosted (Matte), Glazed Luster, Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        87,
        78,
        87
      ],
      "id": "DBS386",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        70,
        76,
        82
      ],
      "id": "DBS387",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        207,
        163,
        133
      ],
      "id": "DBS389",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        141,
        124,
        96
      ],
      "id": "DBS390",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        112,
        114,
        84
      ],
      "id": "DBS391",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Glazed Luster"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        192,
        122,
        60
      ],
      "id": "DBS702",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        180,
        32,
        25
      ],
      "id": "DBS704",
      "t": "Red, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        37,
        90,
        56
      ],
      "id": "DBS705",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        75,
        144,
        205
      ],
      "id": "DBS706",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        53,
        34,
        125
      ],
      "id": "DBS707",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        88,
        93,
        97
      ],
      "id": "DBS708",
      "t": "Gray, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        112,
        66,
        43
      ],
      "id": "DBS709",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        221,
        172,
        39
      ],
      "id": "DBS710",
      "t": "Yellow, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        128,
        93,
        105
      ],
      "id": "DBS711",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        149,
        166,
        48
      ],
      "id": "DBS712",
      "t": "Green, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        12,
        81,
        133
      ],
      "id": "DBS714",
      "t": "Blue, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        66,
        48,
        40
      ],
      "id": "DBS715",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        250,
        230,
        2
      ],
      "id": "DBS721",
      "t": "Yellow, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        251,
        87,
        7
      ],
      "id": "DBS722",
      "t": "Orange, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        195,
        6,
        23
      ],
      "id": "DBS723",
      "t": "Red, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        84,
        137,
        75
      ],
      "id": "DBS724",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        106,
        181,
        214
      ],
      "id": "DBS725",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        58,
        53,
        150
      ],
      "id": "DBS726",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        169,
        142,
        159
      ],
      "id": "DBS728",
      "t": "Purple, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        81,
        168,
        175
      ],
      "id": "DBS729",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        116,
        136,
        214
      ],
      "id": "DBS730",
      "t": "Blue, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        236,
        215,
        181
      ],
      "id": "DBS732",
      "t": "Beige, White, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        178,
        193,
        98
      ],
      "id": "DBS733",
      "t": "Green, Opaque",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        236,
        235,
        247
      ],
      "id": "DBS851",
      "t": "Crystal, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        220,
        169,
        131
      ],
      "id": "DBS852",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        149,
        104,
        100
      ],
      "id": "DBS853",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        235,
        204,
        112
      ],
      "id": "DBS854",
      "t": "Yellow, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        252,
        143,
        88
      ],
      "id": "DBS855",
      "t": "Orange, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        213,
        84,
        103
      ],
      "id": "DBS856",
      "t": "Pink, Red, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        162,
        136,
        159
      ],
      "id": "DBS857",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        73,
        140,
        124
      ],
      "id": "DBS858",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        68,
        106,
        101
      ],
      "id": "DBS859",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        183,
        198,
        118
      ],
      "id": "DBS860",
      "t": "Green, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        123,
        175,
        226
      ],
      "id": "DBS861",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        62,
        127,
        182
      ],
      "id": "DBS862",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        127,
        134,
        149
      ],
      "id": "DBS863",
      "t": "Gray, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        94,
        100,
        182
      ],
      "id": "DBS864",
      "t": "Blue, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        114,
        101,
        113
      ],
      "id": "DBS865",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        176,
        115,
        104
      ],
      "id": "DBS866",
      "t": "Brown, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        233,
        201,
        204
      ],
      "id": "DBS868",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        119,
        103,
        121
      ],
      "id": "DBS869",
      "t": "Purple, Transparent",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        77,
        83,
        99
      ],
      "id": "DBS871",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        252,
        108,
        102
      ],
      "id": "DBS872",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        193,
        84,
        107
      ],
      "id": "DBS874",
      "t": "Pink, Red, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        180,
        157,
        175
      ],
      "id": "DBS875",
      "t": "Purple, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        105,
        154,
        126
      ],
      "id": "DBS877",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        102,
        181,
        195
      ],
      "id": "DBS878",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        126,
        190,
        227
      ],
      "id": "DBS879",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        99,
        97,
        171
      ],
      "id": "DBS880",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        133,
        152,
        226
      ],
      "id": "DBS881",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        240,
        221,
        195
      ],
      "id": "DBS883",
      "t": "White, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        126,
        94,
        105
      ],
      "id": "DBS1013",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        131,
        105,
        117
      ],
      "id": "DBS1014",
      "t": "Iridescent, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        146,
        90,
        101
      ],
      "id": "DBS1016",
      "t": "Red, Opaque",
      "dt": "Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        73,
        87,
        109
      ],
      "id": "DBS1052",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        96,
        95,
        105
      ],
      "id": "DBS1053",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        119,
        98,
        92
      ],
      "id": "DBS1055",
      "t": "Iridescent, Opaque",
      "dt": "Frosted (Matte), Metallic"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        151,
        80,
        24
      ],
      "id": "DBS1101",
      "t": "Brown, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        73,
        53,
        60
      ],
      "id": "DBS1104",
      "t": "Purple, Transparent",
      "dt": "Non-Extra Finish"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        163,
        109,
        41
      ],
      "id": "DBS1201",
      "t": "Gold, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        187,
        155,
        140
      ],
      "id": "DBS1203",
      "t": "Pink, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        104,
        80,
        84
      ],
      "id": "DBS1204",
      "t": "Purple, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        140,
        166,
        87
      ],
      "id": "DBS1206",
      "t": "Green, Transparent",
      "dt": "Silverline"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        161,
        98,
        79
      ],
      "id": "DBS1241",
      "t": "Brown, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        227,
        183,
        180
      ],
      "id": "DBS1243",
      "t": "Pink, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 6,
      "c": [
        110,
        92,
        107
      ],
      "id": "DBS1244",
      "t": "Purple, Transparent",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        234,
        187,
        180
      ],
      "id": "DBS1263",
      "t": "Pink, Transparent",
      "dt": "Frosted (Matte)"
    },
    {
      "a": 6,
      "b": 5,
      "c": [
        81,
        89,
        192
      ],
      "id": "DBS1578",
      "t": "Blue, Opaque",
      "dt": "Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        234,
        200,
        161
      ],
      "id": "DBS1591",
      "t": "Beige, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        251,
        136,
        86
      ],
      "id": "DBS1593",
      "t": "Orange, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        121,
        190,
        205
      ],
      "id": "DBS1595",
      "t": "Green, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    },
    {
      "a": 6,
      "b": 4,
      "c": [
        107,
        110,
        202
      ],
      "id": "DBS1597",
      "t": "Blue, Opaque",
      "dt": "Frosted (Matte), Rainbow"
    }
  ];